// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'http://localhost:8080/api/v1' | 'https://dream-studio.moondust.media/api/v1' | (string & {});
};

export type Error = {
    /**
     * Error message
     */
    message: string;
    /**
     * Machine-readable error kind emitted by the API runtime
     */
    kind?: string;
};

export type BaseEntity = {
    /**
     * Unique entity ID
     */
    id: string;
    /**
     * Creation timestamp (Unix timestamp)
     */
    create_ts: number;
    /**
     * Last update timestamp (Unix timestamp)
     */
    update_ts: number;
};

/**
 * Role for organization/project membership
 */
export const Role = {
    PERSONAL: 'personal',
    OWNER: 'owner',
    ADMIN: 'admin',
    MEMBER: 'member',
    VIEWER: 'viewer'
} as const;

/**
 * Role for organization/project membership
 */
export type Role = typeof Role[keyof typeof Role];

/**
 * Domain resource namespace, mirrors the backend domain Resource type.
 */
export const ResourceType = {
    AI_PERSONA: 'ai-persona',
    BLOB: 'blob',
    BUNDLE: 'bundle',
    BUNDLE_DEPLOYMENT: 'bundle.deployment',
    BUNDLE_ENVIRONMENT: 'bundle.environment',
    BUNDLE_SOURCE: 'bundle.source',
    CHAT: 'chat',
    CHAT_BRANCH: 'chat.branch',
    CHAT_MSG: 'chat.msg',
    CHAT_STREAM_EVENT: 'chat.stream_event',
    EDIT_SESSION: 'edit_session',
    EDIT_SESSION_CONTENT: 'edit_session.content',
    EDIT_SESSION_THREAD: 'edit_session.thread',
    EDIT_SESSION_THREAD_CONTENT: 'edit_session.thread.content',
    FS_WORK: 'fs.work',
    ORG: 'org',
    ORG_PROJECT: 'org.project',
    ORG_PROJECT_CONTENT: 'org.project.content',
    PROJECT_COPY_OPERATION: 'project.copy_operation',
    PRESENCE: 'presence',
    PRESENCE_POINTER: 'presence.pointer',
    PROBLEMS: 'problems',
    SYSTEM: 'system',
    TREEVIEW: 'treeview',
    UI_INTENT: 'ui.intent',
    USER: 'user'
} as const;

/**
 * Domain resource namespace, mirrors the backend domain Resource type.
 */
export type ResourceType = typeof ResourceType[keyof typeof ResourceType];

/**
 * Type of resource for membership/invitation filtering (organization or project)
 */
export const MembershipResourceType = { ORGANIZATION: 'organization', PROJECT: 'project' } as const;

/**
 * Type of resource for membership/invitation filtering (organization or project)
 */
export type MembershipResourceType = typeof MembershipResourceType[keyof typeof MembershipResourceType];

/**
 * Status of an entity (user, organization, membership)
 */
export const EntityStatus = { ACTIVE: 'active', INACTIVE: 'inactive' } as const;

/**
 * Status of an entity (user, organization, membership)
 */
export type EntityStatus = typeof EntityStatus[keyof typeof EntityStatus];

/**
 * Status of an invitation
 */
export const InvitationStatus = {
    PENDING: 'pending',
    ACCEPTED: 'accepted',
    DECLINED: 'declined'
} as const;

/**
 * Status of an invitation
 */
export type InvitationStatus = typeof InvitationStatus[keyof typeof InvitationStatus];

/**
 * Base schema for all paginated list responses. Contains pagination metadata
 * for bidirectional navigation through result sets.
 *
 */
export type ListResponseBase = {
    pagination: PaginationInfo;
};

/**
 * Pagination metadata for bidirectional navigation.
 *
 * Use `previous_cursor` to load the previous page and `next_cursor` to load the next page.
 * A null cursor indicates you've reached that boundary of the result set.
 *
 * Items are returned in chronological order by `create_ts` (oldest first) unless
 * the endpoint documentation specifies a different ordering.
 *
 */
export type PaginationInfo = {
    /**
     * Cursor to fetch the previous page of items.
     * Null when at the beginning of the result set.
     * Pass this value as the `cursor` parameter to load the previous page.
     *
     */
    previous_cursor?: string | null;
    /**
     * Cursor to fetch the next page of items.
     * Null when at the end of the result set.
     * Pass this value as the `cursor` parameter to load the next page.
     *
     */
    next_cursor?: string | null;
};

/**
 * Optional source path for the initial private workspace snapshot.
 */
export type BeginWorkspaceTransactionRequest = {
    /**
     * Relative path in the caller's ArtifactFS scope. Omit or set null to start empty.
     */
    source_path?: string | null;
    /**
     * Optional transaction lifetime in seconds. Omit to use the configured default; explicit values are bounded to seven days.
     */
    expire_after_seconds?: number;
};

export type WorkspaceTransaction = {
    id: string;
    scope_type: 'project' | 'edit_session' | 'thread';
    project_id?: string;
    edit_session_id?: string | null;
    thread_id?: string | null;
    /**
     * Initial path relative to the caller's ArtifactFS scope, or null when started empty.
     */
    source_path?: string | null;
    state: WorkspaceTransactionState;
    /**
     * Creation time as a Unix timestamp.
     */
    create_ts: number;
    /**
     * Expiration time as a Unix timestamp.
     */
    expires_ts: number;
    /**
     * Last accepted patch or explicit activity time as RFC 3339 with nanosecond precision.
     */
    activity_ts: string;
};

export const WorkspaceTransactionState = {
    OPEN: 'open',
    PROMOTING: 'promoting',
    PROMOTED: 'promoted',
    ABORTED: 'aborted',
    EXPIRED: 'expired',
    FAILED: 'failed'
} as const;

export type WorkspaceTransactionState = typeof WorkspaceTransactionState[keyof typeof WorkspaceTransactionState];

export type WorkspaceTransactionEntries = {
    entries: Array<WorkspaceTransactionEntry>;
};

export type WorkspaceTransactionEntry = {
    /**
     * Relative path within the transaction root.
     */
    path: string;
    kind: 'file' | 'directory';
    /**
     * Size in bytes for regular files, or null for directories.
     */
    size?: number | null;
    /**
     * SHA-256 for a regular file when requested; otherwise null or omitted.
     */
    sha256?: string | null;
};

export type WorkspacePatchResult = {
    applied: true;
    changed_paths: Array<string>;
};

export type WorkspacePatchConflictResponse = {
    kind: 'patch_conflict' | 'invalid_patch';
    message: string;
    conflicts: Array<WorkspacePatchConflict>;
};

export type WorkspacePatchConflict = {
    path: string;
    hunk_header?: string | null;
    reason: 'hunk_context_mismatch' | 'malformed_diff' | 'unsupported_binary' | 'unsupported_mode' | 'unsupported_path' | 'non_text_file' | 'missing_file' | 'duplicate_path';
};

export type PromoteWorkspaceTransactionRequest = {
    /**
     * Destination path relative to the caller's ArtifactFS scope.
     */
    destination_path: string;
    collision_policy: 'require_not_exist' | 'override';
    /**
     * Promote only if transaction activity still matches this RFC 3339 value, including nanoseconds.
     */
    expected_activity_ts?: string;
};

export type WorkspacePromotionResult = {
    transaction_id: string;
    destination_path: string;
    state: 'promoted';
};

/**
 * Metadata for a single artifact file system entry.
 */
export type ArtifactEntry = {
    /**
     * Relative path within the artifact workspace
     */
    path: string;
    /**
     * Name of the file or directory
     */
    name: string;
    /**
     * True if entry is a directory
     */
    is_dir: boolean;
    /**
     * MIME type for file entries, if available
     */
    mime_type?: string;
    /**
     * Size in bytes, null for directories
     */
    size?: number | null;
    /**
     * Last update timestamp (Unix timestamp), null if not available
     */
    update_ts?: number | null;
};

/**
 * Response containing the target artifact entry and its contents if it is a directory.
 */
export type ArtifactListResponse = {
    entry: ArtifactEntry;
    content?: Array<ArtifactEntry>;
};

export type ArtifactSearchMatch = {
    entry: ArtifactEntry;
    matches: Array<string>;
};

export type AiPersona = BaseEntity & {
    /**
     * A detailed description of the AI persona's characteristics and purpose
     */
    description: string;
    /**
     * The full name of the AI persona
     */
    name: string;
    /**
     * A friendly nickname for the persona that can be used when addressing them. It must be unique across all personas.
     */
    nickname: string;
    /**
     * Guides the tone of the agent
     */
    age: number;
    /**
     * The professional role or position of the AI persona
     */
    role: string;
    /**
     * The primary goal or objective of the AI persona
     */
    purpose?: string;
    /**
     * Description of the AI persona's personality traits
     */
    personality?: string;
    /**
     * Direct the AIPersona to follow these instructions explicitly
     */
    instructions?: string;
    /**
     * URL path to the persona's avatar image, typically one of the static files served under /assets/
     */
    avatar?: string;
    /**
     * Set by the list endpoint: whether this is the persona that answers when a message
     * mentions no persona and none has answered in the branch yet.
     *
     */
    is_default?: boolean;
    llm_parameters: LlmParameters;
};

/**
 * Data structure for creating a new AI persona, containing all required fields for persona initialization
 */
export type AiPersonaCreate = {
    /**
     * The full name of the AI persona
     */
    name: string;
    /**
     * A friendly nickname for the persona that can be used when addressing them.
     */
    nickname: string;
    /**
     * Guides the tone of the agent
     */
    age: number;
    /**
     * A detailed description of the AI persona's characteristics and purpose
     */
    description: string;
    /**
     * The professional role or position of the AI persona
     */
    role: string;
    /**
     * The primary goal or objective of the AI persona
     */
    purpose?: string;
    /**
     * Description of the AI persona's personality traits
     */
    personality?: string;
    /**
     * Direct the AIPersona to follow these instructions explicitly
     */
    instructions?: string;
    /**
     * URL path to the persona's avatar image, typically one of the static files served under /assets/
     */
    avatar?: string;
    llm_parameters: LlmParameters;
};

/**
 * Data structure for updating an existing AI persona, containing optional fields that can be modified
 */
export type AiPersonaUpdate = {
    /**
     * The full name of the AI persona
     */
    name?: string;
    /**
     * A friendly nickname for the persona that can be used when addressing them.
     */
    nickname?: string;
    /**
     * Guides the tone of the agent
     */
    age?: number;
    /**
     * A detailed description of the AI persona's characteristics and purpose
     */
    description?: string;
    /**
     * The professional role or position of the AI persona
     */
    role?: string;
    /**
     * The primary goal or objective of the AI persona
     */
    purpose?: string;
    /**
     * Description of the AI persona's personality traits
     */
    personality?: string;
    /**
     * The system prompt that defines the AI persona's behavior
     */
    prompt?: string;
    /**
     * URL path to the persona's avatar image, typically one of the static files served under /assets/
     */
    avatar?: string;
    llm_parameters?: LlmParameters;
};

/**
 * Request payload to stop an in-flight AI persona answer generation.
 */
export type StopAiPersonaAnswerRequest = {
    /**
     * The branch containing the target reply message.
     */
    branch_id: string;
    /**
     * The target AI reply message currently being generated.
     */
    message_id: string;
};

/**
 * Configuration parameters for the language model used by an AI persona
 */
export type LlmParameters = {
    /**
     * The LLM model to use for this persona in the format <provider>:<model_name>
     */
    model: string;
    /**
     * Controls randomness in the output (0 = deterministic, 2 = very random)
     */
    temperature?: number;
    /**
     * Maximum number of tokens to generate
     */
    max_tokens?: number;
    /**
     * Level of reasoning effort for the model
     */
    reasoning_effort?: 'minimal' | 'low' | 'medium' | 'high' | 'false';
    /**
     * Whether to enable tool usage for this persona
     */
    use_tools?: boolean;
    /**
     * Whether to enable bubble replay for this persona. Bubble replay is enabled by default; omitting this field enables it. Set to false to opt this persona out.
     */
    bubble_enabled?: boolean;
    /**
     * Whether to enable low-latency / accelerated generation mode for this persona
     */
    fast?: boolean;
    read_budget?: ReadBudget;
};

/**
 * The byte/line budget settings for the unified read tool. If a field is omitted or explicitly set to 0, it will fall back to its system default value.
 */
export type ReadBudget = {
    /**
     * Bounds an open read (no line fragment, or an open-ended "#L<start>-" continuation). A value of 0 falls back to the default (32 KiB / 32768 bytes).
     */
    page_bytes?: number;
    /**
     * Bounds the line count of an open read (no line fragment, or an open-ended "#L<start>-" continuation). A value of 0 falls back to the default (2000 lines).
     */
    page_lines?: number;
    /**
     * Bounds explicit closed #L<a>-L<b> selections (including a single-line #L<n> selection) and must be >= page_bytes. Does not apply to open-ended "#L<start>-" reads. A value of 0 falls back to the default (96 KiB / 98304 bytes).
     */
    ranged_ceiling_bytes?: number;
    /**
     * Bounds the line count of a closed #L<a>-L<b> selection (including a single-line #L<n> selection) and must be >= page_lines. Does not apply to open-ended "#L<start>-" reads. A value of 0 falls back to the default (4000 lines).
     */
    ranged_max_lines?: number;
};

/**
 * Normalized token usage buckets for LLM executions. Total counts include their respective sub-buckets (e.g., input_tokens includes cache tokens).
 */
export type TokenUsage = {
    /**
     * Total input tokens sent to the model, including cached tokens. Base input cost = input_tokens - (cache_read_tokens + cache_write_tokens).
     */
    input_tokens: number;
    /**
     * Total output tokens generated by the model, including reasoning tokens. Base output cost = output_tokens - reasoning_tokens.
     */
    output_tokens: number;
    /**
     * Input tokens read from the provider cache (included in input_tokens).
     */
    cache_read_tokens: number;
    /**
     * Input tokens written to the provider cache (included in input_tokens).
     */
    cache_write_tokens: number;
    /**
     * Output tokens used for reasoning or internal thinking (included in output_tokens).
     */
    reasoning_tokens: number;
};

/**
 * Execution info for LLM-generated content
 */
export type LlmExecution = {
    type: 'llm';
    /**
     * LLM provider (e.g., openai, anthropic)
     */
    provider: string;
    /**
     * Model identifier
     */
    model: string;
    token_usage: TokenUsage;
    /**
     * Provider cost (COGS) in micro-USD (1 USD = 1_000_000 micro-USD), for development.
     * Absent in production; show Dream Bucks from the chat branch usage summary instead.
     *
     */
    cost_micro_usd?: number;
    /**
     * Execution duration in seconds with sub-second precision
     */
    duration: number;
};

/**
 * Execution info for API-generated content
 */
export type ApiExecution = {
    type: 'api';
    /**
     * API provider
     */
    provider: string;
    /**
     * Service name
     */
    service: string;
    /**
     * API endpoint
     */
    endpoint: string;
    /**
     * Provider cost (COGS) in micro-USD (1 USD = 1_000_000 micro-USD), for development.
     * Absent in production.
     *
     */
    cost_micro_usd?: number;
    /**
     * Execution duration in seconds with sub-second precision
     */
    duration: number;
};

/**
 * Execution info for work performed within DreamStudio
 */
export type InAppExecution = {
    type: 'in_app';
    /**
     * Execution duration in seconds with sub-second precision
     */
    duration: number;
};

/**
 * Tracks resources consumed during content generation. Discriminated by 'type' field.
 *
 */
export type ExecutionInfo = ({
    type: 'llm';
} & LlmExecution) | ({
    type: 'api';
} & ApiExecution) | ({
    type: 'in_app';
} & InAppExecution);

/**
 * The type of sender:
 * - 'human' for human participants
 * - 'ai-persona' for AI responses
 * - 'system' for automated system messages
 *
 */
export const SenderType = {
    HUMAN: 'human',
    AI_PERSONA: 'ai-persona',
    SYSTEM: 'system'
} as const;

/**
 * The type of sender:
 * - 'human' for human participants
 * - 'ai-persona' for AI responses
 * - 'system' for automated system messages
 *
 */
export type SenderType = typeof SenderType[keyof typeof SenderType];

export type ChatMessageMention = {
    type: SenderType;
    /**
     * UUID of the referenced entity
     */
    id: string;
};

/**
 * Text content supporting markdown and plain text variants
 */
export type ContentBlockText = {
    type: 'text';
    /**
     * The text content to display
     */
    content: string;
    /**
     * Semantic styling hint for the text:
     * - markdown: Rich text with markdown formatting (default)
     * - plain: Plain text with no special rendering
     *
     */
    variant?: 'markdown' | 'plain';
    execution_info?: ExecutionInfo;
    /**
     * Map of local IDs (1-3 digits) to mention details
     */
    mentions?: {
        [key: string]: ChatMessageMention;
    };
};

/**
 * Styling variant for a collapsible section:
 * - default: Standard collapsible styling (default)
 * - secondary: More subtle styling for nested collapsibles
 * - warning: Attention styling for cautionary content
 * - error: Error styling for failures and critical issues
 *
 */
export const ContentBlockCollapsibleVariant = {
    DEFAULT: 'default',
    SECONDARY: 'secondary',
    WARNING: 'warning',
    ERROR: 'error'
} as const;

/**
 * Styling variant for a collapsible section:
 * - default: Standard collapsible styling (default)
 * - secondary: More subtle styling for nested collapsibles
 * - warning: Attention styling for cautionary content
 * - error: Error styling for failures and critical issues
 *
 */
export type ContentBlockCollapsibleVariant = typeof ContentBlockCollapsibleVariant[keyof typeof ContentBlockCollapsibleVariant];

/**
 * A content block within a chat message. Each block is identified by its `type` and may
 * include `execution_info` describing the resources used to produce it.
 *
 */
export type ChatMessageContentItem = ({
    type: 'text';
} & ContentBlockText) | ({
    type: 'collapsible';
} & ContentBlockCollapsible) | ({
    type: 'button';
} & ContentBlockButton) | ({
    type: 'prompt';
} & ContentBlockPrompt) | ({
    type: 'question_set';
} & ContentBlockQuestionSet) | ({
    type: 'binary';
} & ContentBlockBinary);

/**
 * Expandable section with optional icon for organizing complex content
 */
export type ContentBlockCollapsible = {
    type: 'collapsible';
    /**
     * Section header text
     */
    title: string;
    /**
     * Optional lucide-compatible icon name
     */
    icon?: string;
    variant?: ContentBlockCollapsibleVariant;
    /**
     * Whether the section is still streaming and more content is expected
     */
    pending?: boolean;
    /**
     * Whether the section starts collapsed
     */
    initially_collapsed?: boolean;
    /**
     * Array of nested content blocks
     */
    content: Array<ChatMessageContentItem>;
    execution_info?: ExecutionInfo;
};

/**
 * Tracks when a button was clicked by the user
 */
export type ButtonInteraction = {
    /**
     * Timestamp when the button was clicked
     */
    create_ts: number;
};

/**
 * Interactive button that triggers actions with optional confirmation
 */
export type ContentBlockButton = {
    type: 'button';
    /**
     * Action identifier to trigger
     */
    action: string;
    /**
     * Button display text
     */
    label: string;
    /**
     * Button styling variant:
     * - primary: Primary action styling (default)
     * - secondary: Secondary action styling
     * - destructive: Destructive action with warning styling
     * - checkpoint: Checkpoint/restore styling
     *
     */
    variant?: 'primary' | 'secondary' | 'destructive' | 'checkpoint';
    /**
     * Optional confirmation dialog text shown before action execution
     */
    confirmation?: string;
    interaction?: ButtonInteraction;
    execution_info?: ExecutionInfo;
};

/**
 * Optional media preview rendered alongside a prompt option
 */
export type PromptOptionPreview = {
    /**
     * Blob reference for the preview content
     */
    ref: string;
    /**
     * Optional MIME type hint used while the preview metadata loads
     */
    content_type?: string;
};

/**
 * A selectable option in a prompt
 */
export type PromptOption = {
    /**
     * Display text for the option
     */
    label: string;
    /**
     * Value returned when this option is selected
     */
    value: string;
    /**
     * Optional supporting text for the option
     */
    description?: string;
    preview?: PromptOptionPreview;
};

/**
 * Tracks user's response to a prompt
 */
export type PromptInteraction = {
    selected: string | Array<string>;
    /**
     * Timestamp when the prompt was answered
     */
    create_ts: number;
};

/**
 * Single or multiple choice question for user input
 */
export type ContentBlockPrompt = {
    type: 'prompt';
    /**
     * Optional stable identifier for an agent-authored question
     */
    id?: string;
    /**
     * Question text
     */
    prompt: string;
    /**
     * Whether multiple options can be selected
     */
    multiple_choice?: boolean;
    /**
     * Optional label for the question confirmation button
     */
    submit_label?: string;
    /**
     * Array of selectable options
     */
    options: Array<PromptOption>;
    interaction?: PromptInteraction;
    execution_info?: ExecutionInfo;
};

export type QuestionSetQuestion = {
    id: string;
    title?: string;
    question: string;
    options: Array<PromptOption>;
    recommended_value?: string;
    allow_custom: boolean;
};

/**
 * Exactly one of value or text must be supplied.
 */
export type QuestionSetAnswer = {
    question_id: string;
    value?: string;
    text?: string;
};

export type QuestionSetInteraction = {
    answers: Array<QuestionSetAnswer>;
    create_ts: number;
    responder_id: string;
};

/**
 * A set of independent single-answer questions submitted atomically
 */
export type ContentBlockQuestionSet = {
    type: 'question_set';
    id: string;
    title?: string;
    submit_label?: string;
    questions: Array<QuestionSetQuestion>;
    interaction?: QuestionSetInteraction;
    superseded_by?: string;
    execution_info?: ExecutionInfo;
};

/**
 * File attachments, images, videos with preview support
 */
export type ContentBlockBinary = {
    type: 'binary';
    /**
     * MIME type of the content
     */
    content_type: string;
    /**
     * HTTP/HTTPS URL or data URL for the content
     */
    url: string;
    /**
     * Optional HTTP/HTTPS URL or data URL for preview/thumbnail
     */
    preview_url?: string;
    /**
     * Optional name or filename of the content
     */
    name?: string;
    /**
     * Optional size of the content in bytes
     */
    size?: number;
    execution_info?: ExecutionInfo;
};

export const ChatMessageStatus = {
    COMPLETE: 'complete',
    PENDING: 'pending',
    STOPPING: 'stopping',
    STOPPED: 'stopped',
    ERROR: 'error'
} as const;

export type ChatMessageStatus = typeof ChatMessageStatus[keyof typeof ChatMessageStatus];

/**
 * A billing payer, addressed by its billing routes.
 */
export type BillingPayer = {
    /**
     * `org`: the organization's billing (`/organizations/{id}/billing/…`); `user`: the user's
     * own billing (`/users/{id}/billing/…`).
     *
     */
    type: 'org' | 'user';
    /**
     * Organization ID or user ID.
     */
    id: string;
};

/**
 * Reference to external content attached to a message.
 */
export type Attachment = {
    /**
     * The URI identifying the attachment resource. Supported schemes:
     * - `ref:https://...` or `ref:http://...` for web links
     * - `ref:file:///...` for a full file reference.
     * - `ref:file:///...#L31` for a single line from a file
     * - `ref:file:///...#L31-L40` for a file line range
     * - `ref:file:///...#/characters/peter/bio` for a structured value selected by JSON Pointer
     * - `ref:file:///...#/characters/peter/bio;L31` for a structured text value with a single highlighted line
     * - `ref:file:///...#/characters/peter/bio;L31-L40` for a structured text value with a line range
     * - `ref:fileid://<file-id>#L31` for a single line from a file resolved by file id
     * - `ref:fileid://<file-id>#L31-L40` for a file line range resolved by file id
     * - `ref:fileid://<file-id>#/characters/peter/bio` for a structured value selected by JSON Pointer in a file resolved by id
     * - `ref:fileid://<file-id>#/characters/peter/bio;L31` for a structured text value with a single highlighted line in a file resolved by id
     * - `ref:fileid://<file-id>#/characters/peter/bio;L31-L40` for a structured text value with a line range in a file resolved by id
     * - `ref:blob://...` for uploaded blobs
     *
     */
    uri: string;
    /**
     * Optional descriptive label for the attachment.
     */
    label?: string;
    /**
     * Optional attachment metadata supplied by the client.
     * Use `current_view_focus: true` to tell the backend that the user is currently looking at this attachment. That flag is used to bias the LLM request.
     *
     */
    metadata?: {
        [key: string]: unknown;
    };
};

/**
 * Model and/or reasoning effort to use for the answer to this message instead of the
 * answering persona's own settings. `model` must be one of `GET /llm-model-options`, and
 * `reasoning_effort` one of that model's levels. Omitted model keeps the persona's model,
 * with `reasoning_effort` clamped to its levels; omitted effort keeps the persona's effort,
 * clamped to the model's levels.
 *
 */
export type LlmOverride = {
    model?: string;
    reasoning_effort?: string;
};

export type ChatMessage = BaseEntity & {
    /**
     * The ID of the chat branch this message belongs to
     */
    chat_branch_id: string;
    /**
     * The message content as an array of content items
     */
    content: Array<ChatMessageContentItem>;
    /**
     * The ID of the message sender
     */
    sender: string;
    sender_type: SenderType;
    /**
     * Array of branch IDs that this message appears in
     */
    in_branches: Array<string>;
    status: ChatMessageStatus;
    /**
     * Machine-readable cause, present only when `status` is `error` and the cause is known.
     * Billing refusals carry the billing error code verbatim:
     * `BALANCE_EXHAUSTED`, `BILLING_NOT_PROVISIONED` and `USAGE_LIMIT_REACHED` end the
     * turn without retry or continue controls (retrying cannot succeed until billing
     * changes); `BILLING_PROVIDER_UNAVAILABLE` keeps them. Clients must tolerate
     * values they do not recognize.
     *
     */
    error_kind?: string;
    error_payer?: BillingPayer;
    /**
     * Unix timestamp when the current run started (null if the message never ran)
     */
    start_ts?: number;
    /**
     * Unix timestamp of the latest terminal transition (null while running or never run)
     */
    complete_ts?: number;
    /**
     * Attachments associated with this message
     */
    attachments: Array<Attachment>;
    llm_override?: LlmOverride;
};

export type User = BaseEntity & {
    /**
     * User email
     */
    email: string;
    /**
     * User name
     */
    name: string;
    /**
     * User nickname
     */
    nickname: string;
    /**
     * Optional short-lived signed avatar URL. Not populated when a user is embedded in a membership or invitation response; use /users/{id}/avatar to resolve it.
     */
    avatar_url?: string;
    status: EntityStatus;
};

export type LoginResponse = {
    /**
     * JWT access token
     */
    access_token: string;
    /**
     * JWT refresh token
     */
    refresh_token: string;
    user: User;
};

export type BrowserLoginResponse = {
    user: User;
};

export type TokenResponse = {
    /**
     * New JWT access token
     */
    access_token: string;
    /**
     * New JWT refresh token
     */
    refresh_token: string;
};

/**
 * RFC 8628 section 3.2
 */
export type DeviceAuthorizationResponse = {
    device_code: string;
    user_code: string;
    verification_uri: string;
    /**
     * The approval page with the user code filled in
     */
    verification_uri_complete: string;
    expires_in: number;
    interval: number;
};

export type PendingDeviceAuthorization = {
    user_code: string;
    name: string;
    expires_ts: string;
};

/**
 * RFC 6749 section 5.1
 */
export type OAuthTokenResponse = {
    access_token: string;
    /**
     * Always "Bearer"
     */
    token_type: string;
    expires_in: number;
    /**
     * JWT refresh token, as from `/auth/refresh`
     */
    refresh_token: string;
};

/**
 * RFC 6749 section 5.2
 */
export type OAuthError = {
    error: string;
    error_description?: string;
};

export type ExternalAuthCodeResponse = {
    /**
     * Single-use opaque authcode; return it once to the caller
     */
    authcode: string;
    /**
     * UTC timestamp when the authcode expires (ISO 8601)
     */
    expires_at: string;
};

export type ExternalIdTokenResponse = {
    /**
     * Short-lived identity proof for the user; not a DreamStudio access token
     */
    id_token: string;
    /**
     * Always "Bearer"
     */
    token_type: string;
    /**
     * Seconds until the identity token expires
     */
    expires_in: number;
    /**
     * External service audience from the authcode
     */
    aud: string;
    /**
     * Project bound to the authcode when it was minted; absent when none was bound.
     */
    project_id?: string;
    /**
     * Organization of the bound project, resolved when the authcode was minted; present exactly when `project_id` is.
     */
    org_id?: string;
};

export type AuthorizationGrant = {
    permission: string;
    type: string;
    resource: string;
};

export type CapabilityTokenRequest = {
    audience: string;
    grants: Array<AuthorizationGrant>;
    extra_claims?: {
        [key: string]: unknown;
    };
    expire_after_seconds?: number;
};

export type CapabilityTokenResponse = {
    /**
     * Signed capability JWT
     */
    token: string;
    expire_ts?: string;
};

export type AuthzCheckRequest = {
    checks: Array<AuthzCheckInput>;
};

export type AuthzCheckInput = {
    /**
     * Permission strings as declared by OpenAPI operation security scopes.
     */
    permissions: Array<string>;
    resource: AuthzCheckResource;
};

export type AuthzCheckResource = {
    type: ResourceType;
    /**
     * Concrete identifier for the resource instance to authorize.
     */
    id: string;
};

export type AuthzCheckResponse = {
    results: Array<AuthzCheckResult>;
};

export type AuthzCheckResult = {
    permissions: Array<string>;
    resource: AuthzCheckResource;
    /**
     * Authorization decisions aligned by index with the permissions array.
     */
    allowed: Array<boolean>;
};

/**
 * A billing refusal; absent fields mean the refusal named no payer.
 */
export type BillingRefusalError = Error & {
    payer?: BillingPayer;
    /**
     * With `payer`: self-serve setup (`…/billing/actions/set-up`) can provision it, for
     * whoever may (organization: `org:manage_billing`; user: themself).
     *
     */
    setup_available?: boolean;
    /**
     * Present only while `setup_available` is true: whether the server also runs that setup
     * automatically on the first paid use (an LLM call, a paid run, a Dream Bucks
     * purchase) by whoever may set the payer up, so the app may skip the set-up prompt for
     * them. Anyone else still needs it done for them.
     *
     */
    auto_setup_on_first_use?: boolean;
};

export type BillingSummary = {
    /**
     * Dream Studio provisioning state; independent from funding state.
     */
    account_state: 'not_provisioned' | 'provisioning' | 'ready' | 'failed';
    /**
     * True when the payer can set up (or finish setting up) its own billing: self-serve setup
     * is enabled on this server and `account_state` is not `ready`, or a user's account is
     * ready but its starter Dream Bucks are not granted yet. Offer the
     * `…/billing/actions/set-up` action then; it needs `org:manage_billing` for an organization.
     *
     */
    setup_available: boolean;
    /**
     * Present only while `setup_available` is true: whether the server also runs that setup
     * automatically on the first paid use (an LLM call, a paid run, a Dream Bucks purchase) by
     * whoever may set the payer up, so the app may skip the set-up prompt for them.
     *
     */
    auto_setup_on_first_use?: boolean;
    /**
     * State derived from the cached prepaid balance snapshot.
     */
    balance_state: 'unknown' | 'funded' | 'exhausted';
    /**
     * Non-negative cached prepaid balance as an exact base-10 decimal in whole Dream Bucks,
     * encoded as a string to preserve precision. At most nine fractional digits, without
     * trailing zeros. Null means unknown.
     *
     */
    balance_dream_bucks: string | null;
    /**
     * Timestamp of the Metronome balance snapshot; null when balance is unknown.
     */
    balance_as_of_ts: number | null;
    /**
     * True while a stale stored balance is being refreshed in the background.
     */
    balance_refreshing: boolean;
    /**
     * Ledger-derived quantities only; contains no money.
     */
    usage_quantities: Array<UsageQuantity>;
    /**
     * Inclusive usage window start: the first day of the current UTC month.
     *
     */
    usage_from_ts: number;
    /**
     * Exclusive usage window end: the summary fetch time.
     *
     */
    usage_to_ts: number;
    /**
     * Always true until usage periods can be settled: the month-to-date figures can still
     * change (late capture or transmission, an operator correction).
     *
     */
    usage_is_partial: boolean;
    /**
     * Ledger snapshot or high-water timestamp represented by usage quantities.
     */
    usage_as_of_ts: number;
    default_payment_method: BillingDefaultPaymentMethod;
    /**
     * True when the Stripe-owned summary field group could not be loaded.
     */
    stripe_unavailable: boolean;
    /**
     * Timestamp of the last successful Stripe display read; null when none exists.
     */
    stripe_as_of_ts: number | null;
    /**
     * True while the Stripe display group is being refreshed in the background.
     */
    stripe_refreshing: boolean;
    /**
     * True when the first balance read from Metronome failed and no stored balance exists.
     */
    metronome_unavailable: boolean;
    subscription: BillingSubscription;
};

export type BillingSubscription = {
    /**
     * Display name of the plan.
     */
    plan_label: string;
    /**
     * `active`: renews at `current_period_end_ts`. `canceling`: ends then, and does not renew.
     * `payment_failed`: the latest renewal is unpaid and being retried; it grants no Dream Bucks
     * until paid, so offer to update the card.
     *
     */
    status: 'active' | 'canceling' | 'payment_failed';
    /**
     * Current billing period start as Unix seconds.
     */
    current_period_start_ts: number;
    /**
     * Current billing period end (the renewal) as Unix seconds.
     */
    current_period_end_ts: number;
    /**
     * Dream Bucks each paid period adds, expiring at the period's end, as a decimal string.
     */
    allowance_dream_bucks: string;
    /**
     * What is left of the current period's allowance, as a decimal string; null until the period
     * is paid for, or while Metronome cannot be read. Already part of `balance_dream_bucks`.
     *
     */
    allowance_remaining_dream_bucks: string | null;
} | null;

export type BillingPaymentMethod = {
    /**
     * Stripe PaymentMethod ID.
     */
    id: string;
    /**
     * Payment method type accepted by the v1 setup flow.
     */
    type: 'card';
    /**
     * Stripe card brand. Clients must tolerate previously unseen values.
     */
    brand: string;
    /**
     * Last four card digits for display only.
     */
    last4: string;
    exp_month: number;
    /**
     * Four-digit card expiration year.
     */
    exp_year: number;
    /**
     * Whether Stripe currently uses this method as the invoice default.
     */
    is_default: boolean;
    /**
     * Rendering hint computed by Dream Studio; deletion always revalidates it.
     */
    removable: boolean;
    /**
     * Domain reason removal is blocked, or null when removable.
     */
    removal_blocked_reason: 'default_for_collection' | 'only_payment_method';
};

export type BillingDefaultPaymentMethod = {
    /**
     * Stripe PaymentMethod ID.
     */
    id: string;
    /**
     * Payment method type accepted by the v1 setup flow.
     */
    type: 'card';
    /**
     * Stripe card brand. Clients must tolerate previously unseen values.
     */
    brand: string;
    /**
     * Last four card digits for display only.
     */
    last4: string;
    exp_month: number;
    /**
     * Four-digit card expiration year.
     */
    exp_year: number;
    /**
     * Whether Stripe currently uses this method as the invoice default.
     */
    is_default: boolean;
    /**
     * Rendering hint computed by Dream Studio; deletion always revalidates it.
     */
    removable: boolean;
    /**
     * Domain reason removal is blocked, or null when removable.
     */
    removal_blocked_reason: 'default_for_collection' | 'only_payment_method';
} | null;

export type BillingPaymentMethodListResponse = {
    /**
     * Null only when the first Stripe read fails and no last-known list exists.
     */
    items: Array<BillingPaymentMethod> | null;
    /**
     * Timestamp of the last successful Stripe display read.
     */
    stripe_as_of_ts: number | null;
    /**
     * True while a stale payment-method list is being refreshed in the background.
     */
    stripe_refreshing: boolean;
    /**
     * True only when a cold Stripe read failed and no last-known list exists.
     */
    stripe_unavailable: boolean;
};

export type PaymentMethodSetupCreate = {
    /**
     * Client-minted Dream Studio operation identity, not a Stripe idempotency key.
     */
    attempt_id: string;
    return_path: BillingReturnPath;
};

/**
 * App page Stripe returns the browser to, relative to the request's own origin: a path with
 * an optional query, starting with a single `/`. No scheme, host, fragment, backslash or
 * whitespace. Setup and purchase append `attempt-id=<attempt_id>` to the query, so the
 * path must not carry one.
 *
 */
export type BillingReturnPath = string;

export type CustomerPortalSessionCreate = {
    return_path: BillingReturnPath;
};

export type PaymentMethodSetupCreateResponse = {
    /**
     * Sensitive short-lived client secret for the provider setup object.
     */
    client_secret: string;
    /**
     * Stripe publishable key from the same environment as the setup object.
     */
    publishable_key: string;
    /**
     * Canonical setup expiry as Unix seconds.
     */
    expires_ts: number;
};

export type PaymentMethodSetupAttempt = {
    /**
     * Client-minted Dream Studio setup-attempt identity.
     */
    attempt_id: string;
    /**
     * Product-oriented setup status derived from Dream Studio workflow state.
     */
    status: 'open' | 'pending' | 'succeeded' | 'expired';
    /**
     * Stable canonical expiry for this attempt as Unix seconds.
     */
    expires_ts: number;
};

export type BillingPurchaseOptions = {
    /**
     * Whether this server sells Dream Bucks. When false the other fields are null or empty.
     */
    enabled: boolean;
    /**
     * Price of one Dream Buck before tax, in micro-USD.
     */
    unit_price_micro_usd: number | null;
    /**
     * Smallest purchase, a whole number of Dream Bucks as a decimal string.
     */
    min_dream_bucks: string | null;
    /**
     * Largest purchase, a whole number of Dream Bucks as a decimal string.
     */
    max_dream_bucks: string | null;
    /**
     * Suggested purchase amounts, ascending, whole Dream Bucks as decimal strings.
     */
    preset_dream_bucks: Array<string>;
    /**
     * Monthly plans on offer (`…/billing/actions/subscribe`); empty while subscriptions are
     * switched off, and always while purchases are. A plan's fee buys an allowance of Dream
     * Bucks each paid month, expiring at the month's end and drawn before grants and purchases.
     *
     */
    subscription_plans: Array<BillingSubscriptionPlan>;
};

export type BillingPurchaseCreate = {
    /**
     * Client-minted Dream Studio operation identity, not a Stripe idempotency key.
     */
    attempt_id: string;
    /**
     * Whole Dream Bucks to buy, as a decimal string within the purchase options' bounds.
     */
    dream_bucks: string;
    return_path: BillingReturnPath;
};

export type BillingPurchaseCreateResponse = {
    /**
     * Sensitive short-lived client secret for the embedded Stripe Checkout.
     */
    client_secret: string;
    /**
     * Stripe publishable key from the same environment as the checkout.
     */
    publishable_key: string;
    /**
     * Checkout expiry as Unix seconds.
     */
    expires_ts: number;
    attempt: BillingPurchaseAttempt;
};

export type BillingSubscriptionPlan = {
    /**
     * Pass to `…/billing/actions/subscribe`.
     */
    plan_id: string;
    /**
     * Display name of the plan.
     */
    label: string;
    /**
     * Monthly price before tax, in micro-USD.
     */
    price_micro_usd: number;
    /**
     * Dream Bucks each paid month adds, expiring at the month's end, as a decimal string.
     */
    allowance_dream_bucks: string;
};

export type BillingSubscribeCreate = {
    /**
     * Client-minted identity of this subscribe action; repeating it returns the same checkout.
     * Not a Stripe idempotency key.
     *
     */
    attempt_id: string;
    /**
     * A `plan_id` from the purchase options' `subscription_plans`.
     */
    plan_id: string;
    return_path: BillingReturnPath;
};

export type BillingSubscribeCreateResponse = {
    /**
     * Sensitive short-lived client secret for the embedded Stripe Checkout.
     */
    client_secret: string;
    /**
     * Stripe publishable key from the same environment as the checkout.
     */
    publishable_key: string;
    /**
     * Checkout expiry as Unix seconds.
     */
    expires_ts: number;
};

export type BillingPurchaseAttempt = {
    /**
     * Client-minted Dream Studio purchase-attempt identity.
     */
    attempt_id: string;
    /**
     * `open` until checked out; `pending` once checked out, until the Dream Bucks are added
     * (a delayed payment method, such as a bank debit, can stay here for days); `succeeded`
     * when they are in the balance. Terminal failures: `expired` when the checkout closed
     * unused, `failed` when a delayed payment failed after checkout. Neither charges anything.
     *
     */
    status: 'open' | 'pending' | 'succeeded' | 'expired' | 'failed';
    /**
     * Dream Bucks bought, a whole number as a decimal string.
     */
    dream_bucks: string;
    /**
     * Checkout expiry as Unix seconds; null before the checkout exists.
     */
    expires_ts: number | null;
    /**
     * Creation time as Unix seconds.
     */
    created_ts: number;
};

export type BillingInvoice = {
    /**
     * Stripe Invoice ID used by the public collection surface.
     */
    id: string;
    /**
     * Customer-visible Stripe invoice number; null before assignment.
     */
    number: string | null;
    /**
     * Stripe collection lifecycle status.
     */
    status: 'draft' | 'open' | 'paid' | 'uncollectible' | 'void';
    /**
     * Original Stripe amount due converted exactly to micro-USD.
     */
    amount_due_micro_usd: number;
    /**
     * Amount collected by Stripe converted exactly to micro-USD.
     */
    amount_paid_micro_usd: number;
    /**
     * Live Stripe-hosted invoice URL; null when Stripe has not produced one.
     */
    hosted_url: string | null;
    /**
     * Dream Bucks this invoice bought (a purchase, or a subscription period's allowance), a
     * whole number as a decimal string; null for any other invoice (e.g. a usage invoice).
     *
     */
    dream_bucks: string | null;
    /**
     * Inclusive invoice service-period start as Unix seconds.
     */
    period_start_ts: number;
    /**
     * Exclusive invoice service-period end as Unix seconds.
     */
    period_end_ts: number;
};

export type BillingInvoiceListResponse = ListResponseBase & {
    items: Array<BillingInvoice>;
};

export type CustomerPortalSession = {
    /**
     * Short-lived absolute Stripe Customer Portal URL.
     */
    url: string;
};

export type UsageQuantity = {
    /**
     * Customer-facing usage category. The Dream Bucks wire identifier is
     * `dream_bucks`. The vocabulary is open, so clients must preserve and
     * render categories they do not recognize.
     *
     */
    category: string;
    /**
     * Unit selected by the customer-usage wire contract for this category.
     */
    unit: string;
    /**
     * Non-negative exact base-10 quantity in whole `unit`s, encoded as a string to
     * preserve precision. At most nine fractional digits, without trailing zeros.
     *
     */
    quantity: string;
};

export type BlobCreateResponse = {
    blob: Blob;
    /**
     * Pre-signed URL for uploading the content
     */
    upload_url: string;
    /**
     * Expiration timestamp for the upload URL
     */
    expires_ts: number;
};

export type BlobDownloadUrlResponse = {
    blob: Blob;
    /**
     * Pre-signed URL for downloading the content
     */
    download_url: string;
    /**
     * Expiration timestamp for the download URL
     */
    expires_ts: number;
};

export type BlobUploadUrlResponse = {
    blob: Blob;
    /**
     * Pre-signed URL for replacing the content
     */
    upload_url: string;
    /**
     * Expiration timestamp for the upload URL
     */
    expires_ts: number;
};

export type BlobCreateRequest = {
    /**
     * Optional existing blob ID to preserve when copying a blob between DreamStudio servers.
     */
    id?: string;
    /**
     * Name of the blob
     */
    name: string;
    /**
     * Optional description of the blob
     */
    description?: string | null;
    /**
     * MIME type of the blob content (e.g., image/png)
     */
    type?: string | null;
    /**
     * Expected size of the blob in bytes
     */
    size?: number | null;
    /**
     * Optional expiration timestamp (Unix time)
     */
    expire_ts?: number | null;
    /**
     * Optional arbitrary metadata
     */
    metadata?: {
        [key: string]: unknown;
    } | null;
    access_scope: BlobAccessScope;
    /**
     * If true, the generated upload URL can be reused multiple times to overwrite the blob.
     */
    allow_reupload?: boolean | null;
    /**
     * Optional additional readers. `*` allows authenticated users; `public` allows anyone to read uploaded content. Public grants require allow_reupload=false. Grants do not change scope-based writes or visibility.
     *
     */
    read_grants?: Array<BlobReadGrant>;
    /**
     * Upload transport to use. `single` accepts one complete file.
     *
     */
    upload_protocol?: 'single';
};

export type BlobCopyRequest = {
    access_scope: BlobAccessScope;
    /**
     * Additional readers of the copied blob.
     */
    read_grants: Array<BlobReadGrant>;
    /**
     * Optional name for the copied blob; defaults to the source name.
     */
    name?: string;
    /**
     * If true, later upload requests can replace the copied blob's content.
     */
    allow_reupload?: boolean | null;
};

/**
 * Server-authorized resource scope used to authorize access through the blob endpoints.
 */
export type BlobAccessScope = {
    resource_type: ResourceType;
    /**
     * ID of the resource that authorizes access to the blob.
     */
    resource_id: string;
};

/**
 * Step 1b supports resource_type "*" or "public" with no resource_id. Both grant authenticated download-url access to uploaded content; only public grants enable the unauthenticated content route. Public grants require allow_reupload=false; wildcard grants may allow reupload. Scope view access continues to work regardless of storage status.
 *
 */
export type BlobReadGrant = {
    /**
     * "*" grants authenticated reads; `public` also grants anonymous content access.
     */
    resource_type: '*' | 'public';
    /**
     * Must be empty for wildcard and public grants.
     */
    resource_id?: string;
};

/**
 * Status of the blob in the storage provider
 */
export const BlobStorageStatus = {
    PENDING: 'pending',
    UPLOADED: 'uploaded',
    FAILED: 'failed'
} as const;

/**
 * Status of the blob in the storage provider
 */
export type BlobStorageStatus = typeof BlobStorageStatus[keyof typeof BlobStorageStatus];

export type Blob = {
    id: string;
    create_ts: number;
    update_ts: number;
    name: string;
    description?: string | null;
    type?: string | null;
    size?: number | null;
    expire_ts?: number | null;
    metadata?: {
        [key: string]: unknown;
    } | null;
    access_scope?: BlobAccessScope;
    /**
     * Read grants persisted on the blob; empty means scope-only reads.
     */
    read_grants: Array<BlobReadGrant>;
    storage_status: BlobStorageStatus;
};

export type UploadBlobLocalFile201Response = {
    /**
     * Size of the uploaded file in bytes
     */
    size: number;
};

/**
 * Optional user-visible intent for the resulting history item. If provided, it must not be empty after trimming. The first non-empty line becomes the title (max 72 chars). Overflow from that line and any remaining lines become details. Details preserve line breaks, are capped at 2000 chars with the suffix `... [truncated]`, and generated structured-file change details are appended after user-provided details.
 *
 */
export type IntentField = string;

/**
 * Status of import (e.g., \"pending\", \"success\", \"failed\")
 */
export const ImportStatus = {
    PENDING: 'pending',
    SUCCESS: 'success',
    FAILED: 'failed'
} as const;

/**
 * Status of import (e.g., \"pending\", \"success\", \"failed\")
 */
export type ImportStatus = typeof ImportStatus[keyof typeof ImportStatus];

export type FsEntry = BaseEntity & {
    parent_id?: string;
    name: string;
    file_path: string;
    is_folder: boolean;
    is_readonly: boolean;
    size?: number;
    mime_type?: string;
    extension?: string;
    import_status: ImportStatus;
    import_error?: string;
    read_error?: string;
};

export type BundleCreateResponse = {
    bundle: Bundle;
    /**
     * Pre-signed URL for uploading the content
     */
    upload_url: string;
    /**
     * Expiration timestamp for the upload URL
     */
    expires_ts: number;
};

export type BundleContentUploadRequest = {
    /**
     * IANA media type of the content to be uploaded
     */
    content_type: string;
};

export type BundleContentUploadResponse = {
    /**
     * Pre-signed URL for uploading the content
     */
    upload_url: string;
    /**
     * Expiration timestamp for the upload URL
     */
    expires_ts: number;
};

/**
 * Semantic Versioning (SemVer). Accepts major-only ("3"), major.minor ("3.1"), or full SemVer with optional pre-release/build (e.g., "3.1.4", "3.1.4-rc.1", "3.1.4+build.5"). Versions are unique per source_id but ordering is not enforced by the server by default.
 */
export type Semver = string;

export type BundleSource = BaseEntity & {
    /**
     * Project ID this source belongs to
     */
    project_id: string;
    /**
     * Name of the bundle source
     */
    name: string;
    /**
     * Optional source description
     */
    description?: string;
    /**
     * Arbitrary metadata as key-value pairs
     */
    metadata?: {
        [key: string]: string;
    };
};

export type BundleSourceCreate = {
    name: string;
    description?: string;
    metadata?: {
        [key: string]: string;
    };
};

export type BundleSourceUpdate = {
    name?: string;
    description?: string;
    metadata?: {
        [key: string]: string;
    };
};

export type Bundle = BaseEntity & {
    /**
     * Optional bundle description
     */
    description?: string;
    version: Semver;
    content: BundleContentInfo;
    /**
     * ID of the BundleSource this bundle belongs to (project_id accessible via source)
     */
    source_id: string;
    /**
     * Arbitrary metadata as key-value pairs
     */
    metadata?: {
        [key: string]: string;
    };
};

export type BundleContentInfo = {
    /**
     * Upload status of the content
     */
    upload_status: 'pending' | 'uploaded' | 'failed';
    /**
     * Size of the content in bytes
     */
    size?: number;
    /**
     * IANA media type of the stored content
     */
    content_type?: string;
};

/**
 * Create a bundle without content; the response includes an upload URL for the content
 */
export type BundleCreate = {
    description?: string;
    version: Semver;
    /**
     * IANA media type of the content to be uploaded
     */
    content_type: string;
    metadata?: {
        [key: string]: string;
    };
};

/**
 * Update metadata only; content and version are immutable
 */
export type BundleUpdate = {
    description?: string;
    metadata?: {
        [key: string]: string;
    };
};

export type BundleDiffRequest = {
    /**
     * The other bundle to diff against
     */
    other_bundle_id: string;
    /**
     * Type of diff to generate
     */
    type?: 'unified';
    /**
     * Additional options for diff generation
     */
    options?: {
        /**
         * Options specific to unified diffs
         */
        unified?: {
            /**
             * Number of context lines to include in the diff
             */
            context_lines?: number;
            /**
             * Format to convert content to before diffing (e.g., "json", "yaml")
             */
            convert?: 'json' | 'yaml';
        };
    };
};

/**
 * Request to deploy a bundle to an environment
 */
export type BundleDeployRequest = {
    /**
     * ID of the environment to deploy to
     */
    environment_id: string;
    /**
     * Optional deployment notes
     */
    notes?: string;
    /**
     * Arbitrary metadata as key-value pairs
     */
    metadata?: {
        [key: string]: string;
    };
};

export type BundleEnvironment = BaseEntity & {
    project_id: string;
    name: string;
    description?: string;
    /**
     * ID of the current deployment
     */
    current_deployment_id?: string;
};

export type BundleEnvironmentCreate = {
    name: string;
    description?: string;
};

export type BundleEnvironmentUpdate = {
    name?: string;
    description?: string;
};

export type BundleDeployment = BaseEntity & {
    bundle_id: string;
    bundle?: Bundle;
    environment_id: string;
    environment?: BundleEnvironment;
    notes?: string;
    metadata?: {
        [key: string]: string;
    };
    /**
     * Deployment timestamp (Unix timestamp)
     */
    deploy_ts: number;
};

export type BundleDeploymentUpdate = {
    notes?: string;
    metadata?: {
        [key: string]: string;
    };
};

export type MessageInteractionCreate = {
    /**
     * Zero-based index of the interactive content block within the message's content array
     */
    content_block_index: number;
    /**
     * Interaction data.
     * For Buttons: Contains `[action_key]`.
     * For Prompts: Contains list of selected values.
     *
     */
    interaction: Array<string>;
};

export type QuestionSetAnswerCreate = {
    content_block_index: number;
    question_set_id: string;
    answers: Array<QuestionSetAnswer>;
};

export type Chat = BaseEntity & {
    name: string;
    /**
     * The ID of the currently active branch in this chat
     */
    current_branch_id: string;
};

/**
 * Chat information for listing UI (relationship endpoint)
 */
export type ChatInfo = BaseEntity & {
    name: string;
};

export type ChatBranch = BaseEntity & {
    /**
     * The ID of the chat this branch belongs to
     */
    chat_id: string;
    /**
     * The ID of the parent branch, null for root branches
     */
    parent_branch_id?: string | null;
    /**
     * The ID of the message that triggered the creation of this branch, null for root branches
     */
    parent_message_id?: string | null;
    /**
     * Array of participants in this chat branch
     */
    participants?: Array<Participant>;
};

export type ChatCreate = {
    name: string;
};

export type ChatUpdate = {
    name: string;
};

export type SwitchBranchRequest = {
    /**
     * The ID of the branch to switch to
     */
    branch_id: string;
};

/**
 * Create a new chat message. The sender is automatically determined from the authenticated user.
 *
 */
export type ChatMessageCreate = {
    /**
     * The message content as an array of content items
     */
    content: Array<ChatMessageContentItem>;
    /**
     * Optional array of attachments (references to content)
     */
    attachments?: Array<Attachment>;
    llm_override?: LlmOverride;
};

export type LlmModelOption = {
    /**
     * Provider-qualified model name, as used in `LLMOverride.model`
     */
    model: string;
    /**
     * Accepted reasoning efforts, lowest first; empty when the model has no reasoning
     */
    reasoning_effort_levels: Array<string>;
};

/**
 * Representation of an edit to an existing chat message. The edit can be handled
 * destructively (reverting subsequent messages in the current branch) or by creating
 * a new branch (preserving current branch history and applying the edit in the new branch).
 *
 */
export type ChatMessageUpdate = {
    /**
     * The updated message content as an array of content items
     */
    content: Array<ChatMessageContentItem>;
    /**
     * How to handle the edit:
     * - destructive: Delete subsequent messages and revert current branch
     * - branch: Create a new ChatBranch and apply the edit there
     *
     */
    edit_mode?: 'destructive' | 'branch';
    /**
     * Required when `edit_mode=branch`. Name or description for the created branch.
     */
    branch_name?: string;
};

/**
 * Structured LLM view of the messages sent to the LLM model for a branch.
 */
export type ChatBranchLlmView = {
    schema_version: string;
    /**
     * The chat that owns the branch
     */
    chat_id: string;
    /**
     * The branch whose LLM view is being returned
     */
    branch_id: string;
    /**
     * The AI message that was used as the LLM view target
     */
    target_message_id: string;
    /**
     * LLM view rendering mode
     */
    mode: 'regular_chat' | 'agentic_cycle';
    messages: Array<LlmViewMessage>;
};

export type LlmViewMessage = {
    role: 'system' | 'user' | 'ai' | 'tool';
    content: Array<LlmViewContent>;
};

/**
 * One LLM content block inside an LLM view message.
 */
export type LlmViewContent = {
    type: 'text' | 'reasoning' | 'binary' | 'remote' | 'tool_call' | 'tool_result';
    /**
     * Text payload for `text` or `reasoning` content
     */
    text?: string;
    reasoning?: LlmViewReasoning;
    binary?: LlmViewBinary;
    remote?: LlmViewRemote;
    tool_call?: LlmViewToolCall;
    tool_result?: LlmViewToolResult;
};

export type LlmViewReasoning = {
    /**
     * Whether the reasoning text was redacted by the provider
     */
    redacted: boolean;
    text: string;
};

export type LlmViewBinary = {
    mime_type: string;
    file_name: string;
    /**
     * Base64-encoded binary payload when the LLM view includes raw binary content
     */
    data_base64?: string;
};

export type LlmViewRemote = {
    url: string;
    mime_type: string;
};

export type LlmViewToolCall = {
    id: string;
    name: string;
    args?: {
        [key: string]: unknown;
    };
    raw_args?: string;
};

export type LlmViewToolResult = {
    id: string;
    result: string;
    error?: string | null;
};

/**
 * Type of the explicit chat stream event
 */
export const StreamEventType = {
    MESSAGE_ADD: 'message_add',
    ITEM_ADD: 'item_add',
    ITEM_UPDATE: 'item_update',
    ITEM_PATCH: 'item_patch',
    ITEM_APPEND_TEXT: 'item_append_text',
    ITEM_MOVE: 'item_move',
    STATUS_UPDATE: 'status_update'
} as const;

/**
 * Type of the explicit chat stream event
 */
export type StreamEventType = typeof StreamEventType[keyof typeof StreamEventType];

/**
 * Sparse merge-patch payload for a ContentBlockCollapsible's scalar attributes,
 * following RFC 7396 (JSON Merge Patch) semantics: a field that is absent from the
 * payload means "leave unchanged"; a present field replaces the corresponding
 * attribute on the target item. This type deliberately has no `content` field, so a
 * patch can never introduce, replace, or reorder children — only start_section /
 * item_add and end_section / item_update (full replace) change nested content.
 *
 */
export type ContentBlockCollapsiblePatch = {
    /**
     * Present when the section title changed.
     */
    title?: string;
    /**
     * Present when the icon changed.
     */
    icon?: string;
    /**
     * Present when the streaming/pending state changed.
     */
    pending?: boolean;
    /**
     * Present when the default collapsed state changed.
     */
    initially_collapsed?: boolean;
    variant?: ContentBlockCollapsibleVariant;
};

/**
 * Explicit action on the chat stream.
 * - item_add inserts a new item at item_index
 * - item_update applies a property patch to the existing item at item_index (clients should merge fields and preserve existing nested content unless explicitly replaced)
 * - item_patch applies a sparse ContentBlockCollapsiblePatch to the existing item at item_index (RFC 7396: absent field = leave unchanged, present field = apply; children are never affected)
 * - item_append_text appends text to an existing text node at item_index
 * - item_move moves an existing item from from_item_index to item_index
 *
 */
export type ChatStreamEvent = {
    type: StreamEventType;
    message_id: string;
    branch_id: string;
    /**
     * Identifies the nesting path like [0, 1] for nested content. Used for item_add, item_update, item_patch, item_append_text, item_move.
     */
    item_index?: Array<number>;
    /**
     * Source nesting path for item_move. The item is removed from this path and inserted at item_index. Only valid for item_move.
     */
    from_item_index?: Array<number>;
    item?: ChatMessageContentItem;
    item_patch?: ContentBlockCollapsiblePatch;
    message?: ChatMessage;
    /**
     * Used for item_append_text
     */
    text_delta?: string;
    status?: ChatMessageStatus;
    execution_info?: ExecutionInfo;
};

export type Participant = {
    type: SenderType;
    /**
     * Unique identifier for the participant
     */
    id: string;
    /**
     * Display name or nickname of the participant
     */
    nickname: string;
};

export type FileChangeSummary = {
    path: string;
    title: string;
    details?: string;
    /**
     * Optional rich details with literal text and explicit labeled ref links for navigation_version_id. Plain details remain available.
     */
    details_markdown?: string;
};

export type DiffViewResponse = {
    /**
     * Regular unified diff output with one `@@` hunk format; combined-diff syntax is not used.
     * Directional `own_changes` and `parent_changes` views may include reserved
     * `[structural-conflict:<reason>]` hunks with inserted Target/Base/Source diff3 markers,
     * or `[structural-assessment:unknown]` hunks containing one JSON reason body when
     * assessment is unsupported, incomplete, or truncated. Compatible ordinary changes keep
     * their existing rendering. Structural evidence can appear outside a file or property
     * selector. Arrays are compared positionally; objects are not matched by IDs. Document
     * absence is distinct from a present JSON null. Missing structural markers do not
     * guarantee a clean Git merge. Structural pointers and alternatives are JSON-quoted.
     *
     */
    diff: string;
    /**
     * Unfiltered best-effort per-file summaries; independently empty from diff.
     */
    summary: Array<FileChangeSummary>;
};

export type HistoryComparisonSummaryResponse = {
    /**
     * Human-readable per-file summaries for the resolved history comparison.
     */
    summary: Array<FileChangeSummary>;
};

export type CreateFsEntryRequest = {
    intent?: IntentField;
    name: string;
    parent_id?: string;
    /**
     * Content-Type of the file. If omitted, defaults to application/octet-stream.
     */
    content_type?: string;
    is_folder?: boolean;
};

export type UpdateFsEntryRequest = {
    intent?: IntentField;
    /**
     * New path to move the entry to.
     */
    target_path: string;
} | {
    intent?: IntentField;
    /**
     * ID of the target parent folder to move the entry into. If provided, the entry will be moved to this folder with its current name.
     */
    target_parent_id: string;
    /**
     * New name for the entry (optional). If provided, the entry will be renamed during the move.
     */
    name?: string;
} | {
    intent?: IntentField;
    /**
     * New name for the entry.
     */
    name: string;
};

export type CopyRequest = {
    intent?: IntentField;
    target_parent_id: string;
    name?: string;
};

export type CreateFromDataRequest = {
    intent?: IntentField;
    source_file_id: string;
    source_path: string;
    name: string;
    type: string;
};

export type RequestUploadUrlResponse = {
    upload_url: string;
    expires_ts: unknown;
};

export type CopyFsEntryResponse = {
    new_id: string;
};

/**
 * A single JSON Patch operation (RFC 6902)
 */
export type JsonPatchOperation = {
    /**
     * The operation to perform
     */
    op: 'add' | 'remove' | 'replace' | 'move' | 'copy' | 'test';
    /**
     * JSON Pointer to the target location (RFC 6901)
     */
    path: string;
    /**
     * The value to add, replace, or test
     */
    value?: unknown;
    /**
     * JSON Pointer to the source location for move/copy operations (RFC 6901)
     */
    from?: string;
};

export type ReplaceFsEntryContentRequest = {
    /**
     * SHA-256 of the exact downloaded file bytes, before decoding or parsing.
     */
    expected_content_hash: string;
    /**
     * Complete replacement file content as UTF-8 text.
     */
    content: string;
    intent?: IntentField;
};

/**
 * Incremental edit request.
 * Exactly one of `ops` or `unified_diff` must be provided.
 * Optional `intent` is normalized into the history title/details:
 * first non-empty line → title (max 72 chars), overflow and remaining lines → details.
 * Details preserve line breaks, are capped at 2000 chars with the suffix `… [truncated]`,
 * and generated structured-file change details are appended after user-provided details.
 *
 */
export type PatchFsEntryContentRequest = {
    intent?: IntentField;
    /**
     * JSON Patch operations (RFC 6902). Mutually exclusive with `unified_diff`.
     */
    ops?: Array<JsonPatchOperation>;
    /**
     * Unified diff content. Mutually exclusive with `ops`.
     */
    unified_diff?: string;
};

export type ContentRef = {
    /**
     * UUID of the file system entry
     */
    fs_entry_id: string;
    /**
     * Optional JSONPointer for granular references (e.g., "/furniture/0/name")
     */
    property_path?: string;
};

export type EditSession = BaseEntity & {
    /**
     * Parent project UUID
     */
    project_id: string;
    /**
     * Session name (e.g., "Update room layouts")
     */
    name: string;
    /**
     * Optional description
     */
    description?: string;
    /**
     * Unix timestamp when archived (null if not archived)
     */
    archive_ts?: number;
    /**
     * Whether there are pending changes to apply/merge
     */
    pending_apply: boolean;
    /**
     * Whether there are upstream changes to sync
     */
    pending_sync: boolean;
    /**
     * User who created the session
     */
    created_by: string;
    /**
     * Primary/default Chat for this EditSession (created automatically)
     */
    chat_id: string;
    /**
     * ChatBranch where this edit session's conversation occurs
     */
    chat_branch_id: string;
    /**
     * Content that can be modified in this session
     */
    editable_scope: Array<ContentRef>;
    /**
     * Reference material available for context (read-only)
     */
    readonly_scope: Array<ContentRef>;
    /**
     * Unix timestamp when merged (if applicable)
     */
    merge_ts?: number;
};

/**
 * Request for AI-powered context suggestions to help determine the optimal content scope for an EditSession.
 * The system analyzes the intended editable content and suggests additional related content that should be
 * included in the editable scope or made available as readonly context.
 *
 */
export type ContextSuggestionsRequest = {
    /**
     * Content the user intends to edit
     */
    intended_editable_scope: Array<ContentRef>;
};

/**
 * AI-powered recommendations for content to include in an EditSession. Includes both content that should be
 * editable and content that should be available as readonly reference material.
 *
 */
export type ContextSuggestionsResponse = {
    /**
     * Suggested content that should be included in the editable scope (may include the originally intended content plus related items)
     */
    editable: Array<ContentRef>;
    /**
     * Suggested content that should be available as readonly context (reference material that may be useful but shouldn't be modified)
     */
    readonly: Array<ContentRef>;
};

export type EditSessionListResponse = {
    edit_sessions: Array<EditSession>;
};

export type CreateEditSessionRequest = {
    name: string;
    description?: string;
    editable_scope: Array<ContentRef>;
    readonly_scope: Array<ContentRef>;
};

export type EditSessionResponse = {
    edit_session: EditSession;
};

export type UpdateEditSessionRequest = {
    name?: string;
    description?: string;
};

export type MergeConflict = {
    /**
     * File path relative to project root (e.g., "src/config.json")
     */
    path: string;
    conflict_type: 'locked_by_other' | 'merge_conflict';
    description: string;
    /**
     * Current content in main project
     */
    current_version?: {
        [key: string]: unknown;
    };
    /**
     * Content from edit session
     */
    session_version?: {
        [key: string]: unknown;
    };
};

export const EditSessionConflictResolution = { KEEP_SESSION: 'keep_session', KEEP_PROJECT: 'keep_project' } as const;

export type EditSessionConflictResolution = typeof EditSessionConflictResolution[keyof typeof EditSessionConflictResolution];

export type MergeEditSessionRequest = {
    /**
     * Default conflict resolution strategy to apply to all files unless overridden
     */
    default_conflict_resolution?: EditSessionConflictResolution;
    per_path_conflict_resolutions?: Array<{
        /**
         * Absolute path from the project root, starting with "/" (e.g., "/src/config.json")
         */
        path: string;
        resolution: EditSessionConflictResolution;
    }>;
};

export type MergeResult = {
    success: boolean;
    /**
     * True if the branches are already merged and no action is or was needed
     *
     */
    up_to_date: boolean;
    /**
     * Conflicts that need resolution; present and non-empty when success is false.
     *
     */
    conflicts?: Array<MergeConflict>;
    /**
     * Paths of files that were successfully merged; omitted when `up_to_date`
     * is true or when a conflict prevented merging.
     *
     */
    merged_paths?: Array<string>;
    /**
     * The edit unit's persisted `update_ts` as of this response (Unix timestamp).
     * Set by the merge and sync endpoints so clients can reconcile cached entities
     * without relying on the `Date` response header; omitted by the dry-run
     * (can-merge/can-sync) endpoints.
     *
     */
    update_ts?: number;
};

export type CreateThreadRequest = {
    name: string;
    /**
     * The explicit source from which to branch the new thread. This field is required and must specify either the parent edit session or an existing thread within it.
     */
    source: {
        kind: 'edit_session' | 'edit_session.thread';
        id: string;
    };
};

export type CreateChatRequest = {
    /**
     * Optional name for the chat
     */
    name?: string;
};

/**
 * Restore the current edit unit to the given history item ID. Omitting the body (or the to field) restores the state before the latest visible history item.
 */
export type RevertEditUnitRequest = {
    /**
     * Public history version ID to restore, inclusive. A successful restore moves the branch
     * directly to this version without creating a new commit. Omit to restore the state
     * before the latest visible history item.
     *
     */
    to?: string;
};

export type HistoryItem = {
    /**
     * Stable random nine-character public version ID
     */
    id: string;
    title: string;
    details?: string;
    create_ts: number;
    author_id?: string;
    author_type?: 'human' | 'ai-persona' | 'system';
    requester_id?: string;
    requester_type?: 'human';
    sync?: HistoryItemSyncApply;
    apply?: HistoryItemSyncApply;
    /**
     * History item ID that was reverted to. Only present on revert history items.
     */
    revert_to_item_id?: string;
    /**
     * AI response chat message ID associated with this history item, when the change was made during an agentic response.
     */
    response_chat_message_id?: string;
};

export type HistoryItemSyncApply = {
    source_type: HistoryResourceType;
    source_id: string;
    /**
     * Source tip history item ID at sync/apply time
     */
    source_item_id: string;
    target_type: HistoryResourceType;
    target_id: string;
    /**
     * Target tip history item ID at sync/apply time
     */
    target_item_id: string;
};

export const HistoryResourceType = {
    PROJECT: 'project',
    EDIT_SESSION: 'edit_session',
    EDIT_SESSION_THREAD: 'edit_session.thread'
} as const;

export type HistoryResourceType = typeof HistoryResourceType[keyof typeof HistoryResourceType];

/**
 * Response containing the target file system entry and its contents if it is a folder.
 */
export type FsListResponse = {
    entry: FsEntry;
    content?: Array<FsEntry>;
};

export const ProblemCategory = {
    VALIDATION: 'validation',
    CONFIGURATION: 'configuration',
    IMPORT: 'import',
    FS: 'fs',
    SYSTEM: 'system'
} as const;

export type ProblemCategory = typeof ProblemCategory[keyof typeof ProblemCategory];

export const ProblemSeverity = {
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info'
} as const;

export type ProblemSeverity = typeof ProblemSeverity[keyof typeof ProblemSeverity];

/**
 * A reference to a domain resource by type and id.
 */
export type ResourceRef = {
    type: ResourceType;
    id: string;
};

export type ProblemSource = ResourceRef & unknown;

/**
 * Shared file position metadata for file-scoped problems. The file identity is carried by `Problem.source` (its `id` is the file system entry id); it is not duplicated here.
 */
export type FileProblemDetailsBase = {
    file_update_ts: number;
    path: string;
    line: number;
    column: number;
};

export type FileProblemDetails = FileProblemDetailsBase & {
    type: 'fs_problem';
};

export type StructuredValueValidationDetails = FileProblemDetailsBase & {
    type: 'sv_validation';
    property_path: string;
    metadata?: {
        [key: string]: unknown;
    };
};

export type FsImportErrorDetails = FileProblemDetailsBase & {
    type: 'fs_import_error';
    failed_importer: string;
};

export type ProjectConfigValidationDetails = {
    type: 'project_conf_validation';
    current_version: string;
    expected_version: string;
};

export type ProblemDetails = ({
    type: 'fs_problem';
} & FileProblemDetails) | ({
    type: 'sv_validation';
} & StructuredValueValidationDetails) | ({
    type: 'fs_import_error';
} & FsImportErrorDetails) | ({
    type: 'project_conf_validation';
} & ProjectConfigValidationDetails);

export type Problem = {
    category: ProblemCategory;
    /**
     * Stable machine-readable problem code.
     */
    code: string;
    severity: ProblemSeverity;
    message: string;
    source: ProblemSource;
    /**
     * Timestamp when the problem was detected or generated.
     */
    detect_ts: number;
    details?: ProblemDetails;
};

/**
 * The kind of background check pending on a resource.
 */
export const PendingCheckKind = { VALIDATION: 'validation', IMPORT: 'import' } as const;

/**
 * The kind of background check pending on a resource.
 */
export type PendingCheckKind = typeof PendingCheckKind[keyof typeof PendingCheckKind];

/**
 * A background check pending on a resource. The resource's problems may be stale or incomplete until it completes.
 */
export type PendingCheck = {
    resource: ResourceRef;
    kind: PendingCheckKind;
};

export type ProblemsResponse = {
    problems: Array<Problem>;
    /**
     * Resources with a background check (validation, import, …) still in progress; their problems may be incomplete or outdated until the check completes. Always present (possibly empty). An asynchronous validate or reimport trigger is complete once no entry of the matching `kind` remains.
     */
    pending_checks: Array<PendingCheck>;
};

export type ContentTreeNodeDisplay = {
    /**
     * Display name (e.g., "LivingRoom.room", "Doors", "Where")
     */
    label: string;
    /**
     * Icon name (e.g., "folder", "file", "box", "list", "braces")
     */
    icon: string;
};

export type ContentTreeNodeFs = BaseEntity & {
    /**
     * Full path from project root
     */
    path: string;
    /**
     * File or folder name
     */
    name: string;
    /**
     * True for folders, false for files
     */
    is_folder: boolean;
    is_readonly: boolean;
    /**
     * File size in bytes (present for files)
     */
    size?: number;
    /**
     * MIME type (present for files). Dream Studio structured files use vendor prefix:
     * - application/vnd.dreamstudio.type+yaml
     * - application/vnd.dreamstudio.value.room+yaml
     * - application/vnd.dreamstudio.value.scene+yaml
     * Standard files use native MIME types (image/png, text/markdown, etc)
     *
     */
    mime_type?: string;
};

/**
 * Import processing status for files with importers
 */
export type ContentTreeNodeImport = {
    status?: ImportStatus;
    /**
     * Error message if status='failed'
     */
    import_error?: string;
};

/**
 * Present on file nodes with application/vnd.dreamstudio.* MIME types and on node_type='structured_property' nodes
 */
export type ContentTreeNodeStructured = {
    /**
     * StructuredType ID (for schema lookups and property-node type context)
     */
    type_id: string;
};

/**
 * Present only for node_type='structured_property'
 */
export type ContentTreeNodeStructuredProperty = {
    /**
     * StructuredValue ID (which file this property belongs to)
     */
    file_id: string;
    /**
     * JSONPointer to property (RFC 6901, e.g., "/Doors/0")
     */
    property_path: string;
    /**
     * Suggested editor type (e.g. "visual_node_graph"; reflects the "x-editor" schema annotation)
     */
    editor_hint?: string;
    /**
     * Whether the property is buildable (reflects the "x-buildable" schema annotation)
     */
    buildable?: boolean;
    /**
     * True when property exists in schema but not yet in the value
     */
    virtual?: boolean;
};

/**
 * Validation state for structured content
 */
export type ContentTreeNodeValidation = {
    status?: 'valid' | 'invalid' | 'needs_revalidation';
    /**
     * Whether there are non-blocking warnings
     */
    warning?: boolean;
};

/**
 * Drag and drop affordances (only if node supports drag/drop)
 */
export type ContentTreeNodeDragDrop = {
    /**
     * Drag type tag (e.g., "Room", "Furniture")
     */
    type?: string;
    /**
     * Additional drag data
     */
    data?: {
        [key: string]: unknown;
    };
    /**
     * Accepted drag type tags (for drop targets)
     */
    accepts?: Array<string>;
    /**
     * Where drops are allowed
     */
    position?: 'into' | 'before' | 'after';
};

export type ContentTreeNode = {
    /**
     * Unique node identifier (usable within same response to rebuild tree)
     */
    id: string;
    /**
     * Parent node ID. Only present for non-root nodes.
     */
    parent_id?: string | null;
    /**
     * Depth level in tree (0 = root)
     */
    depth: number;
    /**
     * - folder: Filesystem folder
     * - file: Regular file (check mime_type for Dream Studio vendor types)
     * - structured_property: A property from structured data (arrays/objects only)
     *
     */
    node_type: 'folder' | 'file' | 'structured_property';
    /**
     * True when this node changed in the requested comparison context. Current edit-unit trees show changes attributable to the edit unit versus its parent branch baseline. Historical trees show changes introduced by the selected commit versus its first parent, versus an empty tree for a root commit, or versus an explicit `compare_to` target when one is requested.
     */
    modified?: boolean;
    /**
     * How many children does this node have? Only present for expandable nodes.
     */
    child_count?: number;
    display?: ContentTreeNodeDisplay;
    fs?: ContentTreeNodeFs;
    import?: ContentTreeNodeImport;
    structured?: ContentTreeNodeStructured;
    structured_property?: ContentTreeNodeStructuredProperty;
    validation?: ContentTreeNodeValidation;
    drag_drop?: ContentTreeNodeDragDrop;
};

export type ContentTreeResponseMetadata = {
    /**
     * Index of parent_id -> [child_ids] for efficient tree building.
     * Use "/" string as key for root nodes.
     * Example: {"/": ["folder-123"], "folder-123": ["file-1", "file-2"]}
     *
     */
    index: {
        [key: string]: Array<string>;
    };
    /**
     * Maximum depth level included in this response
     */
    depth_reached: number;
};

export type ContentTreeResponse = {
    /**
     * ID of the node specified by the 'path' parameter (or root node if not specified)
     */
    requested_node_id: string;
    /**
     * Flat array of all tree nodes
     */
    nodes: Array<ContentTreeNode>;
    metadata: ContentTreeResponseMetadata;
};

/**
 * Lifecycle status of an AI-assisted merge resolution.
 */
export const MergeResolutionStatus = {
    /**
     * MergeResolutionStatusResolving
     */
    MERGE_RESOLUTION_STATUS_RESOLVING: 'resolving',
    /**
     * MergeResolutionStatusAwaitingUser
     */
    MERGE_RESOLUTION_STATUS_AWAITING_USER: 'awaiting_user',
    /**
     * MergeResolutionStatusFailed
     */
    MERGE_RESOLUTION_STATUS_FAILED: 'failed'
} as const;

/**
 * Lifecycle status of an AI-assisted merge resolution.
 */
export type MergeResolutionStatus = typeof MergeResolutionStatus[keyof typeof MergeResolutionStatus];

/**
 * Direction of the AI-assisted merge resolution.
 */
export const MergeResolutionDirection = { APPLY: 'apply', SYNC: 'sync' } as const;

/**
 * Direction of the AI-assisted merge resolution.
 */
export type MergeResolutionDirection = typeof MergeResolutionDirection[keyof typeof MergeResolutionDirection];

export type EditSessionThread = BaseEntity & {
    /**
     * Thread belongs to an EditSession
     */
    edit_session_id: string;
    name: string;
    /**
     * User who created the thread
     */
    created_by: string;
    /**
     * Unix timestamp when archived (null if not archived)
     */
    archive_ts?: number;
    /**
     * Whether there are pending changes to apply/merge
     */
    pending_apply: boolean;
    /**
     * Whether there are upstream changes to sync
     */
    pending_sync: boolean;
    /**
     * Present only while an AI-assisted merge resolution is active for this thread; absent means idle. When present, every field is populated — there is no partially-filled state.
     */
    merge_resolution?: {
        status: MergeResolutionStatus;
        direction: MergeResolutionDirection;
        /**
         * Dedicated chat branch for the AI-assisted merge resolution.
         */
        chat_branch_id: string;
        /**
         * User who started this resolution; only they get input controls.
         */
        initiator_id: string;
    };
    /**
     * Parent Chat that contains this thread's branch (for navigation)
     */
    chat_id: string;
    /**
     * ChatBranch where this thread's conversation occurs
     */
    chat_branch_id: string;
    /**
     * Message ID where this thread branched off (null if branched from EditSession directly)
     */
    branching_message_id?: string;
    /**
     * The source from which this thread was branched.
     */
    source: {
        kind: 'edit_session' | 'edit_session.thread';
        id: string;
    };
};

/**
 * Result of a thread merge/sync action. `merged` (200) means the operation completed; `assisted` (202) means it conflicted and an AI-assisted resolution started, in which case the resolution fields are also populated.
 */
export type ThreadMergeOutcome = {
    outcome: 'merged' | 'assisted';
    merge_result: MergeResult;
    status?: MergeResolutionStatus;
    direction?: MergeResolutionDirection;
    /**
     * Dedicated chat branch for the AI-assisted merge resolution. Only set when outcome is assisted.
     */
    chat_branch_id?: string;
};

export type UpdateThreadRequest = {
    name?: string;
};

/**
 * Base structure for all real-time events
 */
export type Event = {
    /**
     * Unique durable event identifier
     */
    id: number;
    resource: ResourceType;
    /**
     * The action performed on the resource
     */
    action: 'create' | 'update' | 'delete';
    /**
     * Unix timestamp with microsecond precision for event ordering
     */
    create_ts: number;
    /**
     * Event-specific data payload. Invalidation-only events such as `problems:update` usually omit payload.
     */
    payload?: Chat | ChatMessage | ChatStreamEvent | TreeView | UiIntent | Blob | ContentApplied | ProjectCopyProgress | PresenceUpdate;
    /**
     * IDs of resources related to this event
     */
    source_ids?: Array<EventSourceId>;
};

/**
 * Scope, client identity, and initial channel used to create a short-lived WebSocket connection URL.
 */
export type CreateEventChannelRequest = {
    /**
     * Authorization scope for the connection; a project, edit session, or thread the caller can view.
     */
    scope: EventSourceId;
    /**
     * Caller-chosen client or tab identifier, 1 to 64 bytes, bound to the token and included in published events.
     */
    client_id: string;
    /**
     * Initial channel name, 1 to 256 bytes. Connections exchange events only when both scope and channel match.
     */
    channel: string;
};

/**
 * Token-authenticated URL for connecting to the requested ephemeral channel.
 */
export type CreateEventChannelResponse = {
    /**
     * WebSocket URL containing a bearer token; keep it private and connect within 60 seconds of issuance. An established socket may remain open after the token expires.
     */
    url: string;
};

/**
 * Server-authored transient event delivered only on WebSocket channels.
 */
export type EphemeralEvent = {
    /**
     * Allowlisted resource:action event type; currently presence.pointer:update.
     */
    type: string;
    /**
     * Receiving socket's channel generation, starting at 0 and incremented after each successful join. Only apply events whose generation matches the latest joined acknowledgement.
     */
    gen: number;
    /**
     * Authenticated user ID of the publishing connection, assigned by the server.
     */
    user_id: string;
    /**
     * Publisher-supplied client ID bound to the channel token. Identifies a client or tab and may be shared by multiple connections.
     */
    client_id: string;
    /**
     * Server-assigned event timestamp in Unix seconds with microsecond precision.
     */
    create_ts: number;
    /**
     * Client-provided, event-specific JSON object, limited to 512 bytes after compaction and HTML escaping.
     */
    payload: {
        [key: string]: unknown;
    };
};

/**
 * Client-to-server event for the socket's current scope and channel. Updates are coalesced per channel generation and event type before publishing; the sending connection receives no echo. Clients may send an empty object payload for a type as a leave signal followed immediately by join, without a delay. Disconnects emit no automatic leave; receivers should expire a sender's state (e.g. its pointer) after a few seconds without updates.
 */
export type EphemeralPublishFrame = {
    /**
     * Allowlisted resource:action event type; currently presence.pointer:update.
     */
    type: string;
    /**
     * Event-specific JSON object, limited to 512 bytes after compaction and HTML escaping.
     */
    payload: {
        [key: string]: unknown;
    };
};

/**
 * Client-to-server request to switch the socket's channel, optionally replacing its scoped credential. Success clears pending downstream events and returns a joined acknowledgement. Pending upstream events still publish to the scope and channel recorded when they were accepted.
 */
export type EventChannelJoinFrame = {
    /**
     * Control-frame discriminator; always join.
     */
    type: 'join';
    /**
     * Channel name to join within the resulting scope, 1 to 256 bytes.
     */
    channel: string;
    /**
     * Optional unexpired channel token from a newly created connection URL, belonging to the connected user. Replaces the socket's scope and client identity; omit to retain both.
     */
    token?: string;
};

/**
 * Server acknowledgement sent on connection and after each successful join, before events with the new generation.
 */
export type EventChannelJoinedFrame = {
    /**
     * Control-frame discriminator; always joined.
     */
    type: 'joined';
    /**
     * Active receiving socket generation; 0 on connection, incremented after each successful join. Only process EphemeralEvent frames whose gen matches this value.
     */
    gen: number;
};

/**
 * Server error for an invalid frame, rejected join, or failed publication; the connection normally remains open.
 */
export type EventChannelErrorFrame = {
    /**
     * Control-frame discriminator; always error.
     */
    type: 'error';
    /**
     * Human-readable explanation of the validation, join, or publication failure.
     */
    message: string;
};

export type EventSourceId = {
    resource: ResourceType;
    id: string;
};

/**
 * Generic UI intent payload emitted for client-side actions such as focusing a resource.
 */
export type UiIntent = {
    type: 'focus_resource';
    resource: ResourceType;
    resource_id: string;
};

/**
 * Generic notification that content was successfully merged from one resource into another.
 */
export type ContentApplied = {
    source_resource: ResourceType;
    source_id: string;
    target_resource: ResourceType;
    target_id: string;
    target_revision: string;
};

/**
 * Notification that a caller-owned project copy operation has a newer durable revision.
 */
export type ProjectCopyProgress = {
    operation_id: string;
    revision: number;
    status: 'pending' | 'running' | 'cleanup_pending' | 'succeeded' | 'failed';
};

/**
 * Payload for TreeView update events, identifying which tree changed.
 */
export type TreeView = {
    /**
     * Context type of the tree view
     */
    type: 'org.project' | 'edit_session' | 'edit_session.thread';
    /**
     * ID of the context (Project ID, EditSession ID, or Thread ID)
     */
    id: string;
};

export const PresenceState = { VIEWING: 'viewing' } as const;

export type PresenceState = typeof PresenceState[keyof typeof PresenceState];

/**
 * One persisted project-presence observation.
 */
export type PresenceUpdate = {
    state: PresenceState;
    location_ref: string;
    metadata: {
        [key: string]: unknown;
    };
};

/**
 * Independent mutable settings, serialized to at most 512 KiB.
 */
export type ExternalRunSettings = {
    [key: string]: unknown;
};

export type ExternalRunSettingsUpdate = {
    set?: {
        [key: string]: unknown;
    };
    remove?: Array<string>;
};

export type ExternalRun = {
    id: string;
    project_id: string;
    scope_type: 'project' | 'edit_session' | 'thread';
    edit_session_id?: string | null;
    thread_id?: string | null;
    run_kind: string;
    input_version: string;
    /**
     * Serialized JSON representation is limited to 256 KiB; domain validation remains authoritative for byte size and whitespace-after-trim checks.
     */
    input_snapshot: {
        [key: string]: unknown;
    };
    settings: ExternalRunSettings;
    source_revision?: string | null;
    parent_run_id?: string | null;
    workspace_source_path?: string | null;
    workspace_output_base?: string | null;
    plugin_invocations?: Array<PluginInvocation>;
    workspace_transactions: Array<ExternalRunWorkspaceTransaction>;
    status: 'queued' | 'active' | 'succeeded' | 'failed' | 'cancelled';
    requester_id: string;
    create_ts: number;
    terminal_reason?: string | null;
    start_ts?: number | null;
    complete_ts?: number | null;
};

export type ExternalRunCreate = {
    run_kind: string;
    input_version: string;
    /**
     * Serialized JSON representation is limited to 256 KiB; domain validation remains authoritative for byte size and whitespace-after-trim checks.
     */
    input_snapshot: {
        [key: string]: unknown;
    };
    settings?: ExternalRunSettings;
    source_revision?: string | null;
    workspace_source_path?: string | null;
    workspace_output_base?: string | null;
    parent_run_id?: string | null;
    /**
     * Defaults to true; false creates a zero-transaction launch anchor.
     */
    create_workspace_transaction?: boolean;
    plugin_invocations?: Array<PluginInvocation>;
    /**
     * Optional workspace transaction lifetime in seconds, bounded to seven days.
     */
    workspace_expire_after_seconds?: number;
};

export type PluginInvocation = {
    plugin_id: string;
    script: string;
    function?: string | null;
};

export type ExternalRunWorkspaceTransactionCreate = {
    /**
     * Optional workspace transaction lifetime in seconds, bounded to seven days.
     */
    workspace_expire_after_seconds?: number;
};

export type ExternalRunWorkspaceTransaction = {
    id: string;
    create_ts: number;
    expire_ts: number;
    source_path?: string | null;
    promotion_path?: string | null;
};

export type ExternalRunCompletion = {
    status: 'succeeded' | 'failed';
    terminal_reason?: string | null;
};

export type ExternalRunRecord = {
    id: string;
    external_run_id: string;
    kind: string;
    media_type: string;
    create_ts: number;
};

export type Invitation = {
    /**
     * Unique invitation ID
     */
    id: string;
    resource_type: MembershipResourceType;
    /**
     * ID of the resource (organization or project)
     */
    resource_id: string;
    /**
     * Name of the resource (organization or project)
     */
    resource_name: string;
    /**
     * Invited email
     */
    email?: string;
    /**
     * ID of the invited user
     */
    user_id?: string;
    user?: User;
    role: Role;
    /**
     * Invitation token
     */
    token: string;
    /**
     * Expiration timestamp (Unix timestamp)
     */
    expires_ts: number;
    status: InvitationStatus;
    /**
     * Creation timestamp (Unix timestamp)
     */
    create_ts: number;
    /**
     * Usage timestamp (Unix timestamp)
     */
    use_ts?: number;
    created_by_user?: User;
};

export type InvitationAccept = {
    token: string;
};

export type InvitationDecline = InvitationAccept;

export type InvitationCreate = {
    /**
     * the target user email. Either email or user_id must be provided.
     */
    email?: string;
    /**
     * the target user. Either email or user_id must be provided. This takes precedence over email if both are provided.
     */
    user_id?: string;
    role: Role;
};

export type InvitationResource = {
    resource_type: MembershipResourceType;
    resource_name: string;
};

export type ProjectInviteLink = {
    id: string;
    project_id: string;
    project_name: string;
    description?: string;
    role: Role;
    token: string;
    expires_ts: number;
    link_revoked_ts?: number;
    link_use_count: number;
    link_last_use_ts?: number;
    link_invite_url: string;
    link_use_log: Array<ProjectInviteLinkUse>;
    create_ts: number;
    created_by_user?: User;
};

export type ProjectInviteLinkUse = {
    user_id: string;
    email: string;
    use_ts: number;
    result: 'created_membership' | 'reactivated_membership' | 'upgraded_role' | 'no_change';
    role_before?: Role;
    role_after: Role;
};

export type ProjectInviteLinkCreate = {
    role: Role;
    description?: string;
    /**
     * Optional expiration timestamp. Defaults to seven days from creation.
     */
    expires_ts?: number;
};

export type ProjectInviteLinkPreview = {
    project_id: string;
    project_name: string;
    role: Role;
    expires_ts: number;
};

export type Organization = BaseEntity & {
    /**
     * Organization name
     */
    name: string;
    /**
     * Archival timestamp (Unix timestamp)
     */
    archive_ts?: number;
};

export type Project = BaseEntity & {
    /**
     * Project name
     */
    name: string;
    /**
     * Project description
     */
    description?: string;
    /**
     * Organization ID
     */
    org_id: string;
    /**
     * Creator user ID
     */
    creator_id: string;
    /**
     * Archival timestamp (Unix timestamp)
     */
    archive_ts?: number;
    /**
     * Pre-signed download URL for the project thumbnail image, if one has been stored.
     */
    thumbnail_url?: string;
};

/**
 * The resource details (organization or project)
 */
export type MembershipResource = Organization | Project;

export type Membership = {
    /**
     * User ID
     */
    user_id: string;
    user?: User;
    resource_type: MembershipResourceType;
    /**
     * ID of the resource (organization or project)
     */
    resource_id: string;
    resource?: MembershipResource;
    role: Role;
    status: EntityStatus;
    /**
     * Whether this membership is synthesized from a broader membership. Omitted for concrete memberships.
     */
    inherited?: boolean;
    /**
     * Creation timestamp (Unix timestamp)
     */
    create_ts: number;
    /**
     * Last update timestamp (Unix timestamp)
     */
    update_ts: number;
};

export type MarketingImage = {
    blobId: string;
    displayName: string;
    mimeType: 'image/png' | 'image/jpeg' | 'image/webp';
    createdAt: string;
};

export type MarketingIngredient = {
    id: string;
    kind: 'character' | 'location' | 'prop' | 'title' | 'subtitle' | 'logo';
    /**
     * Display name captured when selected; preserved across branches.
     */
    label: string;
    /**
     * Story entity ID; intentionally not validated against the current branch.
     */
    referenceId?: string;
    text?: string;
    image?: MarketingImage;
};

export type MarketingSource = {
    type: 'edit-session' | 'thread';
    id: string;
    fileId: string;
};

export type MarketingDirection = {
    name: string;
    description: string;
    aspectRatio: '16:9' | '2:3' | '1:1';
    ingredients: Array<MarketingIngredient>;
    source: MarketingSource;
    basedOn?: string;
    image?: MarketingImage;
};

export type MarketingRecord = MarketingDirection & {
    id: string;
    createdAt: string;
};

export type MembershipUpdate = {
    role?: Role;
    status?: EntityStatus;
};

export const MembershipOrderBy = { VIEW: 'view' } as const;

export type MembershipOrderBy = typeof MembershipOrderBy[keyof typeof MembershipOrderBy];

export type OrganizationCreate = {
    name: string;
};

export type OrganizationUpdate = {
    name?: string;
};

export type TransferOwnershipRequest = {
    /**
     * User ID of the new owner
     */
    new_owner_id: string;
};

export type SkillInfo = {
    /**
     * Unique skill name.
     */
    name: string;
    /**
     * Short description of the skill.
     */
    description: string;
};

export type RunSkillScriptRequest = {
    /**
     * Relative path to the script file inside the selected skill or plugin root. Leading slashes are not allowed.
     */
    script: string;
    /**
     * Optional exported function to call instead of running the script directly.
     */
    function?: string;
    /**
     * Positional arguments passed to the skill runtime.
     */
    args?: Array<unknown>;
    /**
     * Optional execution timeout in milliseconds. Defaults to 30000; supplied values are clamped to 5000–900000. Pass 5000 for pure functions.
     */
    timeout_ms?: number;
    /**
     * Map of output keys to blob-save instructions. Each key appears in
     * `SkillRunResult.blobs` when the corresponding output is saved.
     *
     */
    save_result_blobs?: {
        [key: string]: SkillRunBlobOutputRequest;
    };
    /**
     * Optional ExternalRun request context for trusted plugin execution.
     */
    external_run_id?: string;
};

export type RunSkillBinaryRequest = {
    /**
     * Relative path to the binary file inside the selected skill or plugin root. Leading slashes are not allowed.
     */
    binary: string;
    /**
     * Positional arguments passed to the binary.
     */
    args?: Array<unknown>;
    /**
     * Optional execution timeout in milliseconds. Defaults to 30000; supplied values are clamped to 5000–900000. Pass 5000 for pure functions.
     */
    timeout_ms?: number;
    /**
     * Map of output keys to blob-save instructions. Each key appears in
     * `SkillRunResult.blobs` when the corresponding output is saved.
     *
     */
    save_result_blobs?: {
        [key: string]: SkillRunBlobOutputRequest;
    };
    /**
     * When true, the runtime parses YAML frontmatter from the binary's stdout.
     * Frontmatter must be the very first thing in stdout, fenced by "---" lines.
     * The reserved keys "cost" and "usage" (with sub-keys "prompt_tokens" and
     * "completion_tokens") are extracted into billing metadata and are not
     * returned to the caller. All other frontmatter keys are returned under the
     * "response" key in the result metadata.
     *
     * Auto-detection: if stdout starts with "---\nds_fm: true\n" (any line
     * ending), frontmatter is parsed automatically even when this flag is false.
     * This lets skills opt in without requiring the caller to set the flag.
     *
     */
    parse_frontmatter?: boolean;
};

/**
 * Execution kind.
 * - `script`: executes the script file directly as a program
 * - `script_function`: imports the script as a module and invokes the exported function named in `metadata.function`
 * - `binary`: executes a binary file
 *
 */
export const SkillExecutionKind = {
    SCRIPT: 'script',
    SCRIPT_FUNCTION: 'script_function',
    BINARY: 'binary'
} as const;

/**
 * Execution kind.
 * - `script`: executes the script file directly as a program
 * - `script_function`: imports the script as a module and invokes the exported function named in `metadata.function`
 * - `binary`: executes a binary file
 *
 */
export type SkillExecutionKind = typeof SkillExecutionKind[keyof typeof SkillExecutionKind];

export const SkillExecutionTargetKind = {
    ORG_PROJECT: 'org.project',
    EDIT_SESSION: 'edit_session',
    EDIT_SESSION_THREAD: 'edit_session.thread'
} as const;

export type SkillExecutionTargetKind = typeof SkillExecutionTargetKind[keyof typeof SkillExecutionTargetKind];

/**
 * Saves one skill output as a blob and returns it in the keyed `blobs` result map.
 */
export type SkillRunBlobOutputRequest = {
    /**
     * File name to expose on the saved blob and generated download URL.
     */
    name: string;
    /**
     * MIME type to store on the saved blob.
     */
    content_type: string;
    source: SkillRunBlobOutputSource;
    /**
     * Relative path under writable skill artifact root. Required when source is file.
     */
    file_path?: string;
    /**
     * If true, saved blob does not expire. Defaults to false, which keeps the temporary skill-output TTL.
     */
    durable?: boolean;
    /**
     * Applies only when source is file. If false or omitted, the source file is deleted from
     * ArtifactFS after every requested blob has been saved successfully. If true, the source
     * file remains available as an artifact.
     *
     */
    keep_file_as_artifact?: boolean;
};

export const SkillRunBlobOutputSource = { STDOUT: 'stdout', FILE: 'file' } as const;

export type SkillRunBlobOutputSource = typeof SkillRunBlobOutputSource[keyof typeof SkillRunBlobOutputSource];

export type SkillRunMetadata = {
    runtime?: string;
    skill_name?: string;
    script_name?: string;
    binary_name?: string;
    language?: string;
    function?: string;
    sandbox_mode?: string;
    working_directory?: string;
    [key: string]: unknown;
};

export type SkillRunBlobResult = {
    id: string;
    download_url: string;
    /**
     * Expiration timestamp for the download URL.
     */
    expires_ts: number;
    name: string;
    content_type: string;
    size: number;
    /**
     * Opaque short-lived proof attached to historical output blobs for their intended consuming operation. It is not a version selector.
     */
    execution_proof?: string;
};

export type SkillRunResult = {
    kind: SkillExecutionKind;
    target_kind: SkillExecutionTargetKind;
    target_id: string;
    skill_name: string;
    /**
     * Captured combined stdout/stderr content returned by the execution.
     */
    content: string;
    /**
     * Saved blob outputs keyed by the matching `save_result_blobs` request key.
     *
     */
    blobs?: {
        [key: string]: SkillRunBlobResult;
    };
    metadata: SkillRunMetadata;
    warnings?: Array<string>;
    duration_seconds: number;
};

export type PresenceCreate = {
    resource_type: ResourceType;
    resource_id: string;
    state?: PresenceState;
    /**
     * Required for project presence. Canonical project, edit-session, or thread location reference.
     */
    location_ref?: string;
    /**
     * Optional client metadata (at most 4096 serialized bytes). Omitted, null, and {} each replace metadata with {}.
     */
    metadata?: {
        [key: string]: unknown;
    } | null;
};

export type ProjectCreate = {
    /**
     * Project name
     */
    name: string;
    /**
     * Project description
     */
    description?: string;
    /**
     * ID of a project template to initialize the project from. If omitted, a blank project is created.
     */
    template_id?: string;
};

export type ProjectUpdate = {
    /**
     * Project name
     */
    name?: string;
    /**
     * Project description
     */
    description?: string;
    /**
     * ID of an existing blob scoped to this project to use as the thumbnail
     */
    thumbnail_blob_id?: string;
};

export type ProjectDuplicate = {
    /**
     * Name for the new (duplicate) project
     */
    name: string;
    /**
     * Description for the new project. Defaults to the source project's description when omitted.
     */
    description?: string;
    /**
     * Target organization ID. Defaults to the source project's organization when omitted.
     */
    org_id?: string;
};

export type ProjectCopyOperation = BaseEntity & {
    source_project_id: string;
    destination_project_id: string;
    status: 'pending' | 'running' | 'cleanup_pending' | 'succeeded' | 'failed';
    current_step?: string;
    completed_steps: Array<string>;
    progress: {
        [key: string]: unknown;
    };
    revision: number;
    result?: {
        [key: string]: unknown;
    };
    error?: string;
    cleanup_errors: Array<string>;
};

/**
 * JSON Pointer path to a subvalue within a structured value (e.g., \"/fields/0/name\")
 */
export type SubvaluePath = string;

export type StructuredTypeInfo = {
    fs_entry: FsEntry;
    /**
     * Type name (e.g., "Room", "Character")
     */
    name: string;
    /**
     * File extension for values of this type (e.g., ".room", ".character")
     */
    value_extension: string;
    /**
     * Content (fka. MIME) type for values of this type (e.g., "application/vnd.dreamstudio.value.room")
     */
    value_content_type: string;
    import_status: ImportStatus;
};

export type StructuredValueInfo = {
    fs_entry: FsEntry;
    /**
     * Type id for this value
     */
    type_id: string;
    import_status: ImportStatus;
};

export type SchemaForEditorResponse = {
    /**
     * JSON Schema with x-refCollection converted to enum/enumNames
     */
    schema: {
        [key: string]: unknown;
    };
    /**
     * UI Schema for SJSF (Svelte JSON Schema Form) derived from x-editor annotations
     * in the JSON Schema. Maps x-editor values to ui:components overrides, e.g.
     * x-editor: "textarea" → {"ui:components": {"textWidget": "textareaWidget"}}.
     *
     */
    ui_schema?: {
        [key: string]: unknown;
    };
    /**
     * JSON Pointer paths to accessed values for cache invalidation
     */
    dependencies: Array<string>;
    /**
     * The type file ID
     */
    type_id: string;
    /**
     * Human-readable type name
     */
    type_name: string;
};

export type BuildResult = {
    bundle_id: string;
    download_url: string;
};

export type ProjectTemplateSeedRequest = {
    /**
     * Branch to check out from the org's configured git repository. When omitted, the branch from the server-side GitSeed configuration is used.
     *
     */
    branch?: string;
};

export type ProjectTemplateGroup = {
    /**
     * ID of the organization that owns these templates
     */
    org_id: string;
    /**
     * Display name of the owning organization
     */
    org_name: string;
    templates: Array<ProjectTemplate>;
};

export type ProjectTemplate = BaseEntity & {
    /**
     * ID of the organization that owns this template
     */
    org_id: string;
    /**
     * Template display name
     */
    name: string;
    /**
     * Short description for the template card
     */
    description: string;
    /**
     * Cover image URL for the template card
     */
    image_url?: string;
    /**
     * Pre-deployed game URL for Preview/Play. If absent, no Preview button is shown.
     */
    play_url?: string;
};

export type ServiceAccount = BaseEntity & {
    name: string;
};

export type UsageReportRecord = {
    /**
     * Incurring Dream Studio user. Normal payer resolution applies; an active member of the target organization, of any role, uses that organization's billing account when one exists.
     */
    user_id: string;
    /**
     * Stable retry key, unique across every producer sharing this service account.
     */
    event_id: string;
    target: UsageReportTarget;
    type: 'llm' | 'tts' | 'stt' | 'translation';
    provider: string;
    outcome: 'success' | 'partial' | 'error';
    /**
     * Internal provider COGS in micro-USD. This is not customer spend.
     */
    cost_micro_usd: number;
    /**
     * TTS, STT, and translation records carry a nonempty `model`. LLM records use a registered `purpose`,
     * including `game_runtime` for runtime calls. TTS requires provider `inworld` or
     * `cartesia`, `purpose=speech_synthesis`, `modality=voice`, and explicit
     * `tts_characters`. STT requires provider `cartesia`, `purpose=speech_recognition`,
     * `modality=audio`, and explicit `audio_milliseconds`. Translation requires provider
     * `deepl`, `purpose=translation`, `modality=text`, and explicit `billable_characters`.
     * Character quantities are base-10 integers from 0 to 10,000,000; audio milliseconds
     * from 0 to 86,400,000 (24 hours). Missing quantities are invalid; explicit zero is valid.
     * Token counters (`tks_in`, `tks_in_cache_read`, `tks_in_cache_write`, `tks_out`,
     * `tks_out_reasoning`) are base-10 integers from 0 to 10,000,000 per record; a record
     * with a counter outside that range gets status `invalid`, its `detail` naming the counter.
     *
     */
    dimensions: {
        [key: string]: string;
    };
};

export type UsageReportTarget = {
    type: string;
    id: string;
    related?: Array<UsageReportResourceRef>;
};

export type UsageReportResourceRef = {
    type: string;
    id: string;
};

export type UsageCreditsAvailable = {
    /**
     * The payer has Dream Bucks left; false when they ran out (no billing set up is a 402
     * instead). Always true on a server with billing off.
     *
     */
    credits_available: boolean;
    payer?: BillingPayer;
};

export type UsageReportResult = {
    event_id: string;
    status: 'inserted' | 'replayed' | 'conflict' | 'invalid';
    detail?: string;
};

export type UsageSummaryBase = {
    /**
     * Inclusive normalized range start as Unix seconds.
     */
    from_ts: number;
    /**
     * Exclusive normalized range end as Unix seconds.
     */
    to_ts: number;
    /**
     * Always true until usage periods can be settled: figures for any period can still
     * change (late capture or transmission, an operator correction).
     *
     */
    is_partial: boolean;
    /**
     * Interim local Dream Bucks figure for the requested scope and range, from raw ledger quantities × each record's payer contract rates in Metronome. It is not customer debt.
     */
    totals: Array<UsageQuantity>;
    /**
     * Ledger snapshot or high-water timestamp represented by this summary.
     */
    usage_as_of_ts: number;
};

export type OrgUsageSummary = UsageSummaryBase & {
    /**
     * Breakdown for every project with captured usage in the range, ordered by
     * current project name (case-insensitive) and then project ID. Attribution
     * remains immutable even if the display name later changes.
     *
     */
    projects: Array<ProjectUsageBreakdown>;
};

export type ProjectUsageSummary = UsageSummaryBase;

export type ProjectUsageBreakdown = {
    /**
     * Immutable project attribution copied onto captured usage rows.
     */
    project_id: string;
    /**
     * Current project display name; historical usage rows are not rewritten on rename.
     */
    project_name: string;
    quantities: Array<UsageQuantity>;
};

export type ChatBranchUsageSummary = {
    /**
     * Always true until usage periods can be settled: figures can still change (late
     * capture or transmission, an operator correction).
     *
     */
    is_partial: boolean;
    /**
     * True when the branch has more usage than one read counts: only its latest 1,000
     * messages and, of their usage, the latest 10,000 inference records are counted.
     * Older usage is then left out of `totals` and `messages` (it counts as 0), so the
     * figures are a lower bound.
     *
     */
    is_truncated: boolean;
    /**
     * Interim local Dream Bucks figure for the branch's visible messages. It is not customer
     * debt. Absent when billing is disabled on this server, since Dream Bucks are rated from
     * payer contracts.
     *
     */
    totals?: Array<UsageQuantity>;
    cost_micro_usd?: UsageProviderCostMicroUsd;
    /**
     * Every visible message with usage, in transcript order.
     */
    messages: Array<ChatMessageUsage>;
    /**
     * Ledger snapshot or high-water timestamp represented by this summary.
     */
    usage_as_of_ts: number;
};

export type ChatMessageUsage = {
    chat_message_id: string;
    /**
     * Absent when billing is disabled on this server, like the branch `totals`.
     */
    quantities?: Array<UsageQuantity>;
    cost_micro_usd?: UsageProviderCostMicroUsd;
};

/**
 * Provider cost (COGS) of the same usage in micro-USD, for development. Present only
 * outside production, where it would expose business data; never show it to customers.
 *
 */
export type UsageProviderCostMicroUsd = number;

export type UsageHistoryBucket = {
    /**
     * Inclusive UTC-aligned bucket start as Unix seconds.
     */
    from_ts: number;
    /**
     * Exclusive UTC-aligned bucket end as Unix seconds.
     */
    to_ts: number;
    /**
     * Interim local Dream Bucks figure for the usage captured in this bucket, from raw ledger quantities × each record's payer contract rates in Metronome. It is not customer debt.
     */
    quantities: Array<UsageQuantity>;
};

export type UsageHistoryResponse = ListResponseBase & {
    items: Array<UsageHistoryBucket>;
};

export type PublicUser = {
    id: string;
    /**
     * User name
     */
    name: string;
    /**
     * User nickname
     */
    nickname: string;
    /**
     * Optional short-lived signed avatar URL. Not populated when a user is embedded in a membership or invitation response; use /users/{id}/avatar to resolve it.
     */
    avatar_url?: string;
};

export type UserUpdate = {
    /**
     * User name
     */
    name?: string;
    /**
     * User email
     */
    email?: string;
    status?: EntityStatus;
};

/**
 * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
 * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
 *
 */
export type HistoricalVersionId = string;

/**
 * Version of the DreamStudio client, set by the client application.
 * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
 * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
 * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
 *
 */
export type XdsVersionHeader = string;

/**
 * RFC 7239 forwarded metadata from a trusted reverse proxy.
 * Example: for=203.0.113.10;proto=https;host=example.com
 *
 */
export type ForwardedHeader = string;

/**
 * Original client-facing scheme set by a trusted proxy (for example, `https`).
 */
export type XForwardedProtoHeader = string;

/**
 * Original client-facing host set by a trusted proxy.
 */
export type XForwardedHostHeader = string;

/**
 * Original client-facing port set by a trusted proxy.
 */
export type XForwardedPortHeader = string;

/**
 * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
 */
export type XForwardedPrefixHeader = string;

/**
 * Maximum number of items to return per page.
 *
 * This parameter is only valid on the initial request. When using `cursor`,
 * the page size is encoded in the cursor and this parameter must be omitted.
 *
 */
export type PaginationPageSize = number;

/**
 * Opaque pagination cursor from a previous response (`previous_cursor` or `next_cursor`).
 *
 * **Usage Pattern:**
 * - First request: Omit `cursor`, provide `page_size` and any filters
 * - Subsequent requests: Provide only `cursor`, omit all other parameters
 *
 * The cursor encodes all request state (filters, page_size, position), so when
 * using a cursor, do not include any other parameters. Providing `cursor` with
 * `page_size`, `around`, or any filter returns `422 Unprocessable Entity`.
 *
 * Cursors are opaque strings - do not parse or construct them. They may expire
 * after extended periods; start fresh pagination for new sessions.
 *
 */
export type PaginationCursor = string;

/**
 * Item ID to center results around (for "jump to item" scenarios).
 *
 * When provided, returns approximately `page_size/2` items before and after the
 * specified item. Both `previous_cursor` and `next_cursor` will be returned,
 * enabling bidirectional scrolling from that position.
 *
 * **Example Use Case:** Opening a chat from a notification - use `around` with the
 * message ID from the notification to load messages centered on that message.
 *
 * Can be combined with `page_size` and endpoint-specific filters.
 *
 */
export type PaginationAround = string;

/**
 * Project ancestry for the ArtifactFS scope that owns the transaction.
 */
export type AgenticArtifactProjectId = string;

/**
 * Opaque agentic artifact workspace transaction identifier.
 */
export type TransactionId = string;

export type AgenticArtifactEditSessionId = string;

export type AgenticArtifactThreadId = string;

/**
 * Standard HTTP Range header for partial content requests.
 */
export type RangeHeader = string;

/**
 * Organization whose billing resource is requested.
 */
export type BillingOrgId = string;

/**
 * User whose billing resource is requested. Canonical user billing operations require a self-check.
 */
export type BillingUserId = string;

/**
 * Client-minted Dream Studio payment-method setup attempt ID.
 */
export type BillingAttemptId = string;

/**
 * Client-minted Dream Studio purchase attempt ID.
 */
export type BillingPurchaseAttemptId = string;

/**
 * Public Stripe PaymentMethod ID, verified against the organization before use.
 */
export type BillingPaymentMethodId = string;

/**
 * Public Stripe Invoice ID, verified against the organization before use.
 */
export type BillingInvoiceId = string;

export type ExternalRunProjectId = string;

export type ExternalRunEditSessionId = string;

export type ExternalRunThreadId = string;

export type ExternalRunId = string;

export type ExternalRunRecordKind = string;

export type ExternalRunListParentRunId = string;

export type ExternalRunListRunKind = string;

export const ExternalRunListStatus = {
    QUEUED: 'queued',
    ACTIVE: 'active',
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    CANCELLED: 'cancelled'
} as const;

export type ExternalRunListStatus = typeof ExternalRunListStatus[keyof typeof ExternalRunListStatus];

export type ExternalRunListRequesterId = string;

export type ExternalRunListLimit = number;

export type ExternalRunListOffset = number;

/**
 * Also list the project's edit-session and thread runs, each with its own scope.
 */
export type ExternalRunListIncludeAllScopes = boolean;

/**
 * JSON-encoded object used for JSONB containment; at most 256 KiB.
 */
export type ExternalRunListInputSnapshotContains = string;

export type MarketingProjectId = string;

/**
 * Filter memberships by archived (`true`) / non-archived (`false`) resources (default: non-archived / `false`)
 */
export type ArchivedResourceQueryParam = boolean;

/**
 * The ID of the project.
 */
export type SkillProjId = string;

/**
 * The ID of the edit session.
 */
export type SkillEsId = string;

/**
 * The ID of the edit session thread.
 */
export type SkillThreadId = string;

/**
 * Exact skill name.
 */
export type SkillName = string;

/**
 * Current trusted plugin identifier.
 */
export type SkillPluginId = string;

export type ProjId = string;

export type EsId = string;

export type ThreadId = string;

export type TypeId = string;

export type ValueId = string;

/**
 * Include resolved references (default false)
 */
export type ResolveRefs = boolean;

/**
 * Include validation results (default false)
 */
export type Validate = boolean;

/**
 * Include file metadata (default true)
 */
export type Metadata = boolean;

/**
 * Organization whose captured usage is requested.
 */
export type UsageOrgId = string;

/**
 * The project the usage is for. Its organization pays when the user is an active member
 * and the organization has billing; otherwise, and without a project, the user pays.
 *
 */
export type UsageCreditsProjectId = string;

/**
 * Project whose captured usage is requested.
 */
export type UsageProjectId = string;

/**
 * Chat branch whose visible messages' usage is requested.
 */
export type UsageChatBranchId = string;

/**
 * Incurring user whose captured usage is requested.
 */
export type UsageUserId = string;

/**
 * Inclusive lower bound of the usage range as Unix seconds, with optional subsecond
 * precision. Supply with `to_ts`; omit both for the current UTC calendar
 * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
 * request; omit when using `cursor`.
 *
 */
export type UsageFromTs = number;

/**
 * Exclusive upper bound of the usage range as Unix seconds, with optional subsecond
 * precision. Supply with `from_ts`; omit both for the current UTC calendar
 * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
 * request; omit when using `cursor`.
 *
 */
export type UsageToTs = number;

/**
 * UTC-aligned history bucket width. Valid only on an initial request; omit when
 * using `cursor`, which carries the original granularity.
 *
 */
export const UsageGranularity = { HOUR: 'hour', DAY: 'day' } as const;

/**
 * UTC-aligned history bucket width. Valid only on an initial request; omit when
 * using `cursor`, which carries the original granularity.
 *
 */
export type UsageGranularity = typeof UsageGranularity[keyof typeof UsageGranularity];

export type GetHealthData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/health';
};

export type GetHealthErrors = {
    /**
     * Internal server error
     */
    500: Error;
};

export type GetHealthError = GetHealthErrors[keyof GetHealthErrors];

export type GetHealthResponses = {
    /**
     * OK
     */
    200: {
        status?: string;
    };
};

export type GetHealthResponse = GetHealthResponses[keyof GetHealthResponses];

export type ListProjectAgenticArtifactsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
    };
    query?: {
        path?: string;
    };
    url: '/projects/{project_id}/agentic-artifacts';
};

export type ListProjectAgenticArtifactsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProjectAgenticArtifactsError = ListProjectAgenticArtifactsErrors[keyof ListProjectAgenticArtifactsErrors];

export type ListProjectAgenticArtifactsResponses = {
    /**
     * Artifact entry and its contents if it is a directory
     */
    200: ArtifactListResponse;
};

export type ListProjectAgenticArtifactsResponse = ListProjectAgenticArtifactsResponses[keyof ListProjectAgenticArtifactsResponses];

export type GetProjectAgenticArtifactContentData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
    };
    query: {
        /**
         * Relative path to the file or directory. Pass '.' to download the whole ArtifactFS root.
         */
        path: string;
        /**
         * Optional glob pattern to include specific files (can be repeated, e.g. include=*.go). Evaluated against relative paths using '/' separator. Only used when downloading a directory.
         */
        include?: Array<string>;
        /**
         * Optional glob pattern to exclude specific files (can be repeated, e.g. exclude=*.tmp). Evaluated against relative paths using '/' separator. Only used when downloading a directory.
         */
        exclude?: Array<string>;
    };
    url: '/projects/{project_id}/agentic-artifacts/content';
};

export type GetProjectAgenticArtifactContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetProjectAgenticArtifactContentError = GetProjectAgenticArtifactContentErrors[keyof GetProjectAgenticArtifactContentErrors];

export type SearchProjectAgenticArtifactsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
    };
    query: {
        q: string;
        path?: string;
        context_lines?: number;
    };
    url: '/projects/{project_id}/agentic-artifacts/search';
};

export type SearchProjectAgenticArtifactsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type SearchProjectAgenticArtifactsError = SearchProjectAgenticArtifactsErrors[keyof SearchProjectAgenticArtifactsErrors];

export type SearchProjectAgenticArtifactsResponses = {
    /**
     * Search results
     */
    200: Array<ArtifactSearchMatch>;
};

export type SearchProjectAgenticArtifactsResponse = SearchProjectAgenticArtifactsResponses[keyof SearchProjectAgenticArtifactsResponses];

export type ListEditSessionAgenticArtifactsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: {
        path?: string;
    };
    url: '/edit-sessions/{es_id}/agentic-artifacts';
};

export type ListEditSessionAgenticArtifactsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListEditSessionAgenticArtifactsError = ListEditSessionAgenticArtifactsErrors[keyof ListEditSessionAgenticArtifactsErrors];

export type ListEditSessionAgenticArtifactsResponses = {
    /**
     * Artifact entry and its contents if it is a directory
     */
    200: ArtifactListResponse;
};

export type ListEditSessionAgenticArtifactsResponse = ListEditSessionAgenticArtifactsResponses[keyof ListEditSessionAgenticArtifactsResponses];

export type GetEditSessionAgenticArtifactContentData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query: {
        /**
         * Relative path to the file or directory. Pass '.' to download the whole ArtifactFS root.
         */
        path: string;
        /**
         * Optional glob pattern to include specific files (can be repeated, e.g. include=*.go). Evaluated against relative paths using '/' separator. Only used when downloading a directory.
         */
        include?: Array<string>;
        /**
         * Optional glob pattern to exclude specific files (can be repeated, e.g. exclude=*.tmp). Evaluated against relative paths using '/' separator. Only used when downloading a directory.
         */
        exclude?: Array<string>;
    };
    url: '/edit-sessions/{es_id}/agentic-artifacts/content';
};

export type GetEditSessionAgenticArtifactContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionAgenticArtifactContentError = GetEditSessionAgenticArtifactContentErrors[keyof GetEditSessionAgenticArtifactContentErrors];

export type SearchEditSessionAgenticArtifactsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query: {
        q: string;
        path?: string;
        context_lines?: number;
    };
    url: '/edit-sessions/{es_id}/agentic-artifacts/search';
};

export type SearchEditSessionAgenticArtifactsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type SearchEditSessionAgenticArtifactsError = SearchEditSessionAgenticArtifactsErrors[keyof SearchEditSessionAgenticArtifactsErrors];

export type SearchEditSessionAgenticArtifactsResponses = {
    /**
     * Search results
     */
    200: Array<ArtifactSearchMatch>;
};

export type SearchEditSessionAgenticArtifactsResponse = SearchEditSessionAgenticArtifactsResponses[keyof SearchEditSessionAgenticArtifactsResponses];

export type ListThreadAgenticArtifactsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: {
        path?: string;
    };
    url: '/edit-session-threads/{thread_id}/agentic-artifacts';
};

export type ListThreadAgenticArtifactsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListThreadAgenticArtifactsError = ListThreadAgenticArtifactsErrors[keyof ListThreadAgenticArtifactsErrors];

export type ListThreadAgenticArtifactsResponses = {
    /**
     * Artifact entry and its contents if it is a directory
     */
    200: ArtifactListResponse;
};

export type ListThreadAgenticArtifactsResponse = ListThreadAgenticArtifactsResponses[keyof ListThreadAgenticArtifactsResponses];

export type GetThreadAgenticArtifactContentData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query: {
        /**
         * Relative path to the file or directory. Pass '.' to download the whole ArtifactFS root.
         */
        path: string;
        /**
         * Optional glob pattern to include specific files (can be repeated, e.g. include=*.go). Evaluated against relative paths using '/' separator. Only used when downloading a directory.
         */
        include?: Array<string>;
        /**
         * Optional glob pattern to exclude specific files (can be repeated, e.g. exclude=*.tmp). Evaluated against relative paths using '/' separator. Only used when downloading a directory.
         */
        exclude?: Array<string>;
    };
    url: '/edit-session-threads/{thread_id}/agentic-artifacts/content';
};

export type GetThreadAgenticArtifactContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadAgenticArtifactContentError = GetThreadAgenticArtifactContentErrors[keyof GetThreadAgenticArtifactContentErrors];

export type SearchThreadAgenticArtifactsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query: {
        q: string;
        path?: string;
        context_lines?: number;
    };
    url: '/edit-session-threads/{thread_id}/agentic-artifacts/search';
};

export type SearchThreadAgenticArtifactsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type SearchThreadAgenticArtifactsError = SearchThreadAgenticArtifactsErrors[keyof SearchThreadAgenticArtifactsErrors];

export type SearchThreadAgenticArtifactsResponses = {
    /**
     * Search results
     */
    200: Array<ArtifactSearchMatch>;
};

export type SearchThreadAgenticArtifactsResponse = SearchThreadAgenticArtifactsResponses[keyof SearchThreadAgenticArtifactsResponses];

export type GetAgenticArtifactContentByTokenData = {
    body?: never;
    headers?: {
        /**
         * Standard HTTP Range header for partial content requests.
         */
        Range?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query: {
        /**
         * Signed token representing the download request
         */
        token: string;
    };
    url: '/agentic-artifacts/download';
};

export type GetAgenticArtifactContentByTokenErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Range Not Satisfiable. Returned when the requested byte range is out of bounds for the file.
     */
    416: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetAgenticArtifactContentByTokenError = GetAgenticArtifactContentByTokenErrors[keyof GetAgenticArtifactContentByTokenErrors];

export type GetAgenticArtifactContentByTokenResponses = {
    /**
     * Full file content stream or zipped directory package.
     */
    200: Blob | File;
    /**
     * Partial file content stream.
     */
    206: Blob | File;
};

export type GetAgenticArtifactContentByTokenResponse = GetAgenticArtifactContentByTokenResponses[keyof GetAgenticArtifactContentByTokenResponses];

export type BeginProjectAgenticArtifactWorkspaceTransactionData = {
    body?: BeginWorkspaceTransactionRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Project ancestry for the ArtifactFS scope that owns the transaction.
         */
        project_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/agentic-artifacts/workspace-transactions';
};

export type BeginProjectAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BeginProjectAgenticArtifactWorkspaceTransactionError = BeginProjectAgenticArtifactWorkspaceTransactionErrors[keyof BeginProjectAgenticArtifactWorkspaceTransactionErrors];

export type BeginProjectAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction created
     */
    201: WorkspaceTransaction;
};

export type BeginProjectAgenticArtifactWorkspaceTransactionResponse = BeginProjectAgenticArtifactWorkspaceTransactionResponses[keyof BeginProjectAgenticArtifactWorkspaceTransactionResponses];

export type AbortProjectAgenticArtifactWorkspaceTransactionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Project ancestry for the ArtifactFS scope that owns the transaction.
         */
        project_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}';
};

export type AbortProjectAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type AbortProjectAgenticArtifactWorkspaceTransactionError = AbortProjectAgenticArtifactWorkspaceTransactionErrors[keyof AbortProjectAgenticArtifactWorkspaceTransactionErrors];

export type AbortProjectAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction aborted
     */
    204: void;
};

export type AbortProjectAgenticArtifactWorkspaceTransactionResponse = AbortProjectAgenticArtifactWorkspaceTransactionResponses[keyof AbortProjectAgenticArtifactWorkspaceTransactionResponses];

export type GetProjectAgenticArtifactWorkspaceTransactionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Project ancestry for the ArtifactFS scope that owns the transaction.
         */
        project_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}';
};

export type GetProjectAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetProjectAgenticArtifactWorkspaceTransactionError = GetProjectAgenticArtifactWorkspaceTransactionErrors[keyof GetProjectAgenticArtifactWorkspaceTransactionErrors];

export type GetProjectAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction status
     */
    200: WorkspaceTransaction;
};

export type GetProjectAgenticArtifactWorkspaceTransactionResponse = GetProjectAgenticArtifactWorkspaceTransactionResponses[keyof GetProjectAgenticArtifactWorkspaceTransactionResponses];

export type TouchProjectAgenticArtifactWorkspaceTransactionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Project ancestry for the ArtifactFS scope that owns the transaction.
         */
        project_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}/touch';
};

export type TouchProjectAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type TouchProjectAgenticArtifactWorkspaceTransactionError = TouchProjectAgenticArtifactWorkspaceTransactionErrors[keyof TouchProjectAgenticArtifactWorkspaceTransactionErrors];

export type TouchProjectAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction activity recorded
     */
    200: WorkspaceTransaction;
};

export type TouchProjectAgenticArtifactWorkspaceTransactionResponse = TouchProjectAgenticArtifactWorkspaceTransactionResponses[keyof TouchProjectAgenticArtifactWorkspaceTransactionResponses];

export type GetProjectAgenticArtifactWorkspaceTransactionContentData = {
    body?: never;
    headers?: {
        /**
         * Standard HTTP Range header for partial content requests.
         */
        Range?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Project ancestry for the ArtifactFS scope that owns the transaction.
         */
        project_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query: {
        /**
         * Relative path to the regular file inside the transaction root.
         */
        path: string;
    };
    url: '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}/content';
};

export type GetProjectAgenticArtifactWorkspaceTransactionContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Range Not Satisfiable. Returned when the requested byte range is out of bounds for the file.
     */
    416: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetProjectAgenticArtifactWorkspaceTransactionContentError = GetProjectAgenticArtifactWorkspaceTransactionContentErrors[keyof GetProjectAgenticArtifactWorkspaceTransactionContentErrors];

export type GetProjectAgenticArtifactWorkspaceTransactionContentResponses = {
    /**
     * Full file content stream.
     */
    200: Blob | File;
    /**
     * Partial file content stream.
     */
    206: Blob | File;
};

export type GetProjectAgenticArtifactWorkspaceTransactionContentResponse = GetProjectAgenticArtifactWorkspaceTransactionContentResponses[keyof GetProjectAgenticArtifactWorkspaceTransactionContentResponses];

export type ListProjectAgenticArtifactWorkspaceTransactionEntriesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Project ancestry for the ArtifactFS scope that owns the transaction.
         */
        project_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: {
        /**
         * Relative directory or file path inside the transaction root.
         */
        path?: string;
        recursive?: boolean;
        /**
         * Include SHA-256 values for regular files.
         */
        include_sha256?: boolean;
    };
    url: '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}/entries';
};

export type ListProjectAgenticArtifactWorkspaceTransactionEntriesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProjectAgenticArtifactWorkspaceTransactionEntriesError = ListProjectAgenticArtifactWorkspaceTransactionEntriesErrors[keyof ListProjectAgenticArtifactWorkspaceTransactionEntriesErrors];

export type ListProjectAgenticArtifactWorkspaceTransactionEntriesResponses = {
    /**
     * Entries in the transaction's private root
     */
    200: WorkspaceTransactionEntries;
};

export type ListProjectAgenticArtifactWorkspaceTransactionEntriesResponse = ListProjectAgenticArtifactWorkspaceTransactionEntriesResponses[keyof ListProjectAgenticArtifactWorkspaceTransactionEntriesResponses];

export type ApplyProjectAgenticArtifactWorkspaceTransactionPatchData = {
    /**
     * UTF-8 Git-compatible unified diff containing one or more files.
     */
    body: string;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Project ancestry for the ArtifactFS scope that owns the transaction.
         */
        project_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}/patches';
};

export type ApplyProjectAgenticArtifactWorkspaceTransactionPatchErrors = {
    /**
     * Malformed or unsupported unified diff
     */
    400: WorkspacePatchConflictResponse;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * One or more hunks conflict with the current private root
     */
    409: WorkspacePatchConflictResponse;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ApplyProjectAgenticArtifactWorkspaceTransactionPatchError = ApplyProjectAgenticArtifactWorkspaceTransactionPatchErrors[keyof ApplyProjectAgenticArtifactWorkspaceTransactionPatchErrors];

export type ApplyProjectAgenticArtifactWorkspaceTransactionPatchResponses = {
    /**
     * Complete diff applied to the private transaction root
     */
    200: WorkspacePatchResult;
};

export type ApplyProjectAgenticArtifactWorkspaceTransactionPatchResponse = ApplyProjectAgenticArtifactWorkspaceTransactionPatchResponses[keyof ApplyProjectAgenticArtifactWorkspaceTransactionPatchResponses];

export type PromoteProjectAgenticArtifactWorkspaceTransactionData = {
    body: PromoteWorkspaceTransactionRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Project ancestry for the ArtifactFS scope that owns the transaction.
         */
        project_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}/promote';
};

export type PromoteProjectAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type PromoteProjectAgenticArtifactWorkspaceTransactionError = PromoteProjectAgenticArtifactWorkspaceTransactionErrors[keyof PromoteProjectAgenticArtifactWorkspaceTransactionErrors];

export type PromoteProjectAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction promoted
     */
    200: WorkspacePromotionResult;
};

export type PromoteProjectAgenticArtifactWorkspaceTransactionResponse = PromoteProjectAgenticArtifactWorkspaceTransactionResponses[keyof PromoteProjectAgenticArtifactWorkspaceTransactionResponses];

export type BeginEditSessionAgenticArtifactWorkspaceTransactionData = {
    body?: BeginWorkspaceTransactionRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions';
};

export type BeginEditSessionAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BeginEditSessionAgenticArtifactWorkspaceTransactionError = BeginEditSessionAgenticArtifactWorkspaceTransactionErrors[keyof BeginEditSessionAgenticArtifactWorkspaceTransactionErrors];

export type BeginEditSessionAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction created
     */
    201: WorkspaceTransaction;
};

export type BeginEditSessionAgenticArtifactWorkspaceTransactionResponse = BeginEditSessionAgenticArtifactWorkspaceTransactionResponses[keyof BeginEditSessionAgenticArtifactWorkspaceTransactionResponses];

export type AbortEditSessionAgenticArtifactWorkspaceTransactionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}';
};

export type AbortEditSessionAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type AbortEditSessionAgenticArtifactWorkspaceTransactionError = AbortEditSessionAgenticArtifactWorkspaceTransactionErrors[keyof AbortEditSessionAgenticArtifactWorkspaceTransactionErrors];

export type AbortEditSessionAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction aborted
     */
    204: void;
};

export type AbortEditSessionAgenticArtifactWorkspaceTransactionResponse = AbortEditSessionAgenticArtifactWorkspaceTransactionResponses[keyof AbortEditSessionAgenticArtifactWorkspaceTransactionResponses];

export type GetEditSessionAgenticArtifactWorkspaceTransactionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}';
};

export type GetEditSessionAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionAgenticArtifactWorkspaceTransactionError = GetEditSessionAgenticArtifactWorkspaceTransactionErrors[keyof GetEditSessionAgenticArtifactWorkspaceTransactionErrors];

export type GetEditSessionAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction status
     */
    200: WorkspaceTransaction;
};

export type GetEditSessionAgenticArtifactWorkspaceTransactionResponse = GetEditSessionAgenticArtifactWorkspaceTransactionResponses[keyof GetEditSessionAgenticArtifactWorkspaceTransactionResponses];

export type TouchEditSessionAgenticArtifactWorkspaceTransactionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}/touch';
};

export type TouchEditSessionAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type TouchEditSessionAgenticArtifactWorkspaceTransactionError = TouchEditSessionAgenticArtifactWorkspaceTransactionErrors[keyof TouchEditSessionAgenticArtifactWorkspaceTransactionErrors];

export type TouchEditSessionAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction activity recorded
     */
    200: WorkspaceTransaction;
};

export type TouchEditSessionAgenticArtifactWorkspaceTransactionResponse = TouchEditSessionAgenticArtifactWorkspaceTransactionResponses[keyof TouchEditSessionAgenticArtifactWorkspaceTransactionResponses];

export type GetEditSessionAgenticArtifactWorkspaceTransactionContentData = {
    body?: never;
    headers?: {
        /**
         * Standard HTTP Range header for partial content requests.
         */
        Range?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query: {
        path: string;
    };
    url: '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}/content';
};

export type GetEditSessionAgenticArtifactWorkspaceTransactionContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Range Not Satisfiable
     */
    416: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionAgenticArtifactWorkspaceTransactionContentError = GetEditSessionAgenticArtifactWorkspaceTransactionContentErrors[keyof GetEditSessionAgenticArtifactWorkspaceTransactionContentErrors];

export type GetEditSessionAgenticArtifactWorkspaceTransactionContentResponses = {
    /**
     * Full file content stream
     */
    200: Blob | File;
    /**
     * Partial file content stream
     */
    206: Blob | File;
};

export type GetEditSessionAgenticArtifactWorkspaceTransactionContentResponse = GetEditSessionAgenticArtifactWorkspaceTransactionContentResponses[keyof GetEditSessionAgenticArtifactWorkspaceTransactionContentResponses];

export type ListEditSessionAgenticArtifactWorkspaceTransactionEntriesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: {
        path?: string;
        recursive?: boolean;
        include_sha256?: boolean;
    };
    url: '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}/entries';
};

export type ListEditSessionAgenticArtifactWorkspaceTransactionEntriesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListEditSessionAgenticArtifactWorkspaceTransactionEntriesError = ListEditSessionAgenticArtifactWorkspaceTransactionEntriesErrors[keyof ListEditSessionAgenticArtifactWorkspaceTransactionEntriesErrors];

export type ListEditSessionAgenticArtifactWorkspaceTransactionEntriesResponses = {
    /**
     * Entries in the transaction's private root
     */
    200: WorkspaceTransactionEntries;
};

export type ListEditSessionAgenticArtifactWorkspaceTransactionEntriesResponse = ListEditSessionAgenticArtifactWorkspaceTransactionEntriesResponses[keyof ListEditSessionAgenticArtifactWorkspaceTransactionEntriesResponses];

export type ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchData = {
    body: string;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}/patches';
};

export type ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchErrors = {
    /**
     * Malformed or unsupported unified diff
     */
    400: WorkspacePatchConflictResponse;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Patch conflict
     */
    409: WorkspacePatchConflictResponse;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchError = ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchErrors[keyof ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchErrors];

export type ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchResponses = {
    /**
     * Patch applied
     */
    200: WorkspacePatchResult;
};

export type ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchResponse = ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchResponses[keyof ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchResponses];

export type PromoteEditSessionAgenticArtifactWorkspaceTransactionData = {
    body: PromoteWorkspaceTransactionRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}/promote';
};

export type PromoteEditSessionAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type PromoteEditSessionAgenticArtifactWorkspaceTransactionError = PromoteEditSessionAgenticArtifactWorkspaceTransactionErrors[keyof PromoteEditSessionAgenticArtifactWorkspaceTransactionErrors];

export type PromoteEditSessionAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction promoted
     */
    200: WorkspacePromotionResult;
};

export type PromoteEditSessionAgenticArtifactWorkspaceTransactionResponse = PromoteEditSessionAgenticArtifactWorkspaceTransactionResponses[keyof PromoteEditSessionAgenticArtifactWorkspaceTransactionResponses];

export type BeginThreadAgenticArtifactWorkspaceTransactionData = {
    body?: BeginWorkspaceTransactionRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions';
};

export type BeginThreadAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BeginThreadAgenticArtifactWorkspaceTransactionError = BeginThreadAgenticArtifactWorkspaceTransactionErrors[keyof BeginThreadAgenticArtifactWorkspaceTransactionErrors];

export type BeginThreadAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction created
     */
    201: WorkspaceTransaction;
};

export type BeginThreadAgenticArtifactWorkspaceTransactionResponse = BeginThreadAgenticArtifactWorkspaceTransactionResponses[keyof BeginThreadAgenticArtifactWorkspaceTransactionResponses];

export type AbortThreadAgenticArtifactWorkspaceTransactionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}';
};

export type AbortThreadAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type AbortThreadAgenticArtifactWorkspaceTransactionError = AbortThreadAgenticArtifactWorkspaceTransactionErrors[keyof AbortThreadAgenticArtifactWorkspaceTransactionErrors];

export type AbortThreadAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction aborted
     */
    204: void;
};

export type AbortThreadAgenticArtifactWorkspaceTransactionResponse = AbortThreadAgenticArtifactWorkspaceTransactionResponses[keyof AbortThreadAgenticArtifactWorkspaceTransactionResponses];

export type GetThreadAgenticArtifactWorkspaceTransactionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}';
};

export type GetThreadAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadAgenticArtifactWorkspaceTransactionError = GetThreadAgenticArtifactWorkspaceTransactionErrors[keyof GetThreadAgenticArtifactWorkspaceTransactionErrors];

export type GetThreadAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction status
     */
    200: WorkspaceTransaction;
};

export type GetThreadAgenticArtifactWorkspaceTransactionResponse = GetThreadAgenticArtifactWorkspaceTransactionResponses[keyof GetThreadAgenticArtifactWorkspaceTransactionResponses];

export type TouchThreadAgenticArtifactWorkspaceTransactionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}/touch';
};

export type TouchThreadAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type TouchThreadAgenticArtifactWorkspaceTransactionError = TouchThreadAgenticArtifactWorkspaceTransactionErrors[keyof TouchThreadAgenticArtifactWorkspaceTransactionErrors];

export type TouchThreadAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction activity recorded
     */
    200: WorkspaceTransaction;
};

export type TouchThreadAgenticArtifactWorkspaceTransactionResponse = TouchThreadAgenticArtifactWorkspaceTransactionResponses[keyof TouchThreadAgenticArtifactWorkspaceTransactionResponses];

export type GetThreadAgenticArtifactWorkspaceTransactionContentData = {
    body?: never;
    headers?: {
        /**
         * Standard HTTP Range header for partial content requests.
         */
        Range?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query: {
        path: string;
    };
    url: '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}/content';
};

export type GetThreadAgenticArtifactWorkspaceTransactionContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Range Not Satisfiable
     */
    416: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadAgenticArtifactWorkspaceTransactionContentError = GetThreadAgenticArtifactWorkspaceTransactionContentErrors[keyof GetThreadAgenticArtifactWorkspaceTransactionContentErrors];

export type GetThreadAgenticArtifactWorkspaceTransactionContentResponses = {
    /**
     * Full file content stream
     */
    200: Blob | File;
    /**
     * Partial file content stream
     */
    206: Blob | File;
};

export type GetThreadAgenticArtifactWorkspaceTransactionContentResponse = GetThreadAgenticArtifactWorkspaceTransactionContentResponses[keyof GetThreadAgenticArtifactWorkspaceTransactionContentResponses];

export type ListThreadAgenticArtifactWorkspaceTransactionEntriesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: {
        path?: string;
        recursive?: boolean;
        include_sha256?: boolean;
    };
    url: '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}/entries';
};

export type ListThreadAgenticArtifactWorkspaceTransactionEntriesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListThreadAgenticArtifactWorkspaceTransactionEntriesError = ListThreadAgenticArtifactWorkspaceTransactionEntriesErrors[keyof ListThreadAgenticArtifactWorkspaceTransactionEntriesErrors];

export type ListThreadAgenticArtifactWorkspaceTransactionEntriesResponses = {
    /**
     * Entries in the transaction's private root
     */
    200: WorkspaceTransactionEntries;
};

export type ListThreadAgenticArtifactWorkspaceTransactionEntriesResponse = ListThreadAgenticArtifactWorkspaceTransactionEntriesResponses[keyof ListThreadAgenticArtifactWorkspaceTransactionEntriesResponses];

export type ApplyThreadAgenticArtifactWorkspaceTransactionPatchData = {
    body: string;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}/patches';
};

export type ApplyThreadAgenticArtifactWorkspaceTransactionPatchErrors = {
    /**
     * Malformed or unsupported unified diff
     */
    400: WorkspacePatchConflictResponse;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Patch conflict
     */
    409: WorkspacePatchConflictResponse;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ApplyThreadAgenticArtifactWorkspaceTransactionPatchError = ApplyThreadAgenticArtifactWorkspaceTransactionPatchErrors[keyof ApplyThreadAgenticArtifactWorkspaceTransactionPatchErrors];

export type ApplyThreadAgenticArtifactWorkspaceTransactionPatchResponses = {
    /**
     * Patch applied
     */
    200: WorkspacePatchResult;
};

export type ApplyThreadAgenticArtifactWorkspaceTransactionPatchResponse = ApplyThreadAgenticArtifactWorkspaceTransactionPatchResponses[keyof ApplyThreadAgenticArtifactWorkspaceTransactionPatchResponses];

export type PromoteThreadAgenticArtifactWorkspaceTransactionData = {
    body: PromoteWorkspaceTransactionRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        /**
         * Opaque agentic artifact workspace transaction identifier.
         */
        transaction_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}/promote';
};

export type PromoteThreadAgenticArtifactWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type PromoteThreadAgenticArtifactWorkspaceTransactionError = PromoteThreadAgenticArtifactWorkspaceTransactionErrors[keyof PromoteThreadAgenticArtifactWorkspaceTransactionErrors];

export type PromoteThreadAgenticArtifactWorkspaceTransactionResponses = {
    /**
     * Workspace transaction promoted
     */
    200: WorkspacePromotionResult;
};

export type PromoteThreadAgenticArtifactWorkspaceTransactionResponse = PromoteThreadAgenticArtifactWorkspaceTransactionResponses[keyof PromoteThreadAgenticArtifactWorkspaceTransactionResponses];

export type ListAiPersonasData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/ai-personas';
};

export type ListAiPersonasErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListAiPersonasError = ListAiPersonasErrors[keyof ListAiPersonasErrors];

export type ListAiPersonasResponses = {
    /**
     * List of AI personas
     */
    200: Array<AiPersona>;
};

export type ListAiPersonasResponse = ListAiPersonasResponses[keyof ListAiPersonasResponses];

export type CreateAiPersonaData = {
    body: AiPersonaCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/ai-personas';
};

export type CreateAiPersonaErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateAiPersonaError = CreateAiPersonaErrors[keyof CreateAiPersonaErrors];

export type CreateAiPersonaResponses = {
    /**
     * AI persona created
     */
    201: AiPersona;
};

export type CreateAiPersonaResponse = CreateAiPersonaResponses[keyof CreateAiPersonaResponses];

export type DeleteAiPersonaData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        persona_id: string;
    };
    query?: never;
    url: '/ai-personas/{persona_id}';
};

export type DeleteAiPersonaErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteAiPersonaError = DeleteAiPersonaErrors[keyof DeleteAiPersonaErrors];

export type DeleteAiPersonaResponses = {
    /**
     * AI persona deleted
     */
    204: void;
};

export type DeleteAiPersonaResponse = DeleteAiPersonaResponses[keyof DeleteAiPersonaResponses];

export type GetAiPersonaData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        persona_id: string;
    };
    query?: never;
    url: '/ai-personas/{persona_id}';
};

export type GetAiPersonaErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetAiPersonaError = GetAiPersonaErrors[keyof GetAiPersonaErrors];

export type GetAiPersonaResponses = {
    /**
     * AI persona details
     */
    200: AiPersona;
};

export type GetAiPersonaResponse = GetAiPersonaResponses[keyof GetAiPersonaResponses];

export type UpdateAiPersonaData = {
    body: AiPersonaUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        persona_id: string;
    };
    query?: never;
    url: '/ai-personas/{persona_id}';
};

export type UpdateAiPersonaErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateAiPersonaError = UpdateAiPersonaErrors[keyof UpdateAiPersonaErrors];

export type UpdateAiPersonaResponses = {
    /**
     * AI persona updated
     */
    200: AiPersona;
};

export type UpdateAiPersonaResponse = UpdateAiPersonaResponses[keyof UpdateAiPersonaResponses];

export type StopAiPersonaAnswerData = {
    body: StopAiPersonaAnswerRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        persona_id: string;
    };
    query?: never;
    url: '/ai-personas/{persona_id}/actions/stop-answer';
};

export type StopAiPersonaAnswerErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Conflict - message is not currently generating
     */
    409: ChatMessage;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type StopAiPersonaAnswerError = StopAiPersonaAnswerErrors[keyof StopAiPersonaAnswerErrors];

export type StopAiPersonaAnswerResponses = {
    /**
     * AI persona answer stopped
     */
    200: ChatMessage;
};

export type StopAiPersonaAnswerResponse = StopAiPersonaAnswerResponses[keyof StopAiPersonaAnswerResponses];

export type RefreshTokenData = {
    body?: never;
    headers: {
        'Refresh-Token': string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/refresh';
};

export type RefreshTokenErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RefreshTokenError = RefreshTokenErrors[keyof RefreshTokenErrors];

export type RefreshTokenResponses = {
    /**
     * Token refreshed
     */
    200: TokenResponse;
};

export type RefreshTokenResponse = RefreshTokenResponses[keyof RefreshTokenResponses];

export type LogoutData = {
    body?: never;
    headers: {
        'Refresh-Token': string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/logout';
};

export type LogoutErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type LogoutError = LogoutErrors[keyof LogoutErrors];

export type LogoutResponses = {
    /**
     * Logout successful
     */
    204: void;
};

export type LogoutResponse = LogoutResponses[keyof LogoutResponses];

export type CreateCapabilityTokenData = {
    body: CapabilityTokenRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/capability-tokens';
};

export type CreateCapabilityTokenErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateCapabilityTokenError = CreateCapabilityTokenErrors[keyof CreateCapabilityTokenErrors];

export type CreateCapabilityTokenResponses = {
    /**
     * Capability token minted
     */
    200: CapabilityTokenResponse;
};

export type CreateCapabilityTokenResponse = CreateCapabilityTokenResponses[keyof CreateCapabilityTokenResponses];

export type BrowserCreateCapabilityTokenData = {
    body: CapabilityTokenRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth-browser/capability-tokens';
};

export type BrowserCreateCapabilityTokenErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BrowserCreateCapabilityTokenError = BrowserCreateCapabilityTokenErrors[keyof BrowserCreateCapabilityTokenErrors];

export type BrowserCreateCapabilityTokenResponses = {
    /**
     * Capability token minted
     */
    200: CapabilityTokenResponse;
};

export type BrowserCreateCapabilityTokenResponse = BrowserCreateCapabilityTokenResponses[keyof BrowserCreateCapabilityTokenResponses];

export type BrowserLogoutData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth-browser/logout';
};

export type BrowserLogoutErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BrowserLogoutError = BrowserLogoutErrors[keyof BrowserLogoutErrors];

export type BrowserLogoutResponses = {
    /**
     * Logout successful
     */
    204: void;
};

export type BrowserLogoutResponse = BrowserLogoutResponses[keyof BrowserLogoutResponses];

export type GoogleLoginData = {
    body: {
        /**
         * ID token obtained from Google OAuth
         */
        id_token: string;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/google/login';
};

export type GoogleLoginErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GoogleLoginError = GoogleLoginErrors[keyof GoogleLoginErrors];

export type GoogleLoginResponses = {
    /**
     * Login successful
     */
    200: LoginResponse;
};

export type GoogleLoginResponse = GoogleLoginResponses[keyof GoogleLoginResponses];

export type BrowserGoogleLoginData = {
    body: {
        /**
         * ID token obtained from Google OAuth
         */
        id_token: string;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth-browser/google/login';
};

export type BrowserGoogleLoginErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BrowserGoogleLoginError = BrowserGoogleLoginErrors[keyof BrowserGoogleLoginErrors];

export type BrowserGoogleLoginResponses = {
    /**
     * Login successful
     */
    200: BrowserLoginResponse;
};

export type BrowserGoogleLoginResponse = BrowserGoogleLoginResponses[keyof BrowserGoogleLoginResponses];

export type GenerateExternalAuthCodeData = {
    body: {
        /**
         * Target external service identifier (must be in the server's allowlist)
         */
        audience: string;
        /**
         * Optional project to bind to the authcode. The caller must have `org.project:view` on it. The project and its organization are stored with the authcode and returned when it is redeemed.
         */
        project_id?: string;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/external/authcode';
};

export type GenerateExternalAuthCodeErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GenerateExternalAuthCodeError = GenerateExternalAuthCodeErrors[keyof GenerateExternalAuthCodeErrors];

export type GenerateExternalAuthCodeResponses = {
    /**
     * Authcode minted
     */
    200: ExternalAuthCodeResponse;
};

export type GenerateExternalAuthCodeResponse = GenerateExternalAuthCodeResponses[keyof GenerateExternalAuthCodeResponses];

export type BrowserGenerateExternalAuthCodeData = {
    body: {
        /**
         * Target external service identifier (must be in the server's allowlist)
         */
        audience: string;
        /**
         * Optional project to bind to the authcode. The caller must have `org.project:view` on it. The project and its organization are stored with the authcode and returned when it is redeemed.
         */
        project_id?: string;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth-browser/external/authcode';
};

export type BrowserGenerateExternalAuthCodeErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BrowserGenerateExternalAuthCodeError = BrowserGenerateExternalAuthCodeErrors[keyof BrowserGenerateExternalAuthCodeErrors];

export type BrowserGenerateExternalAuthCodeResponses = {
    /**
     * Authcode minted
     */
    200: ExternalAuthCodeResponse;
};

export type BrowserGenerateExternalAuthCodeResponse = BrowserGenerateExternalAuthCodeResponses[keyof BrowserGenerateExternalAuthCodeResponses];

export type RedeemExternalAuthCodeData = {
    body: {
        /**
         * Authcode previously minted by generateExternalAuthCode
         */
        authcode: string;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/external/token';
};

export type RedeemExternalAuthCodeErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedeemExternalAuthCodeError = RedeemExternalAuthCodeErrors[keyof RedeemExternalAuthCodeErrors];

export type RedeemExternalAuthCodeResponses = {
    /**
     * Authcode redeemed; returns an identity proof for the bound external audience
     */
    200: ExternalIdTokenResponse;
};

export type RedeemExternalAuthCodeResponse = RedeemExternalAuthCodeResponses[keyof RedeemExternalAuthCodeResponses];

export type StartDeviceAuthorizationData = {
    body: {
        /**
         * Must be `dreamstudio-cli`
         */
        client_id?: string;
        /**
         * Where the tool runs (e.g. "erin on laptop"), shown on the approval page
         */
        name?: string;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/device/code';
};

export type StartDeviceAuthorizationErrors = {
    /**
     * OAuth error
     */
    400: OAuthError;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type StartDeviceAuthorizationError = StartDeviceAuthorizationErrors[keyof StartDeviceAuthorizationErrors];

export type StartDeviceAuthorizationResponses = {
    /**
     * Device authorization started
     */
    200: DeviceAuthorizationResponse;
};

export type StartDeviceAuthorizationResponse = StartDeviceAuthorizationResponses[keyof StartDeviceAuthorizationResponses];

export type RedeemDeviceAuthorizationData = {
    body: {
        /**
         * Must be `urn:ietf:params:oauth:grant-type:device_code`
         */
        grant_type?: string;
        client_id?: string;
        device_code?: string;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/device/token';
};

export type RedeemDeviceAuthorizationErrors = {
    /**
     * OAuth error
     */
    400: OAuthError;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedeemDeviceAuthorizationError = RedeemDeviceAuthorizationErrors[keyof RedeemDeviceAuthorizationErrors];

export type RedeemDeviceAuthorizationResponses = {
    /**
     * Tokens issued
     */
    200: OAuthTokenResponse;
};

export type RedeemDeviceAuthorizationResponse = RedeemDeviceAuthorizationResponses[keyof RedeemDeviceAuthorizationResponses];

export type BrowserGetDeviceAuthorizationData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        user_code: string;
    };
    query?: never;
    url: '/auth-browser/device/{user_code}';
};

export type BrowserGetDeviceAuthorizationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BrowserGetDeviceAuthorizationError = BrowserGetDeviceAuthorizationErrors[keyof BrowserGetDeviceAuthorizationErrors];

export type BrowserGetDeviceAuthorizationResponses = {
    /**
     * Pending device authorization
     */
    200: PendingDeviceAuthorization;
};

export type BrowserGetDeviceAuthorizationResponse = BrowserGetDeviceAuthorizationResponses[keyof BrowserGetDeviceAuthorizationResponses];

export type BrowserApproveDeviceAuthorizationData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        user_code: string;
    };
    query?: never;
    url: '/auth-browser/device/{user_code}/actions/approve';
};

export type BrowserApproveDeviceAuthorizationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BrowserApproveDeviceAuthorizationError = BrowserApproveDeviceAuthorizationErrors[keyof BrowserApproveDeviceAuthorizationErrors];

export type BrowserApproveDeviceAuthorizationResponses = {
    /**
     * Device authorization approved
     */
    204: void;
};

export type BrowserApproveDeviceAuthorizationResponse = BrowserApproveDeviceAuthorizationResponses[keyof BrowserApproveDeviceAuthorizationResponses];

export type DevLoginData = {
    body: {
        email: string;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/dev/login';
};

export type DevLoginErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DevLoginError = DevLoginErrors[keyof DevLoginErrors];

export type DevLoginResponses = {
    /**
     * Login successful
     */
    200: LoginResponse;
};

export type DevLoginResponse = DevLoginResponses[keyof DevLoginResponses];

export type BrowserDevLoginData = {
    body: {
        email: string;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth-browser/dev/login';
};

export type BrowserDevLoginErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BrowserDevLoginError = BrowserDevLoginErrors[keyof BrowserDevLoginErrors];

export type BrowserDevLoginResponses = {
    /**
     * Login successful
     */
    200: BrowserLoginResponse;
};

export type BrowserDevLoginResponse = BrowserDevLoginResponses[keyof BrowserDevLoginResponses];

export type CheckAuthzActionsData = {
    body: AuthzCheckRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/authz/actions/check';
};

export type CheckAuthzActionsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Request is unauthenticated
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Request payload is malformed or contains unsupported permission/resource combinations
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Internal server error
     */
    500: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CheckAuthzActionsError = CheckAuthzActionsErrors[keyof CheckAuthzActionsErrors];

export type CheckAuthzActionsResponses = {
    /**
     * Authorization checks evaluated successfully
     */
    200: AuthzCheckResponse;
};

export type CheckAuthzActionsResponse = CheckAuthzActionsResponses[keyof CheckAuthzActionsResponses];

export type GetBillingSummaryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/summary';
};

export type GetBillingSummaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * `BILLING_DISABLED` when billing is disabled on this server, or `BILLING_NOT_PROVISIONED`
     * when this month's usage belongs to a payer without a Metronome contract (see usage reads).
     * With `BILLING_NOT_PROVISIONED`, `payer` names the payer without a contract (not
     * necessarily the requested subject) and `setup_available` says whether self-serve setup
     * can provision it.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Metronome is unreachable and its rates are not cached, so Dream Bucks cannot be computed
     * (`kind` `BILLING_PROVIDER_UNAVAILABLE`). Transient: retry with backoff.
     *
     */
    503: Error;
};

export type GetBillingSummaryError = GetBillingSummaryErrors[keyof GetBillingSummaryErrors];

export type GetBillingSummaryResponses = {
    /**
     * Composite organization billing summary
     */
    200: BillingSummary;
};

export type GetBillingSummaryResponse = GetBillingSummaryResponses[keyof GetBillingSummaryResponses];

export type ListBillingPaymentMethodsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/payment-methods';
};

export type ListBillingPaymentMethodsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable and no authoritative collection can be returned
     */
    503: Error;
};

export type ListBillingPaymentMethodsError = ListBillingPaymentMethodsErrors[keyof ListBillingPaymentMethodsErrors];

export type ListBillingPaymentMethodsResponses = {
    /**
     * Complete ordered payment-method collection
     */
    200: BillingPaymentMethodListResponse;
};

export type ListBillingPaymentMethodsResponse = ListBillingPaymentMethodsResponses[keyof ListBillingPaymentMethodsResponses];

export type CreatePaymentMethodSetupData = {
    body: PaymentMethodSetupCreate;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/payment-methods/actions/setup';
};

export type CreatePaymentMethodSetupErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * The supplied attempt is no longer open (`SETUP_ATTEMPT_NOT_OPEN`)
     */
    409: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * A billing provider is unavailable and setup cannot safely complete
     */
    503: Error;
};

export type CreatePaymentMethodSetupError = CreatePaymentMethodSetupErrors[keyof CreatePaymentMethodSetupErrors];

export type CreatePaymentMethodSetupResponses = {
    /**
     * New or resumed payment-method setup
     */
    200: PaymentMethodSetupCreateResponse;
};

export type CreatePaymentMethodSetupResponse = CreatePaymentMethodSetupResponses[keyof CreatePaymentMethodSetupResponses];

export type GetPaymentMethodSetupAttemptData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
        /**
         * Client-minted Dream Studio payment-method setup attempt ID.
         */
        attempt_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/payment-method-setup-attempts/{attempt_id}';
};

export type GetPaymentMethodSetupAttemptErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Attempt not found in the requested organization
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetPaymentMethodSetupAttemptError = GetPaymentMethodSetupAttemptErrors[keyof GetPaymentMethodSetupAttemptErrors];

export type GetPaymentMethodSetupAttemptResponses = {
    /**
     * Payment-method setup attempt
     */
    200: PaymentMethodSetupAttempt;
};

export type GetPaymentMethodSetupAttemptResponse = GetPaymentMethodSetupAttemptResponses[keyof GetPaymentMethodSetupAttemptResponses];

export type GetBillingPurchaseOptionsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/purchase-options';
};

export type GetBillingPurchaseOptionsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetBillingPurchaseOptionsError = GetBillingPurchaseOptionsErrors[keyof GetBillingPurchaseOptionsErrors];

export type GetBillingPurchaseOptionsResponses = {
    /**
     * Purchase options
     */
    200: BillingPurchaseOptions;
};

export type GetBillingPurchaseOptionsResponse = GetBillingPurchaseOptionsResponses[keyof GetBillingPurchaseOptionsResponses];

export type CreateBillingPurchaseData = {
    body: BillingPurchaseCreate;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/actions/purchase';
};

export type CreateBillingPurchaseErrors = {
    /**
     * Amount outside the purchase bounds, the attempt was created for another amount, or an invalid `return_path`
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled (`BILLING_DISABLED`), purchases are disabled (`PURCHASES_DISABLED`),
     * or the organization has no billing account (`BILLING_NOT_PROVISIONED`).
     * With `BILLING_NOT_PROVISIONED`, `payer` names the payer without a contract (not
     * necessarily the requested subject) and `setup_available` says whether self-serve setup
     * can provision it.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * The supplied attempt is no longer open (`PURCHASE_ATTEMPT_NOT_OPEN`)
     */
    409: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable (`BILLING_PROVIDER_UNAVAILABLE`)
     */
    503: Error;
};

export type CreateBillingPurchaseError = CreateBillingPurchaseErrors[keyof CreateBillingPurchaseErrors];

export type CreateBillingPurchaseResponses = {
    /**
     * New or resumed purchase checkout
     */
    200: BillingPurchaseCreateResponse;
};

export type CreateBillingPurchaseResponse = CreateBillingPurchaseResponses[keyof CreateBillingPurchaseResponses];

export type CreateBillingSubscriptionData = {
    body: BillingSubscribeCreate;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/actions/subscribe';
};

export type CreateBillingSubscriptionErrors = {
    /**
     * Unknown `plan_id` or an invalid `return_path`
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled (`BILLING_DISABLED`), subscriptions are disabled
     * (`SUBSCRIPTIONS_DISABLED`), or the organization has no billing account
     * (`BILLING_NOT_PROVISIONED`). With `BILLING_NOT_PROVISIONED`, `payer` and
     * `setup_available` are as for purchases.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * The organization already has a live subscription (`SUBSCRIPTION_EXISTS`)
     */
    409: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable (`BILLING_PROVIDER_UNAVAILABLE`)
     */
    503: Error;
};

export type CreateBillingSubscriptionError = CreateBillingSubscriptionErrors[keyof CreateBillingSubscriptionErrors];

export type CreateBillingSubscriptionResponses = {
    /**
     * Subscription checkout
     */
    200: BillingSubscribeCreateResponse;
};

export type CreateBillingSubscriptionResponse = CreateBillingSubscriptionResponses[keyof CreateBillingSubscriptionResponses];

export type GetBillingPurchaseAttemptData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
        /**
         * Client-minted Dream Studio purchase attempt ID.
         */
        attempt_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/purchase-attempts/{attempt_id}';
};

export type GetBillingPurchaseAttemptErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Attempt not found in the requested organization
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetBillingPurchaseAttemptError = GetBillingPurchaseAttemptErrors[keyof GetBillingPurchaseAttemptErrors];

export type GetBillingPurchaseAttemptResponses = {
    /**
     * Purchase attempt
     */
    200: BillingPurchaseAttempt;
};

export type GetBillingPurchaseAttemptResponse = GetBillingPurchaseAttemptResponses[keyof GetBillingPurchaseAttemptResponses];

export type SetDefaultPaymentMethodData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
        /**
         * Public Stripe PaymentMethod ID, verified against the organization before use.
         */
        pm_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/payment-methods/{pm_id}/actions/set-default';
};

export type SetDefaultPaymentMethodErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Payment method not found in the requested organization
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable; the default did not change yet
     */
    503: Error;
};

export type SetDefaultPaymentMethodError = SetDefaultPaymentMethodErrors[keyof SetDefaultPaymentMethodErrors];

export type SetDefaultPaymentMethodResponses = {
    /**
     * Stripe's invoice default is now this payment method
     */
    204: void;
};

export type SetDefaultPaymentMethodResponse = SetDefaultPaymentMethodResponses[keyof SetDefaultPaymentMethodResponses];

export type DeleteBillingPaymentMethodData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
        /**
         * Public Stripe PaymentMethod ID, verified against the organization before use.
         */
        pm_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/payment-methods/{pm_id}';
};

export type DeleteBillingPaymentMethodErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Payment method not found in the requested organization
     */
    404: Error;
    /**
     * Payment method is not removable (`PAYMENT_METHOD_NOT_REMOVABLE`)
     */
    409: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable and the mutation cannot safely complete
     */
    503: Error;
};

export type DeleteBillingPaymentMethodError = DeleteBillingPaymentMethodErrors[keyof DeleteBillingPaymentMethodErrors];

export type DeleteBillingPaymentMethodResponses = {
    /**
     * Payment method detached
     */
    204: void;
};

export type DeleteBillingPaymentMethodResponse = DeleteBillingPaymentMethodResponses[keyof DeleteBillingPaymentMethodResponses];

export type ListBillingInvoicesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
    };
    query?: {
        /**
         * Maximum number of items to return per page.
         *
         * This parameter is only valid on the initial request. When using `cursor`,
         * the page size is encoded in the cursor and this parameter must be omitted.
         *
         */
        page_size?: number;
        /**
         * Opaque pagination cursor from a previous response (`previous_cursor` or `next_cursor`).
         *
         * **Usage Pattern:**
         * - First request: Omit `cursor`, provide `page_size` and any filters
         * - Subsequent requests: Provide only `cursor`, omit all other parameters
         *
         * The cursor encodes all request state (filters, page_size, position), so when
         * using a cursor, do not include any other parameters. Providing `cursor` with
         * `page_size`, `around`, or any filter returns `422 Unprocessable Entity`.
         *
         * Cursors are opaque strings - do not parse or construct them. They may expire
         * after extended periods; start fresh pagination for new sessions.
         *
         */
        cursor?: string;
    };
    url: '/organizations/{org_id}/billing/invoices';
};

export type ListBillingInvoicesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Invalid cursor parameter combination
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable and no authoritative collection can be returned
     */
    503: Error;
};

export type ListBillingInvoicesError = ListBillingInvoicesErrors[keyof ListBillingInvoicesErrors];

export type ListBillingInvoicesResponses = {
    /**
     * Paginated Stripe collection invoices
     */
    200: BillingInvoiceListResponse;
};

export type ListBillingInvoicesResponse = ListBillingInvoicesResponses[keyof ListBillingInvoicesResponses];

export type GetBillingInvoiceData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
        /**
         * Public Stripe Invoice ID, verified against the organization before use.
         */
        invoice_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/invoices/{invoice_id}';
};

export type GetBillingInvoiceErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Invoice not found in the requested organization
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable and no authoritative invoice can be returned
     */
    503: Error;
};

export type GetBillingInvoiceError = GetBillingInvoiceErrors[keyof GetBillingInvoiceErrors];

export type GetBillingInvoiceResponses = {
    /**
     * Stripe collection invoice
     */
    200: BillingInvoice;
};

export type GetBillingInvoiceResponse = GetBillingInvoiceResponses[keyof GetBillingInvoiceResponses];

export type CreateCustomerPortalSessionData = {
    body: CustomerPortalSessionCreate;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/actions/customer-portal-session';
};

export type CreateCustomerPortalSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable and a portal session cannot be created
     */
    503: Error;
};

export type CreateCustomerPortalSessionError = CreateCustomerPortalSessionErrors[keyof CreateCustomerPortalSessionErrors];

export type CreateCustomerPortalSessionResponses = {
    /**
     * Short-lived Stripe Customer Portal session
     */
    200: CustomerPortalSession;
};

export type CreateCustomerPortalSessionResponse = CreateCustomerPortalSessionResponses[keyof CreateCustomerPortalSessionResponses];

export type SetUpBillingData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose billing resource is requested.
         */
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/billing/actions/set-up';
};

export type SetUpBillingErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled (`BILLING_DISABLED`), or self-serve setup is disabled on this server
     * (`BILLING_SETUP_DISABLED`).
     *
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe or Metronome is unavailable (`BILLING_PROVIDER_UNAVAILABLE`); the setup is not
     * complete yet. Retry with backoff: it resumes where it stopped.
     *
     */
    503: Error;
};

export type SetUpBillingError = SetUpBillingErrors[keyof SetUpBillingErrors];

export type SetUpBillingResponses = {
    /**
     * The organization's billing account is ready
     */
    204: void;
};

export type SetUpBillingResponse = SetUpBillingResponses[keyof SetUpBillingResponses];

export type GetUserBillingSummaryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/summary';
};

export type GetUserBillingSummaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * `BILLING_DISABLED` when billing is disabled on this server, or `BILLING_NOT_PROVISIONED`
     * when this month's usage belongs to a payer without a Metronome contract (see usage reads).
     * With `BILLING_NOT_PROVISIONED`, `payer` names the payer without a contract (not
     * necessarily the requested subject) and `setup_available` says whether self-serve setup
     * can provision it.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Metronome is unreachable and its rates are not cached, so Dream Bucks cannot be computed
     * (`kind` `BILLING_PROVIDER_UNAVAILABLE`). Transient: retry with backoff.
     *
     */
    503: Error;
};

export type GetUserBillingSummaryError = GetUserBillingSummaryErrors[keyof GetUserBillingSummaryErrors];

export type GetUserBillingSummaryResponses = {
    /**
     * Composite user billing summary
     */
    200: BillingSummary;
};

export type GetUserBillingSummaryResponse = GetUserBillingSummaryResponses[keyof GetUserBillingSummaryResponses];

export type ListUserBillingPaymentMethodsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/payment-methods';
};

export type ListUserBillingPaymentMethodsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable and no authoritative collection can be returned
     */
    503: Error;
};

export type ListUserBillingPaymentMethodsError = ListUserBillingPaymentMethodsErrors[keyof ListUserBillingPaymentMethodsErrors];

export type ListUserBillingPaymentMethodsResponses = {
    /**
     * Complete ordered payment-method collection
     */
    200: BillingPaymentMethodListResponse;
};

export type ListUserBillingPaymentMethodsResponse = ListUserBillingPaymentMethodsResponses[keyof ListUserBillingPaymentMethodsResponses];

export type CreateUserPaymentMethodSetupData = {
    body: PaymentMethodSetupCreate;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/payment-methods/actions/setup';
};

export type CreateUserPaymentMethodSetupErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * The supplied attempt is no longer open (`SETUP_ATTEMPT_NOT_OPEN`)
     */
    409: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * A billing provider is unavailable and setup cannot safely complete
     */
    503: Error;
};

export type CreateUserPaymentMethodSetupError = CreateUserPaymentMethodSetupErrors[keyof CreateUserPaymentMethodSetupErrors];

export type CreateUserPaymentMethodSetupResponses = {
    /**
     * New or resumed payment-method setup
     */
    200: PaymentMethodSetupCreateResponse;
};

export type CreateUserPaymentMethodSetupResponse = CreateUserPaymentMethodSetupResponses[keyof CreateUserPaymentMethodSetupResponses];

export type GetUserPaymentMethodSetupAttemptData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
        /**
         * Client-minted Dream Studio payment-method setup attempt ID.
         */
        attempt_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/payment-method-setup-attempts/{attempt_id}';
};

export type GetUserPaymentMethodSetupAttemptErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Attempt not found for the requested user
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetUserPaymentMethodSetupAttemptError = GetUserPaymentMethodSetupAttemptErrors[keyof GetUserPaymentMethodSetupAttemptErrors];

export type GetUserPaymentMethodSetupAttemptResponses = {
    /**
     * Payment-method setup attempt
     */
    200: PaymentMethodSetupAttempt;
};

export type GetUserPaymentMethodSetupAttemptResponse = GetUserPaymentMethodSetupAttemptResponses[keyof GetUserPaymentMethodSetupAttemptResponses];

export type GetUserBillingPurchaseOptionsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/purchase-options';
};

export type GetUserBillingPurchaseOptionsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetUserBillingPurchaseOptionsError = GetUserBillingPurchaseOptionsErrors[keyof GetUserBillingPurchaseOptionsErrors];

export type GetUserBillingPurchaseOptionsResponses = {
    /**
     * Purchase options
     */
    200: BillingPurchaseOptions;
};

export type GetUserBillingPurchaseOptionsResponse = GetUserBillingPurchaseOptionsResponses[keyof GetUserBillingPurchaseOptionsResponses];

export type CreateUserBillingPurchaseData = {
    body: BillingPurchaseCreate;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/actions/purchase';
};

export type CreateUserBillingPurchaseErrors = {
    /**
     * Amount outside the purchase bounds, the attempt was created for another amount, or an invalid `return_path`
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled (`BILLING_DISABLED`), purchases are disabled (`PURCHASES_DISABLED`),
     * or the user has no billing account (`BILLING_NOT_PROVISIONED`).
     * With `BILLING_NOT_PROVISIONED`, `payer` names the payer without a contract (not
     * necessarily the requested subject) and `setup_available` says whether self-serve setup
     * can provision it.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * The supplied attempt is no longer open (`PURCHASE_ATTEMPT_NOT_OPEN`)
     */
    409: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable (`BILLING_PROVIDER_UNAVAILABLE`)
     */
    503: Error;
};

export type CreateUserBillingPurchaseError = CreateUserBillingPurchaseErrors[keyof CreateUserBillingPurchaseErrors];

export type CreateUserBillingPurchaseResponses = {
    /**
     * New or resumed purchase checkout
     */
    200: BillingPurchaseCreateResponse;
};

export type CreateUserBillingPurchaseResponse = CreateUserBillingPurchaseResponses[keyof CreateUserBillingPurchaseResponses];

export type CreateUserBillingSubscriptionData = {
    body: BillingSubscribeCreate;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/actions/subscribe';
};

export type CreateUserBillingSubscriptionErrors = {
    /**
     * Unknown `plan_id` or an invalid `return_path`
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled (`BILLING_DISABLED`), subscriptions are disabled
     * (`SUBSCRIPTIONS_DISABLED`), or the user has no billing account
     * (`BILLING_NOT_PROVISIONED`). With `BILLING_NOT_PROVISIONED`, `payer` and
     * `setup_available` are as for purchases.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * The user already has a live subscription (`SUBSCRIPTION_EXISTS`)
     */
    409: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable (`BILLING_PROVIDER_UNAVAILABLE`)
     */
    503: Error;
};

export type CreateUserBillingSubscriptionError = CreateUserBillingSubscriptionErrors[keyof CreateUserBillingSubscriptionErrors];

export type CreateUserBillingSubscriptionResponses = {
    /**
     * Subscription checkout
     */
    200: BillingSubscribeCreateResponse;
};

export type CreateUserBillingSubscriptionResponse = CreateUserBillingSubscriptionResponses[keyof CreateUserBillingSubscriptionResponses];

export type GetUserBillingPurchaseAttemptData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
        /**
         * Client-minted Dream Studio purchase attempt ID.
         */
        attempt_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/purchase-attempts/{attempt_id}';
};

export type GetUserBillingPurchaseAttemptErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Attempt not found for the requested user
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetUserBillingPurchaseAttemptError = GetUserBillingPurchaseAttemptErrors[keyof GetUserBillingPurchaseAttemptErrors];

export type GetUserBillingPurchaseAttemptResponses = {
    /**
     * Purchase attempt
     */
    200: BillingPurchaseAttempt;
};

export type GetUserBillingPurchaseAttemptResponse = GetUserBillingPurchaseAttemptResponses[keyof GetUserBillingPurchaseAttemptResponses];

export type SetUserDefaultPaymentMethodData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
        /**
         * Public Stripe PaymentMethod ID, verified against the organization before use.
         */
        pm_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/payment-methods/{pm_id}/actions/set-default';
};

export type SetUserDefaultPaymentMethodErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Payment method not found for the requested user
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable; the default did not change yet
     */
    503: Error;
};

export type SetUserDefaultPaymentMethodError = SetUserDefaultPaymentMethodErrors[keyof SetUserDefaultPaymentMethodErrors];

export type SetUserDefaultPaymentMethodResponses = {
    /**
     * Stripe's invoice default is now this payment method
     */
    204: void;
};

export type SetUserDefaultPaymentMethodResponse = SetUserDefaultPaymentMethodResponses[keyof SetUserDefaultPaymentMethodResponses];

export type DeleteUserBillingPaymentMethodData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
        /**
         * Public Stripe PaymentMethod ID, verified against the organization before use.
         */
        pm_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/payment-methods/{pm_id}';
};

export type DeleteUserBillingPaymentMethodErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Payment method not found for the requested user
     */
    404: Error;
    /**
     * Payment method is not removable (`PAYMENT_METHOD_NOT_REMOVABLE`)
     */
    409: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable and the mutation cannot safely complete
     */
    503: Error;
};

export type DeleteUserBillingPaymentMethodError = DeleteUserBillingPaymentMethodErrors[keyof DeleteUserBillingPaymentMethodErrors];

export type DeleteUserBillingPaymentMethodResponses = {
    /**
     * Payment method detached
     */
    204: void;
};

export type DeleteUserBillingPaymentMethodResponse = DeleteUserBillingPaymentMethodResponses[keyof DeleteUserBillingPaymentMethodResponses];

export type ListUserBillingInvoicesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
    };
    query?: {
        /**
         * Maximum number of items to return per page.
         *
         * This parameter is only valid on the initial request. When using `cursor`,
         * the page size is encoded in the cursor and this parameter must be omitted.
         *
         */
        page_size?: number;
        /**
         * Opaque pagination cursor from a previous response (`previous_cursor` or `next_cursor`).
         *
         * **Usage Pattern:**
         * - First request: Omit `cursor`, provide `page_size` and any filters
         * - Subsequent requests: Provide only `cursor`, omit all other parameters
         *
         * The cursor encodes all request state (filters, page_size, position), so when
         * using a cursor, do not include any other parameters. Providing `cursor` with
         * `page_size`, `around`, or any filter returns `422 Unprocessable Entity`.
         *
         * Cursors are opaque strings - do not parse or construct them. They may expire
         * after extended periods; start fresh pagination for new sessions.
         *
         */
        cursor?: string;
    };
    url: '/users/{user_id}/billing/invoices';
};

export type ListUserBillingInvoicesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Invalid cursor parameter combination
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable and no authoritative collection can be returned
     */
    503: Error;
};

export type ListUserBillingInvoicesError = ListUserBillingInvoicesErrors[keyof ListUserBillingInvoicesErrors];

export type ListUserBillingInvoicesResponses = {
    /**
     * Paginated Stripe collection invoices
     */
    200: BillingInvoiceListResponse;
};

export type ListUserBillingInvoicesResponse = ListUserBillingInvoicesResponses[keyof ListUserBillingInvoicesResponses];

export type GetUserBillingInvoiceData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
        /**
         * Public Stripe Invoice ID, verified against the organization before use.
         */
        invoice_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/invoices/{invoice_id}';
};

export type GetUserBillingInvoiceErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Invoice not found for the requested user
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable and no authoritative invoice can be returned
     */
    503: Error;
};

export type GetUserBillingInvoiceError = GetUserBillingInvoiceErrors[keyof GetUserBillingInvoiceErrors];

export type GetUserBillingInvoiceResponses = {
    /**
     * Stripe collection invoice
     */
    200: BillingInvoice;
};

export type GetUserBillingInvoiceResponse = GetUserBillingInvoiceResponses[keyof GetUserBillingInvoiceResponses];

export type SetUpUserBillingData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/actions/set-up';
};

export type SetUpUserBillingErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled (`BILLING_DISABLED`), or self-serve setup is disabled on this server
     * (`BILLING_SETUP_DISABLED`).
     *
     */
    402: Error;
    /**
     * The caller is not this user
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe or Metronome is unavailable (`BILLING_PROVIDER_UNAVAILABLE`); the setup is not
     * complete yet. Retry with backoff: it resumes where it stopped.
     *
     */
    503: Error;
};

export type SetUpUserBillingError = SetUpUserBillingErrors[keyof SetUpUserBillingErrors];

export type SetUpUserBillingResponses = {
    /**
     * The user's billing account is ready
     */
    204: void;
};

export type SetUpUserBillingResponse = SetUpUserBillingResponses[keyof SetUpUserBillingResponses];

export type CreateUserCustomerPortalSessionData = {
    body: CustomerPortalSessionCreate;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User whose billing resource is requested. Canonical user billing operations require a self-check.
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/billing/actions/customer-portal-session';
};

export type CreateUserCustomerPortalSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Billing is disabled on this server (`kind` `BILLING_DISABLED`).
     */
    402: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Stripe is unavailable and a portal session cannot be created
     */
    503: Error;
};

export type CreateUserCustomerPortalSessionError = CreateUserCustomerPortalSessionErrors[keyof CreateUserCustomerPortalSessionErrors];

export type CreateUserCustomerPortalSessionResponses = {
    /**
     * Short-lived Stripe Customer Portal session
     */
    200: CustomerPortalSession;
};

export type CreateUserCustomerPortalSessionResponse = CreateUserCustomerPortalSessionResponses[keyof CreateUserCustomerPortalSessionResponses];

export type RedirectToUserBillingSummaryData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/billing/summary';
};

export type RedirectToUserBillingSummaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserBillingSummaryError = RedirectToUserBillingSummaryErrors[keyof RedirectToUserBillingSummaryErrors];

export type RedirectToUserBillingPaymentMethodsData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/billing/payment-methods';
};

export type RedirectToUserBillingPaymentMethodsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserBillingPaymentMethodsError = RedirectToUserBillingPaymentMethodsErrors[keyof RedirectToUserBillingPaymentMethodsErrors];

export type RedirectToUserBillingInvoicesData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: {
        /**
         * Maximum number of items to return per page.
         *
         * This parameter is only valid on the initial request. When using `cursor`,
         * the page size is encoded in the cursor and this parameter must be omitted.
         *
         */
        page_size?: number;
        /**
         * Opaque pagination cursor from a previous response (`previous_cursor` or `next_cursor`).
         *
         * **Usage Pattern:**
         * - First request: Omit `cursor`, provide `page_size` and any filters
         * - Subsequent requests: Provide only `cursor`, omit all other parameters
         *
         * The cursor encodes all request state (filters, page_size, position), so when
         * using a cursor, do not include any other parameters. Providing `cursor` with
         * `page_size`, `around`, or any filter returns `422 Unprocessable Entity`.
         *
         * Cursors are opaque strings - do not parse or construct them. They may expire
         * after extended periods; start fresh pagination for new sessions.
         *
         */
        cursor?: string;
    };
    url: '/user/billing/invoices';
};

export type RedirectToUserBillingInvoicesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserBillingInvoicesError = RedirectToUserBillingInvoicesErrors[keyof RedirectToUserBillingInvoicesErrors];

export type RedirectToUserBillingInvoiceData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Public Stripe Invoice ID, verified against the organization before use.
         */
        invoice_id: string;
    };
    query?: never;
    url: '/user/billing/invoices/{invoice_id}';
};

export type RedirectToUserBillingInvoiceErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserBillingInvoiceError = RedirectToUserBillingInvoiceErrors[keyof RedirectToUserBillingInvoiceErrors];

export type CreateBlobData = {
    body: BlobCreateRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/blobs';
};

export type CreateBlobErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateBlobError = CreateBlobErrors[keyof CreateBlobErrors];

export type CreateBlobResponses = {
    /**
     * Blob created successfully
     */
    201: BlobCreateResponse;
};

export type CreateBlobResponse = CreateBlobResponses[keyof CreateBlobResponses];

export type GetBlobDownloadUrlData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        blob_id: string;
    };
    query?: {
        file_name?: string;
    };
    url: '/blobs/{blob_id}/download-url';
};

export type GetBlobDownloadUrlErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetBlobDownloadUrlError = GetBlobDownloadUrlErrors[keyof GetBlobDownloadUrlErrors];

export type GetBlobDownloadUrlResponses = {
    /**
     * Download URL generated successfully
     */
    200: BlobDownloadUrlResponse;
};

export type GetBlobDownloadUrlResponse = GetBlobDownloadUrlResponses[keyof GetBlobDownloadUrlResponses];

export type CopyBlobData = {
    body: BlobCopyRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        blob_id: string;
    };
    query?: never;
    url: '/blobs/{blob_id}/copy';
};

export type CopyBlobErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CopyBlobError = CopyBlobErrors[keyof CopyBlobErrors];

export type CopyBlobResponses = {
    /**
     * Blob copied successfully
     */
    201: Blob;
};

export type CopyBlobResponse = CopyBlobResponses[keyof CopyBlobResponses];

export type GetBlobContentData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        blob_id: string;
    };
    query?: {
        file_name?: string;
    };
    url: '/blobs/{blob_id}/content';
};

export type GetBlobContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Blob is unavailable.
     */
    404: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetBlobContentError = GetBlobContentErrors[keyof GetBlobContentErrors];

export type CreateBlobUploadUrlData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        blob_id: string;
    };
    query?: never;
    url: '/blobs/{blob_id}/upload-url';
};

export type CreateBlobUploadUrlErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateBlobUploadUrlError = CreateBlobUploadUrlErrors[keyof CreateBlobUploadUrlErrors];

export type CreateBlobUploadUrlResponses = {
    /**
     * Upload URL generated successfully.
     */
    200: BlobUploadUrlResponse;
};

export type CreateBlobUploadUrlResponse = CreateBlobUploadUrlResponses[keyof CreateBlobUploadUrlResponses];

export type DeleteBlobData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        blob_id: string;
    };
    query?: never;
    url: '/blobs/{blob_id}';
};

export type DeleteBlobErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteBlobError = DeleteBlobErrors[keyof DeleteBlobErrors];

export type DeleteBlobResponses = {
    /**
     * Blob deleted successfully
     */
    204: void;
};

export type DeleteBlobResponse = DeleteBlobResponses[keyof DeleteBlobResponses];

export type GetBlobLocalGitFileData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query: {
        /**
         * The access token for the local git blob storage. This token maps to git content stored in the local FS subsystem (e.g., a repo/path or an encoded access token).
         */
        token: string;
    };
    url: '/blobs/local-git';
};

export type GetBlobLocalGitFileErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetBlobLocalGitFileError = GetBlobLocalGitFileErrors[keyof GetBlobLocalGitFileErrors];

export type GetBlobLocalGitFileResponses = {
    /**
     * File retrieved successfully
     */
    200: Blob | File;
};

export type GetBlobLocalGitFileResponse = GetBlobLocalGitFileResponses[keyof GetBlobLocalGitFileResponses];

export type UploadBlobLocalGitFileData = {
    /**
     * Upload the file providing the `file` field. Optional `intent` follows the same history title/details normalization rules used by write endpoints.
     */
    body: {
        intent?: IntentField;
        [key: string]: unknown;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query: {
        /**
         * The access token for the local git blob storage
         */
        token: string;
    };
    url: '/blobs/local-git';
};

export type UploadBlobLocalGitFileErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UploadBlobLocalGitFileError = UploadBlobLocalGitFileErrors[keyof UploadBlobLocalGitFileErrors];

export type UploadBlobLocalGitFileResponses = {
    /**
     * File uploaded successfully
     */
    201: FsEntry;
};

export type UploadBlobLocalGitFileResponse = UploadBlobLocalGitFileResponses[keyof UploadBlobLocalGitFileResponses];

export type GetBlobLocalFileData = {
    body?: never;
    headers?: {
        /**
         * The media type that the client is able to accept in the response. This is used to determine the content type of the response.
         */
        Accept?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query: {
        /**
         * The token of the blob storage provider
         */
        token: string;
        /**
         * The name to be used when downloading the content. If provided, the response will include a Content-Disposition header to prompt download with this filename.
         */
        file_name?: string;
    };
    url: '/blobs/local';
};

export type GetBlobLocalFileErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetBlobLocalFileError = GetBlobLocalFileErrors[keyof GetBlobLocalFileErrors];

export type GetBlobLocalFileResponses = {
    /**
     * File retrieved successfully
     */
    200: string;
};

export type GetBlobLocalFileResponse = GetBlobLocalFileResponses[keyof GetBlobLocalFileResponses];

export type UploadBlobLocalFileData = {
    /**
     * Upload the file providing the 'file' field. We are not defining it here because validation requires adherence to format, which may vary according to the client needs.
     */
    body: {
        [key: string]: unknown;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query: {
        /**
         * The token of the blob storage provider
         */
        token: string;
    };
    url: '/blobs/local';
};

export type UploadBlobLocalFileErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UploadBlobLocalFileError = UploadBlobLocalFileErrors[keyof UploadBlobLocalFileErrors];

export type UploadBlobLocalFileResponses = {
    /**
     * File uploaded successfully
     */
    201: UploadBlobLocalFile201Response;
};

export type UploadBlobLocalFileResponse = UploadBlobLocalFileResponses[keyof UploadBlobLocalFileResponses];

export type ListProjectBundleSourcesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/bundle-sources';
};

export type ListProjectBundleSourcesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProjectBundleSourcesError = ListProjectBundleSourcesErrors[keyof ListProjectBundleSourcesErrors];

export type ListProjectBundleSourcesResponses = {
    /**
     * List of bundle sources for the project
     */
    200: Array<BundleSource>;
};

export type ListProjectBundleSourcesResponse = ListProjectBundleSourcesResponses[keyof ListProjectBundleSourcesResponses];

export type CreateBundleSourceData = {
    body: BundleSourceCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/bundle-sources';
};

export type CreateBundleSourceErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateBundleSourceError = CreateBundleSourceErrors[keyof CreateBundleSourceErrors];

export type CreateBundleSourceResponses = {
    /**
     * bundle source created
     */
    201: BundleSource;
};

export type CreateBundleSourceResponse = CreateBundleSourceResponses[keyof CreateBundleSourceResponses];

export type DeleteBundleSourceData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        source_id: string;
    };
    query?: never;
    url: '/bundle-sources/{source_id}';
};

export type DeleteBundleSourceErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteBundleSourceError = DeleteBundleSourceErrors[keyof DeleteBundleSourceErrors];

export type DeleteBundleSourceResponses = {
    /**
     * bundle source deleted
     */
    204: void;
};

export type DeleteBundleSourceResponse = DeleteBundleSourceResponses[keyof DeleteBundleSourceResponses];

export type GetBundleSourceData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        source_id: string;
    };
    query?: never;
    url: '/bundle-sources/{source_id}';
};

export type GetBundleSourceErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetBundleSourceError = GetBundleSourceErrors[keyof GetBundleSourceErrors];

export type GetBundleSourceResponses = {
    /**
     * bundle source details
     */
    200: BundleSource;
};

export type GetBundleSourceResponse = GetBundleSourceResponses[keyof GetBundleSourceResponses];

export type UpdateBundleSourceData = {
    body: BundleSourceUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        source_id: string;
    };
    query?: never;
    url: '/bundle-sources/{source_id}';
};

export type UpdateBundleSourceErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateBundleSourceError = UpdateBundleSourceErrors[keyof UpdateBundleSourceErrors];

export type UpdateBundleSourceResponses = {
    /**
     * bundle source updated
     */
    200: BundleSource;
};

export type UpdateBundleSourceResponse = UpdateBundleSourceResponses[keyof UpdateBundleSourceResponses];

export type ListSourceBundlesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        source_id: string;
    };
    query?: never;
    url: '/bundle-sources/{source_id}/bundles';
};

export type ListSourceBundlesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListSourceBundlesError = ListSourceBundlesErrors[keyof ListSourceBundlesErrors];

export type ListSourceBundlesResponses = {
    /**
     * List of bundles for the source
     */
    200: Array<Bundle>;
};

export type ListSourceBundlesResponse = ListSourceBundlesResponses[keyof ListSourceBundlesResponses];

export type CreateBundleData = {
    body: BundleCreate;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        source_id: string;
    };
    query?: never;
    url: '/bundle-sources/{source_id}/bundles';
};

export type CreateBundleErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateBundleError = CreateBundleErrors[keyof CreateBundleErrors];

export type CreateBundleResponses = {
    /**
     * bundle created
     */
    201: BundleCreateResponse;
};

export type CreateBundleResponse = CreateBundleResponses[keyof CreateBundleResponses];

export type DeleteBundleData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        bundle_id: string;
    };
    query?: never;
    url: '/bundles/{bundle_id}';
};

export type DeleteBundleErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteBundleError = DeleteBundleErrors[keyof DeleteBundleErrors];

export type DeleteBundleResponses = {
    /**
     * bundle deleted
     */
    204: void;
};

export type DeleteBundleResponse = DeleteBundleResponses[keyof DeleteBundleResponses];

export type GetBundleData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        bundle_id: string;
    };
    query?: never;
    url: '/bundles/{bundle_id}';
};

export type GetBundleErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetBundleError = GetBundleErrors[keyof GetBundleErrors];

export type GetBundleResponses = {
    /**
     * bundle metadata
     */
    200: Bundle;
};

export type GetBundleResponse = GetBundleResponses[keyof GetBundleResponses];

export type UpdateBundleData = {
    body: BundleUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        bundle_id: string;
    };
    query?: never;
    url: '/bundles/{bundle_id}';
};

export type UpdateBundleErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateBundleError = UpdateBundleErrors[keyof UpdateBundleErrors];

export type UpdateBundleResponses = {
    /**
     * bundle updated
     */
    200: Bundle;
};

export type UpdateBundleResponse = UpdateBundleResponses[keyof UpdateBundleResponses];

export type GetBundleContentRedirectData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        bundle_id: string;
    };
    query?: never;
    url: '/bundles/{bundle_id}/content';
};

export type GetBundleContentRedirectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetBundleContentRedirectError = GetBundleContentRedirectErrors[keyof GetBundleContentRedirectErrors];

export type GenerateBundleContentUploadUrlData = {
    body: BundleContentUploadRequest;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        bundle_id: string;
    };
    query?: never;
    url: '/bundles/{bundle_id}/content';
};

export type GenerateBundleContentUploadUrlErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GenerateBundleContentUploadUrlError = GenerateBundleContentUploadUrlErrors[keyof GenerateBundleContentUploadUrlErrors];

export type GenerateBundleContentUploadUrlResponses = {
    /**
     * Pre-signed upload URL for the bundle content
     */
    200: BundleContentUploadResponse;
};

export type GenerateBundleContentUploadUrlResponse = GenerateBundleContentUploadUrlResponses[keyof GenerateBundleContentUploadUrlResponses];

export type ListBundleDeploymentsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        bundle_id: string;
    };
    query?: never;
    url: '/bundles/{bundle_id}/deployments';
};

export type ListBundleDeploymentsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListBundleDeploymentsError = ListBundleDeploymentsErrors[keyof ListBundleDeploymentsErrors];

export type ListBundleDeploymentsResponses = {
    /**
     * List of deployments
     */
    200: Array<BundleDeployment>;
};

export type ListBundleDeploymentsResponse = ListBundleDeploymentsResponses[keyof ListBundleDeploymentsResponses];

export type DiffBundlesData = {
    body: BundleDiffRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        bundle_id: string;
    };
    query?: never;
    url: '/bundles/{bundle_id}/actions/diff';
};

export type DiffBundlesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DiffBundlesError = DiffBundlesErrors[keyof DiffBundlesErrors];

export type DiffBundlesResponses = {
    /**
     * Unified textual diff format
     */
    200: string;
};

export type DiffBundlesResponse = DiffBundlesResponses[keyof DiffBundlesResponses];

export type DeployBundleData = {
    body: BundleDeployRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        bundle_id: string;
    };
    query?: never;
    url: '/bundles/{bundle_id}/actions/deploy';
};

export type DeployBundleErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeployBundleError = DeployBundleErrors[keyof DeployBundleErrors];

export type DeployBundleResponses = {
    /**
     * Deployment created
     */
    201: BundleDeployment;
};

export type DeployBundleResponse = DeployBundleResponses[keyof DeployBundleResponses];

export type ListProjectBundleEnvironmentsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/bundle-environments';
};

export type ListProjectBundleEnvironmentsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProjectBundleEnvironmentsError = ListProjectBundleEnvironmentsErrors[keyof ListProjectBundleEnvironmentsErrors];

export type ListProjectBundleEnvironmentsResponses = {
    /**
     * List of bundle environments for the project
     */
    200: Array<BundleEnvironment>;
};

export type ListProjectBundleEnvironmentsResponse = ListProjectBundleEnvironmentsResponses[keyof ListProjectBundleEnvironmentsResponses];

export type CreateBundleEnvironmentData = {
    body: BundleEnvironmentCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/bundle-environments';
};

export type CreateBundleEnvironmentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateBundleEnvironmentError = CreateBundleEnvironmentErrors[keyof CreateBundleEnvironmentErrors];

export type CreateBundleEnvironmentResponses = {
    /**
     * Bundle environment created
     */
    201: BundleEnvironment;
};

export type CreateBundleEnvironmentResponse = CreateBundleEnvironmentResponses[keyof CreateBundleEnvironmentResponses];

export type DeleteBundleEnvironmentData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        env_id: string;
    };
    query?: never;
    url: '/bundle-environments/{env_id}';
};

export type DeleteBundleEnvironmentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteBundleEnvironmentError = DeleteBundleEnvironmentErrors[keyof DeleteBundleEnvironmentErrors];

export type DeleteBundleEnvironmentResponses = {
    /**
     * Bundle environment deleted
     */
    204: void;
};

export type DeleteBundleEnvironmentResponse = DeleteBundleEnvironmentResponses[keyof DeleteBundleEnvironmentResponses];

export type GetBundleEnvironmentData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        env_id: string;
    };
    query?: never;
    url: '/bundle-environments/{env_id}';
};

export type GetBundleEnvironmentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetBundleEnvironmentError = GetBundleEnvironmentErrors[keyof GetBundleEnvironmentErrors];

export type GetBundleEnvironmentResponses = {
    /**
     * Bundle environment details
     */
    200: BundleEnvironment;
};

export type GetBundleEnvironmentResponse = GetBundleEnvironmentResponses[keyof GetBundleEnvironmentResponses];

export type UpdateBundleEnvironmentData = {
    body: BundleEnvironmentUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        env_id: string;
    };
    query?: never;
    url: '/bundle-environments/{env_id}';
};

export type UpdateBundleEnvironmentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateBundleEnvironmentError = UpdateBundleEnvironmentErrors[keyof UpdateBundleEnvironmentErrors];

export type UpdateBundleEnvironmentResponses = {
    /**
     * Bundle environment updated
     */
    200: BundleEnvironment;
};

export type UpdateBundleEnvironmentResponse = UpdateBundleEnvironmentResponses[keyof UpdateBundleEnvironmentResponses];

export type RedirectToCurrentBundleData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        env_id: string;
    };
    query?: never;
    url: '/bundle-environments/{env_id}/bundle';
};

export type RedirectToCurrentBundleErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToCurrentBundleError = RedirectToCurrentBundleErrors[keyof RedirectToCurrentBundleErrors];

export type RedirectToCurrentBundleContentData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        env_id: string;
    };
    query?: never;
    url: '/bundle-environments/{env_id}/bundle/content';
};

export type RedirectToCurrentBundleContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToCurrentBundleContentError = RedirectToCurrentBundleContentErrors[keyof RedirectToCurrentBundleContentErrors];

export type ListBundleEnvironmentDeploymentsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        env_id: string;
    };
    query?: never;
    url: '/bundle-environments/{env_id}/deployments';
};

export type ListBundleEnvironmentDeploymentsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListBundleEnvironmentDeploymentsError = ListBundleEnvironmentDeploymentsErrors[keyof ListBundleEnvironmentDeploymentsErrors];

export type ListBundleEnvironmentDeploymentsResponses = {
    /**
     * List of deployments
     */
    200: Array<BundleDeployment>;
};

export type ListBundleEnvironmentDeploymentsResponse = ListBundleEnvironmentDeploymentsResponses[keyof ListBundleEnvironmentDeploymentsResponses];

export type DeleteBundleDeploymentData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        deployment_id: string;
    };
    query?: never;
    url: '/bundle-deployments/{deployment_id}';
};

export type DeleteBundleDeploymentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteBundleDeploymentError = DeleteBundleDeploymentErrors[keyof DeleteBundleDeploymentErrors];

export type DeleteBundleDeploymentResponses = {
    /**
     * Deployment deleted
     */
    204: void;
};

export type DeleteBundleDeploymentResponse = DeleteBundleDeploymentResponses[keyof DeleteBundleDeploymentResponses];

export type GetBundleDeploymentData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        deployment_id: string;
    };
    query?: never;
    url: '/bundle-deployments/{deployment_id}';
};

export type GetBundleDeploymentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetBundleDeploymentError = GetBundleDeploymentErrors[keyof GetBundleDeploymentErrors];

export type GetBundleDeploymentResponses = {
    /**
     * Deployment details
     */
    200: BundleDeployment;
};

export type GetBundleDeploymentResponse = GetBundleDeploymentResponses[keyof GetBundleDeploymentResponses];

export type UpdateBundleDeploymentData = {
    body: BundleDeploymentUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        deployment_id: string;
    };
    query?: never;
    url: '/bundle-deployments/{deployment_id}';
};

export type UpdateBundleDeploymentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateBundleDeploymentError = UpdateBundleDeploymentErrors[keyof UpdateBundleDeploymentErrors];

export type UpdateBundleDeploymentResponses = {
    /**
     * Deployment updated
     */
    200: BundleDeployment;
};

export type UpdateBundleDeploymentResponse = UpdateBundleDeploymentResponses[keyof UpdateBundleDeploymentResponses];

export type RedirectToUserChatsData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/chats';
};

export type RedirectToUserChatsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserChatsError = RedirectToUserChatsErrors[keyof RedirectToUserChatsErrors];

export type ListUserChatsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the user whose chats to list
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/chats';
};

export type ListUserChatsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListUserChatsError = ListUserChatsErrors[keyof ListUserChatsErrors];

export type ListUserChatsResponses = {
    /**
     * List of chats created by the user (lightweight data for listing UI)
     */
    200: Array<ChatInfo>;
};

export type ListUserChatsResponse = ListUserChatsResponses[keyof ListUserChatsResponses];

export type CreateUserChatData = {
    body: ChatCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the user creating the chat
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/chats';
};

export type CreateUserChatErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateUserChatError = CreateUserChatErrors[keyof CreateUserChatErrors];

export type CreateUserChatResponses = {
    /**
     * Chat created
     */
    201: Chat;
};

export type CreateUserChatResponse = CreateUserChatResponses[keyof CreateUserChatResponses];

export type DeleteChatData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        chat_id: string;
    };
    query?: never;
    url: '/chats/{chat_id}';
};

export type DeleteChatErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteChatError = DeleteChatErrors[keyof DeleteChatErrors];

export type DeleteChatResponses = {
    /**
     * Chat deleted
     */
    204: void;
};

export type DeleteChatResponse = DeleteChatResponses[keyof DeleteChatResponses];

export type GetChatData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        chat_id: string;
    };
    query?: never;
    url: '/chats/{chat_id}';
};

export type GetChatErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetChatError = GetChatErrors[keyof GetChatErrors];

export type GetChatResponses = {
    /**
     * Chat details
     */
    200: Chat;
};

export type GetChatResponse = GetChatResponses[keyof GetChatResponses];

export type UpdateChatData = {
    body: ChatUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        chat_id: string;
    };
    query?: never;
    url: '/chats/{chat_id}';
};

export type UpdateChatErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateChatError = UpdateChatErrors[keyof UpdateChatErrors];

export type UpdateChatResponses = {
    /**
     * Chat updated
     */
    200: Chat;
};

export type UpdateChatResponse = UpdateChatResponses[keyof UpdateChatResponses];

export type ListChatBranchesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the chat whose branches to list
         */
        chat_id: string;
    };
    query?: never;
    url: '/chats/{chat_id}/branches';
};

export type ListChatBranchesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListChatBranchesError = ListChatBranchesErrors[keyof ListChatBranchesErrors];

export type ListChatBranchesResponses = {
    /**
     * List of branches in the chat
     */
    200: Array<ChatBranch>;
};

export type ListChatBranchesResponse = ListChatBranchesResponses[keyof ListChatBranchesResponses];

export type SwitchChatBranchData = {
    body: SwitchBranchRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the chat to switch branches in
         */
        chat_id: string;
    };
    query?: never;
    url: '/chats/{chat_id}/actions/switch-branch';
};

export type SwitchChatBranchErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type SwitchChatBranchError = SwitchChatBranchErrors[keyof SwitchChatBranchErrors];

export type SwitchChatBranchResponses = {
    /**
     * Branch switched successfully
     */
    200: Chat;
};

export type SwitchChatBranchResponse = SwitchChatBranchResponses[keyof SwitchChatBranchResponses];

export type RedirectToChatMessagesData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        chat_id: string;
    };
    query?: {
        /**
         * Maximum number of items to return per page.
         *
         * This parameter is only valid on the initial request. When using `cursor`,
         * the page size is encoded in the cursor and this parameter must be omitted.
         *
         */
        page_size?: number;
        /**
         * Opaque pagination cursor from a previous response (`previous_cursor` or `next_cursor`).
         *
         * **Usage Pattern:**
         * - First request: Omit `cursor`, provide `page_size` and any filters
         * - Subsequent requests: Provide only `cursor`, omit all other parameters
         *
         * The cursor encodes all request state (filters, page_size, position), so when
         * using a cursor, do not include any other parameters. Providing `cursor` with
         * `page_size`, `around`, or any filter returns `422 Unprocessable Entity`.
         *
         * Cursors are opaque strings - do not parse or construct them. They may expire
         * after extended periods; start fresh pagination for new sessions.
         *
         */
        cursor?: string;
    };
    url: '/chats/{chat_id}/messages';
};

export type RedirectToChatMessagesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToChatMessagesError = RedirectToChatMessagesErrors[keyof RedirectToChatMessagesErrors];

export type RedirectToCreateChatMessageData = {
    body: ChatMessageCreate;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the chat to send the message to
         */
        chat_id: string;
    };
    query?: never;
    url: '/chats/{chat_id}/messages';
};

export type RedirectToCreateChatMessageErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToCreateChatMessageError = RedirectToCreateChatMessageErrors[keyof RedirectToCreateChatMessageErrors];

export type UpdateChatBranchMessageData = {
    body: ChatMessageUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the chat containing the message
         */
        branch_id: string;
        /**
         * The ID of the message to edit
         */
        message_id: string;
    };
    query?: never;
    url: '/chat-branches/{branch_id}/messages/{message_id}';
};

export type UpdateChatBranchMessageErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateChatBranchMessageError = UpdateChatBranchMessageErrors[keyof UpdateChatBranchMessageErrors];

export type UpdateChatBranchMessageResponses = {
    /**
     * Message edited successfully. Behavior depends on `edit_mode`:
     * - `destructive`: The current chat branch is reverted to the message's commit and subsequent messages are deleted; returns the edited `ChatMessage`.
     * - `branch`: A new `ChatBranch` is created and the edited message is applied there; returns the new `ChatBranch` metadata.
     *
     */
    200: ChatMessage;
};

export type UpdateChatBranchMessageResponse = UpdateChatBranchMessageResponses[keyof UpdateChatBranchMessageResponses];

export type DeleteChatBranchData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the branch to delete
         */
        branch_id: string;
    };
    query?: never;
    url: '/chat-branches/{branch_id}';
};

export type DeleteChatBranchErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteChatBranchError = DeleteChatBranchErrors[keyof DeleteChatBranchErrors];

export type DeleteChatBranchResponses = {
    /**
     * Chat branch deleted
     */
    204: void;
};

export type DeleteChatBranchResponse = DeleteChatBranchResponses[keyof DeleteChatBranchResponses];

export type GetChatBranchData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the branch to retrieve
         */
        branch_id: string;
    };
    query?: never;
    url: '/chat-branches/{branch_id}';
};

export type GetChatBranchErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetChatBranchError = GetChatBranchErrors[keyof GetChatBranchErrors];

export type GetChatBranchResponses = {
    /**
     * Chat branch details
     */
    200: ChatBranch;
};

export type GetChatBranchResponse = GetChatBranchResponses[keyof GetChatBranchResponses];

export type ListLlmModelOptionsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/llm-model-options';
};

export type ListLlmModelOptionsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListLlmModelOptionsError = ListLlmModelOptionsErrors[keyof ListLlmModelOptionsErrors];

export type ListLlmModelOptionsResponses = {
    /**
     * Selectable models, in display order
     */
    200: Array<LlmModelOption>;
};

export type ListLlmModelOptionsResponse = ListLlmModelOptionsResponses[keyof ListLlmModelOptionsResponses];

export type GetChatBranchLlmViewData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the branch to inspect
         */
        branch_id: string;
    };
    query?: {
        /**
         * Optional target AI message ID.
         * If not provided:
         * - In `regular_chat` mode, uses the latest AI message
         * - In `agentic_cycle` mode, scans backwards from latest to find the first agentic cycle
         *
         */
        message_id?: string;
        /**
         * LLM view rendering mode
         */
        mode?: 'regular_chat' | 'agentic_cycle';
        /**
         * When `true`, removes all system prompt messages from the returned LLM view.
         * Default is `false` to include the full original LLM context.
         *
         */
        hide_system_prompt?: boolean;
    };
    url: '/chat-branches/{branch_id}/llm-view';
};

export type GetChatBranchLlmViewErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetChatBranchLlmViewError = GetChatBranchLlmViewErrors[keyof GetChatBranchLlmViewErrors];

export type GetChatBranchLlmViewResponses = {
    /**
     * LLM view for the branch
     */
    200: ChatBranchLlmView;
};

export type GetChatBranchLlmViewResponse = GetChatBranchLlmViewResponses[keyof GetChatBranchLlmViewResponses];

export type ListChatBranchMessagesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the branch
         */
        branch_id: string;
    };
    query?: {
        /**
         * Maximum number of items to return per page.
         *
         * This parameter is only valid on the initial request. When using `cursor`,
         * the page size is encoded in the cursor and this parameter must be omitted.
         *
         */
        page_size?: number;
        /**
         * Opaque pagination cursor from a previous response (`previous_cursor` or `next_cursor`).
         *
         * **Usage Pattern:**
         * - First request: Omit `cursor`, provide `page_size` and any filters
         * - Subsequent requests: Provide only `cursor`, omit all other parameters
         *
         * The cursor encodes all request state (filters, page_size, position), so when
         * using a cursor, do not include any other parameters. Providing `cursor` with
         * `page_size`, `around`, or any filter returns `422 Unprocessable Entity`.
         *
         * Cursors are opaque strings - do not parse or construct them. They may expire
         * after extended periods; start fresh pagination for new sessions.
         *
         */
        cursor?: string;
        /**
         * Item ID to center results around (for "jump to item" scenarios).
         *
         * When provided, returns approximately `page_size/2` items before and after the
         * specified item. Both `previous_cursor` and `next_cursor` will be returned,
         * enabling bidirectional scrolling from that position.
         *
         * **Example Use Case:** Opening a chat from a notification - use `around` with the
         * message ID from the notification to load messages centered on that message.
         *
         * Can be combined with `page_size` and endpoint-specific filters.
         *
         */
        around?: string;
        /**
         * Filter by sender type (human, ai-persona, system)
         */
        sender_type?: 'human' | 'ai-persona' | 'system';
        /**
         * Filter by specific sender ID
         */
        sender_id?: string;
        /**
         * Messages created after this timestamp (Unix timestamp)
         */
        from_ts?: number;
        /**
         * Messages created before this timestamp (Unix timestamp)
         */
        to_ts?: number;
        /**
         * If true, returns the full message lineage including ancestor branch messages up to their cutoff points.
         * If false (default), returns only messages from the current branch.
         *
         */
        include_lineage?: boolean;
    };
    url: '/chat-branches/{branch_id}/messages';
};

export type ListChatBranchMessagesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListChatBranchMessagesError = ListChatBranchMessagesErrors[keyof ListChatBranchMessagesErrors];

export type ListChatBranchMessagesResponses = {
    /**
     * List of messages in the branch
     */
    200: ListResponseBase & {
        items: Array<ChatMessage>;
    };
};

export type ListChatBranchMessagesResponse = ListChatBranchMessagesResponses[keyof ListChatBranchMessagesResponses];

export type CreateChatBranchMessageData = {
    body: ChatMessageCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the branch to send the message to
         */
        branch_id: string;
    };
    query?: never;
    url: '/chat-branches/{branch_id}/messages';
};

export type CreateChatBranchMessageErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateChatBranchMessageError = CreateChatBranchMessageErrors[keyof CreateChatBranchMessageErrors];

export type CreateChatBranchMessageResponses = {
    /**
     * Message created successfully. AI processing and real-time updates will be streamed via the /events SSE endpoint.
     */
    201: ChatMessage;
};

export type CreateChatBranchMessageResponse = CreateChatBranchMessageResponses[keyof CreateChatBranchMessageResponses];

export type InteractWithChatMessageData = {
    body: MessageInteractionCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the branch containing the message
         */
        branch_id: string;
        /**
         * The ID of the message containing the interactive element
         */
        message_id: string;
    };
    query?: never;
    url: '/chat-branches/{branch_id}/messages/{message_id}/actions/interact';
};

export type InteractWithChatMessageErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Conflict - interaction already exists for this content block.
     * Returns the existing message with the recorded interaction.
     *
     */
    409: ChatMessage;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type InteractWithChatMessageError = InteractWithChatMessageErrors[keyof InteractWithChatMessageErrors];

export type InteractWithChatMessageResponses = {
    /**
     * Interaction recorded successfully
     */
    200: ChatMessage;
};

export type InteractWithChatMessageResponse = InteractWithChatMessageResponses[keyof InteractWithChatMessageResponses];

export type AnswerChatQuestionsData = {
    body: QuestionSetAnswerCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the branch containing the message
         */
        branch_id: string;
        /**
         * The ID of the message containing the question set
         */
        message_id: string;
    };
    query?: never;
    url: '/chat-branches/{branch_id}/messages/{message_id}/actions/answer-questions';
};

export type AnswerChatQuestionsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * The question set was already answered; returns the authoritative message.
     */
    409: ChatMessage;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type AnswerChatQuestionsError = AnswerChatQuestionsErrors[keyof AnswerChatQuestionsErrors];

export type AnswerChatQuestionsResponses = {
    /**
     * Question set answered successfully
     */
    200: ChatMessage;
};

export type AnswerChatQuestionsResponse = AnswerChatQuestionsResponses[keyof AnswerChatQuestionsResponses];

export type ListEditSessionFsEntriesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
        /**
         * Scope to subfolder path
         */
        path?: string;
        /**
         * Filter by StructuredType name
         */
        type?: string;
        /**
         * Filter by file extension
         */
        extension?: string;
        /**
         * Filter by import status
         */
        import_status?: ImportStatus;
    };
    url: '/edit-sessions/{es_id}/content/fs';
};

export type ListEditSessionFsEntriesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListEditSessionFsEntriesError = ListEditSessionFsEntriesErrors[keyof ListEditSessionFsEntriesErrors];

export type ListEditSessionFsEntriesResponses = {
    /**
     * File system entry and its contents
     */
    200: FsListResponse;
};

export type ListEditSessionFsEntriesResponse = ListEditSessionFsEntriesResponses[keyof ListEditSessionFsEntriesResponses];

export type CreateFsEntryData = {
    body: CreateFsEntryRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/fs';
};

export type CreateFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateFsEntryError = CreateFsEntryErrors[keyof CreateFsEntryErrors];

export type CreateFsEntryResponses = {
    /**
     * Created file system entry
     */
    201: FsEntry;
};

export type CreateFsEntryResponse = CreateFsEntryResponses[keyof CreateFsEntryResponses];

export type DeleteFsEntryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/fs/{id}';
};

export type DeleteFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteFsEntryError = DeleteFsEntryErrors[keyof DeleteFsEntryErrors];

export type DeleteFsEntryResponses = {
    /**
     * File system entry deleted
     */
    204: void;
};

export type DeleteFsEntryResponse = DeleteFsEntryResponses[keyof DeleteFsEntryResponses];

export type GetEditSessionFsEntryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/content/fs/{id}';
};

export type GetEditSessionFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionFsEntryError = GetEditSessionFsEntryErrors[keyof GetEditSessionFsEntryErrors];

export type GetEditSessionFsEntryResponses = {
    /**
     * File system entry metadata
     */
    200: FsEntry;
};

export type GetEditSessionFsEntryResponse = GetEditSessionFsEntryResponses[keyof GetEditSessionFsEntryResponses];

export type UpdateFsEntryData = {
    body: UpdateFsEntryRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/fs/{id}';
};

export type UpdateFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateFsEntryError = UpdateFsEntryErrors[keyof UpdateFsEntryErrors];

export type UpdateFsEntryResponses = {
    /**
     * Updated file system entry
     */
    200: FsEntry;
};

export type UpdateFsEntryResponse = UpdateFsEntryResponses[keyof UpdateFsEntryResponses];

export type GetEditSessionFsEntryContentData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/content/fs/{id}/content';
};

export type GetEditSessionFsEntryContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionFsEntryContentError = GetEditSessionFsEntryContentErrors[keyof GetEditSessionFsEntryContentErrors];

export type PatchFsEntryContentData = {
    body: PatchFsEntryContentRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: {
        /**
         * Apply the JSON Patch in strict mode without replace transformation or implicit path creation.
         */
        strict?: boolean;
    };
    url: '/edit-sessions/{es_id}/content/fs/{id}/content';
};

export type PatchFsEntryContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type PatchFsEntryContentError = PatchFsEntryContentErrors[keyof PatchFsEntryContentErrors];

export type PatchFsEntryContentResponses = {
    /**
     * Updated file metadata
     */
    200: FsEntry;
};

export type PatchFsEntryContentResponse = PatchFsEntryContentResponses[keyof PatchFsEntryContentResponses];

export type RequestUploadUrlData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/fs/{id}/content';
};

export type RequestUploadUrlErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RequestUploadUrlError = RequestUploadUrlErrors[keyof RequestUploadUrlErrors];

export type RequestUploadUrlResponses = {
    /**
     * Upload URL info
     */
    200: RequestUploadUrlResponse;
};

export type RequestUploadUrlResponse2 = RequestUploadUrlResponses[keyof RequestUploadUrlResponses];

export type ReplaceFsEntryContentData = {
    body: ReplaceFsEntryContentRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/fs/{id}/content';
};

export type ReplaceFsEntryContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * File content changed or the edit unit is unavailable
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ReplaceFsEntryContentError = ReplaceFsEntryContentErrors[keyof ReplaceFsEntryContentErrors];

export type ReplaceFsEntryContentResponses = {
    /**
     * Updated file metadata
     */
    200: FsEntry;
};

export type ReplaceFsEntryContentResponse = ReplaceFsEntryContentResponses[keyof ReplaceFsEntryContentResponses];

export type GetEditSessionFsEntryByPathData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        /**
         * File path encoded as a single (percent-encoded) URL path segment.
         */
        path: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/content/fs-by-path/{path}';
};

export type GetEditSessionFsEntryByPathErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionFsEntryByPathError = GetEditSessionFsEntryByPathErrors[keyof GetEditSessionFsEntryByPathErrors];

export type GetEditSessionFsEntryByPathResponses = {
    /**
     * File system entry metadata
     */
    200: FsEntry;
};

export type GetEditSessionFsEntryByPathResponse = GetEditSessionFsEntryByPathResponses[keyof GetEditSessionFsEntryByPathResponses];

export type GetEditSessionFsEntryContentByPathData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        /**
         * File path encoded as a single (percent-encoded) URL path segment.
         */
        path: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/content/fs-by-path/{path}/content';
};

export type GetEditSessionFsEntryContentByPathErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionFsEntryContentByPathError = GetEditSessionFsEntryContentByPathErrors[keyof GetEditSessionFsEntryContentByPathErrors];

export type CopyFsEntryData = {
    body: CopyRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/fs/{id}/actions/copy';
};

export type CopyFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CopyFsEntryError = CopyFsEntryErrors[keyof CopyFsEntryErrors];

export type CopyFsEntryResponses = {
    /**
     * File copied
     */
    200: CopyFsEntryResponse;
};

export type CopyFsEntryResponse2 = CopyFsEntryResponses[keyof CopyFsEntryResponses];

export type ReimportFsEntryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/fs/{id}/actions/reimport';
};

export type ReimportFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ReimportFsEntryError = ReimportFsEntryErrors[keyof ReimportFsEntryErrors];

export type ReimportFsEntryResponses = {
    /**
     * Reimport triggered
     */
    202: unknown;
};

export type ValidateEditSessionFsEntryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/fs/{id}/actions/validate';
};

export type ValidateEditSessionFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Target is a folder, not a file
     */
    422: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ValidateEditSessionFsEntryError = ValidateEditSessionFsEntryErrors[keyof ValidateEditSessionFsEntryErrors];

export type ValidateEditSessionFsEntryResponses = {
    /**
     * Validation result for the file
     */
    200: ProblemsResponse;
};

export type ValidateEditSessionFsEntryResponse = ValidateEditSessionFsEntryResponses[keyof ValidateEditSessionFsEntryResponses];

export type CreateFsEntryFromDataData = {
    body: CreateFromDataRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        folder_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/fs/{folder_id}/actions/create-from-data';
};

export type CreateFsEntryFromDataErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateFsEntryFromDataError = CreateFsEntryFromDataErrors[keyof CreateFsEntryFromDataErrors];

export type CreateFsEntryFromDataResponses = {
    /**
     * File created
     */
    201: FsEntry;
};

export type CreateFsEntryFromDataResponse = CreateFsEntryFromDataResponses[keyof CreateFsEntryFromDataResponses];

export type ListEditSessionProblemsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: {
        severity?: ProblemSeverity;
        /**
         * Filter to problems anchored to this file (matches `Problem.source.id`).
         */
        file_id?: string;
    };
    url: '/edit-sessions/{es_id}/problems';
};

export type ListEditSessionProblemsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListEditSessionProblemsError = ListEditSessionProblemsErrors[keyof ListEditSessionProblemsErrors];

export type ListEditSessionProblemsResponses = {
    /**
     * List of problems for the edit session
     */
    200: ProblemsResponse;
};

export type ListEditSessionProblemsResponse = ListEditSessionProblemsResponses[keyof ListEditSessionProblemsResponses];

export type ReimportEditSessionContentPathData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/actions/reimport';
};

export type ReimportEditSessionContentPathErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ReimportEditSessionContentPathError = ReimportEditSessionContentPathErrors[keyof ReimportEditSessionContentPathErrors];

export type ReimportEditSessionContentPathResponses = {
    /**
     * Reimport triggered
     */
    202: unknown;
};

export type TriggerEditSessionValidationData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/actions/validate';
};

export type TriggerEditSessionValidationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type TriggerEditSessionValidationError = TriggerEditSessionValidationErrors[keyof TriggerEditSessionValidationErrors];

export type TriggerEditSessionValidationResponses = {
    /**
     * Validation triggered
     */
    202: unknown;
};

export type RefreshEditSessionContentTreeData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: {
        /**
         * Scope to a subtree. Defaults to "/".
         *
         */
        path?: string;
    };
    url: '/edit-sessions/{es_id}/content/tree/actions/refresh';
};

export type RefreshEditSessionContentTreeErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RefreshEditSessionContentTreeError = RefreshEditSessionContentTreeErrors[keyof RefreshEditSessionContentTreeErrors];

export type RefreshEditSessionContentTreeResponses = {
    /**
     * Tree refresh triggered
     */
    202: unknown;
};

export type GetEditSessionContentTreeData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
        /**
         * Historical version to compare with when `version_id` is present. The returned tree
         * remains the selected `version_id` snapshot, while `modified` markers reflect the
         * direct comparison with this target. Omit it to compare with the selected version's
         * first parent or the empty tree.
         *
         */
        compare_to?: string;
        /**
         * Scope to a subtree. Returns the specified node and all its descendants.
         * Example: "/Rooms" returns the Rooms folder and all files within it.
         *
         */
        path?: string;
        /**
         * Deprecated: use `relative_depth` instead. Identical semantics; this parameter will be removed in a future version.
         * Limit tree depth. Depth is relative to the root (or path parameter).
         * - depth=0: Only root nodes
         * - depth=1: Root + immediate children
         * - null: Unlimited (default)
         *
         *
         * @deprecated
         */
        depth?: number;
        /**
         * Limit tree depth, relative to the root (or path parameter). Supersedes the deprecated `depth` parameter; if both are given, relative_depth takes precedence.
         * - relative_depth=0: Only root nodes
         * - relative_depth=1: Root + immediate children
         * - null: Unlimited (default)
         *
         */
        relative_depth?: number;
        /**
         * Filter by MIME type (e.g., "application/vnd.dreamstudio.value.room+yaml").
         * Returns matching files and their ancestor folders.
         *
         */
        type?: string;
    };
    url: '/edit-sessions/{es_id}/content/tree';
};

export type GetEditSessionContentTreeErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionContentTreeError = GetEditSessionContentTreeErrors[keyof GetEditSessionContentTreeErrors];

export type GetEditSessionContentTreeResponses = {
    /**
     * Flat array of tree nodes
     */
    200: ContentTreeResponse;
};

export type GetEditSessionContentTreeResponse = GetEditSessionContentTreeResponses[keyof GetEditSessionContentTreeResponses];

export type ListContextSuggestionsData = {
    body: ContextSuggestionsRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the project containing the edit sessions or requests
         */
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/edit-sessions/context-suggestions';
};

export type ListContextSuggestionsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListContextSuggestionsError = ListContextSuggestionsErrors[keyof ListContextSuggestionsErrors];

export type ListContextSuggestionsResponses = {
    /**
     * Context suggestions retrieved successfully
     */
    200: ContextSuggestionsResponse;
};

export type ListContextSuggestionsResponse = ListContextSuggestionsResponses[keyof ListContextSuggestionsResponses];

export type ListEditSessionsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the project whose edit sessions are being requested
         */
        proj_id: string;
    };
    query?: {
        /**
         * Filter by archived status (true/false)
         */
        archived?: boolean;
    };
    url: '/projects/{proj_id}/edit-sessions';
};

export type ListEditSessionsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListEditSessionsError = ListEditSessionsErrors[keyof ListEditSessionsErrors];

export type ListEditSessionsResponses = {
    /**
     * Edit sessions retrieved successfully
     */
    200: EditSessionListResponse;
};

export type ListEditSessionsResponse = ListEditSessionsResponses[keyof ListEditSessionsResponses];

export type CreateEditSessionData = {
    body: CreateEditSessionRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the project where the edit session will be created
         */
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/edit-sessions';
};

export type CreateEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateEditSessionError = CreateEditSessionErrors[keyof CreateEditSessionErrors];

export type CreateEditSessionResponses = {
    /**
     * Edit session created successfully
     */
    201: EditSessionResponse;
};

export type CreateEditSessionResponse = CreateEditSessionResponses[keyof CreateEditSessionResponses];

export type DeleteEditSessionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session to delete
         */
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}';
};

export type DeleteEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteEditSessionError = DeleteEditSessionErrors[keyof DeleteEditSessionErrors];

export type DeleteEditSessionResponses = {
    /**
     * Edit session deleted successfully
     */
    204: void;
};

export type DeleteEditSessionResponse = DeleteEditSessionResponses[keyof DeleteEditSessionResponses];

export type GetEditSessionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session to retrieve
         */
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}';
};

export type GetEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionError = GetEditSessionErrors[keyof GetEditSessionErrors];

export type GetEditSessionResponses = {
    /**
     * Edit session retrieved successfully
     */
    200: EditSessionResponse;
};

export type GetEditSessionResponse = GetEditSessionResponses[keyof GetEditSessionResponses];

export type UpdateEditSessionData = {
    body: UpdateEditSessionRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session to update
         */
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}';
};

export type UpdateEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateEditSessionError = UpdateEditSessionErrors[keyof UpdateEditSessionErrors];

export type UpdateEditSessionResponses = {
    /**
     * Edit session updated successfully
     */
    200: EditSessionResponse;
};

export type UpdateEditSessionResponse = UpdateEditSessionResponses[keyof UpdateEditSessionResponses];

export type ArchiveEditSessionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session to discard
         */
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/actions/archive';
};

export type ArchiveEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ArchiveEditSessionError = ArchiveEditSessionErrors[keyof ArchiveEditSessionErrors];

export type ArchiveEditSessionResponses = {
    /**
     * Edit session archived successfully
     */
    200: EditSessionResponse;
};

export type ArchiveEditSessionResponse = ArchiveEditSessionResponses[keyof ArchiveEditSessionResponses];

export type UndoEditSessionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session
         */
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/actions/undo';
};

export type UndoEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UndoEditSessionError = UndoEditSessionErrors[keyof UndoEditSessionErrors];

export type UndoEditSessionResponses = {
    /**
     * Change undone successfully
     */
    204: void;
};

export type UndoEditSessionResponse = UndoEditSessionResponses[keyof UndoEditSessionResponses];

export type RedoEditSessionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session
         */
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/actions/redo';
};

export type RedoEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedoEditSessionError = RedoEditSessionErrors[keyof RedoEditSessionErrors];

export type RedoEditSessionResponses = {
    /**
     * Change redone successfully
     */
    204: void;
};

export type RedoEditSessionResponse = RedoEditSessionResponses[keyof RedoEditSessionResponses];

export type RevertEditSessionData = {
    body?: RevertEditUnitRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session
         */
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/actions/revert';
};

export type RevertEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit session is archived and cannot be restored
     */
    409: unknown;
    /**
     * Invalid history item ID or selected version not found
     */
    422: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RevertEditSessionError = RevertEditSessionErrors[keyof RevertEditSessionErrors];

export type RevertEditSessionResponses = {
    /**
     * Content restored successfully
     */
    204: void;
};

export type RevertEditSessionResponse = RevertEditSessionResponses[keyof RevertEditSessionResponses];

export type ListEditSessionHistoryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session
         */
        es_id: string;
    };
    query?: {
        /**
         * Maximum number of items to return per page.
         *
         * This parameter is only valid on the initial request. When using `cursor`,
         * the page size is encoded in the cursor and this parameter must be omitted.
         *
         */
        page_size?: number;
        /**
         * Opaque pagination cursor from a previous response (`previous_cursor` or `next_cursor`).
         *
         * **Usage Pattern:**
         * - First request: Omit `cursor`, provide `page_size` and any filters
         * - Subsequent requests: Provide only `cursor`, omit all other parameters
         *
         * The cursor encodes all request state (filters, page_size, position), so when
         * using a cursor, do not include any other parameters. Providing `cursor` with
         * `page_size`, `around`, or any filter returns `422 Unprocessable Entity`.
         *
         * Cursors are opaque strings - do not parse or construct them. They may expire
         * after extended periods; start fresh pagination for new sessions.
         *
         */
        cursor?: string;
        /**
         * File selector to limit history to a single file, with optional structured-value filtering using `(<file-path>|@<file-id>)#<json-pointer>[*][=]`.
         * Use an absolute-style file path from project root (must start with '/') or `@<file-id>` to resolve a file node ID.
         *
         * Examples: `/content.yaml#/project/items/0/name`, `@file_123#/project/items/0/name`.
         *
         * Two orthogonal trailing sigils refine structured-property matching:
         * - `*` (subtree axis): match any descendant of the pointer in addition to the pointer itself.
         * - `=` (anchored): disable upward widening. Without `=`, the match also includes ancestor container wildcards and whole-file changes.
         *
         * The sigils combine as `/foo/bar`, `/foo/bar=`, `/foo*`, and `/foo*=`. Order is fixed: `*` must precede `=`.
         *
         */
        path?: string;
    };
    url: '/edit-sessions/{es_id}/content/history';
};

export type ListEditSessionHistoryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListEditSessionHistoryError = ListEditSessionHistoryErrors[keyof ListEditSessionHistoryErrors];

export type ListEditSessionHistoryResponses = {
    /**
     * Change history retrieved successfully
     */
    200: ListResponseBase & {
        items: Array<HistoryItem>;
    };
};

export type ListEditSessionHistoryResponse = ListEditSessionHistoryResponses[keyof ListEditSessionHistoryResponses];

export type GetEditSessionHistoryItemData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session
         */
        es_id: string;
        /**
         * The history item ID
         */
        item_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/history/{item_id}';
};

export type GetEditSessionHistoryItemErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionHistoryItemError = GetEditSessionHistoryItemErrors[keyof GetEditSessionHistoryItemErrors];

export type GetEditSessionHistoryItemResponses = {
    /**
     * History item retrieved successfully
     */
    200: HistoryItem;
};

export type GetEditSessionHistoryItemResponse = GetEditSessionHistoryItemResponses[keyof GetEditSessionHistoryItemResponses];

export type GetEditSessionHistoryItemDiffData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session
         */
        es_id: string;
        /**
         * The public history version ID to diff. Legacy full or unambiguous short Git hashes are also accepted.
         */
        item_id: string;
    };
    query?: {
        /**
         * The public history version ID to compare with. Legacy full or unambiguous short Git hashes are also accepted. When provided, compares the selected item directly to this target (selected to target).
         */
        compare_to?: string;
        /**
         * Absolute-style path from project root (must start with '/') to limit the diff to. May be provided multiple times to include multiple paths. Mutually exclusive with file_id.
         */
        path?: Array<string>;
        /**
         * Stable file node ID to follow independently at both historical endpoints. Mutually exclusive with path.
         */
        file_id?: string;
        /**
         * JSONPointer path for structured value filtering (for example /project/characters/0/name). Requires exactly one filter target via path or file_id. Explicit comparisons remain strictly scoped to this property and return HISTORY_PROPERTY_DIFF_UNAVAILABLE when that scope cannot be preserved.
         */
        property_path?: string;
        /**
         * Number of context lines to include in the unified diff output, with default value of 3.
         */
        context?: number;
    };
    url: '/edit-sessions/{es_id}/content/history/{item_id}/diff';
};

export type GetEditSessionHistoryItemDiffErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Error body `{ message, kind }`; kind is `VALIDATION_FAILED`, `BAD_ARGUMENT`, `HISTORY_DIFF_TOO_LARGE`, or `HISTORY_PROPERTY_DIFF_UNAVAILABLE`.
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
    /**
     * Error body `{ message, kind }` with kind `HISTORY_DIFF_TIMEOUT`.
     */
    504: Error;
};

export type GetEditSessionHistoryItemDiffError = GetEditSessionHistoryItemDiffErrors[keyof GetEditSessionHistoryItemDiffErrors];

export type GetEditSessionHistoryItemDiffResponses = {
    /**
     * Unified diff returned successfully
     */
    200: string;
};

export type GetEditSessionHistoryItemDiffResponse = GetEditSessionHistoryItemDiffResponses[keyof GetEditSessionHistoryItemDiffResponses];

export type GetEditSessionHistoryItemSummaryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session
         */
        es_id: string;
        /**
         * The selected public history version ID. Legacy full or unambiguous short Git hashes are also accepted.
         */
        item_id: string;
    };
    query?: {
        /**
         * The public history version ID used as the direct comparison target. Legacy full or unambiguous short Git hashes are also accepted.
         */
        compare_to?: string;
        /**
         * The displayed public history version ID (or legacy Git selector). Must resolve to a comparison endpoint. When supplied, summaries may include labeled references into that snapshot.
         */
        navigation_version_id?: string;
    };
    url: '/edit-sessions/{es_id}/content/history/{item_id}/summary';
};

export type GetEditSessionHistoryItemSummaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Error body `{ message, kind }`; kind is `VALIDATION_FAILED`, `BAD_ARGUMENT`, or `HISTORY_DIFF_TOO_LARGE`.
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
    /**
     * Error body `{ message, kind }` with kind `HISTORY_DIFF_TIMEOUT`.
     */
    504: Error;
};

export type GetEditSessionHistoryItemSummaryError = GetEditSessionHistoryItemSummaryErrors[keyof GetEditSessionHistoryItemSummaryErrors];

export type GetEditSessionHistoryItemSummaryResponses = {
    /**
     * Human-readable history comparison summary returned successfully
     */
    200: HistoryComparisonSummaryResponse;
};

export type GetEditSessionHistoryItemSummaryResponse = GetEditSessionHistoryItemSummaryResponses[keyof GetEditSessionHistoryItemSummaryResponses];

export type CanMergeEditSessionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session to check
         */
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/actions/can-merge';
};

export type CanMergeEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Merge conflicts detected (same as merge endpoint)
     */
    409: MergeResult;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CanMergeEditSessionError = CanMergeEditSessionErrors[keyof CanMergeEditSessionErrors];

export type CanMergeEditSessionResponses = {
    /**
     * It is possible to merge the edit session, no conflicts detected; or there is nothing to merge
     */
    200: MergeResult;
};

export type CanMergeEditSessionResponse = CanMergeEditSessionResponses[keyof CanMergeEditSessionResponses];

export type MergeEditSessionData = {
    body?: MergeEditSessionRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session to merge
         */
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/actions/merge';
};

export type MergeEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Merge conflicts detected
     */
    409: MergeResult;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type MergeEditSessionError = MergeEditSessionErrors[keyof MergeEditSessionErrors];

export type MergeEditSessionResponses = {
    /**
     * Edit session merged successfully
     */
    200: MergeResult;
};

export type MergeEditSessionResponse = MergeEditSessionResponses[keyof MergeEditSessionResponses];

export type CanSyncEditSessionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session to check
         */
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/actions/can-sync';
};

export type CanSyncEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Sync conflicts detected (same as sync endpoint)
     */
    409: MergeResult;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CanSyncEditSessionError = CanSyncEditSessionErrors[keyof CanSyncEditSessionErrors];

export type CanSyncEditSessionResponses = {
    /**
     * It is possible to sync the edit session, no conflicts detected; or there is nothing to sync
     */
    200: MergeResult;
};

export type CanSyncEditSessionResponse = CanSyncEditSessionResponses[keyof CanSyncEditSessionResponses];

export type SyncEditSessionData = {
    body?: MergeEditSessionRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session to synchronize
         */
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/content/actions/sync';
};

export type SyncEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Sync conflicts detected
     */
    409: MergeResult;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type SyncEditSessionError = SyncEditSessionErrors[keyof SyncEditSessionErrors];

export type SyncEditSessionResponses = {
    /**
     * Edit session synchronized successfully; or there was nothing to sync
     */
    200: MergeResult;
};

export type SyncEditSessionResponse = SyncEditSessionResponses[keyof SyncEditSessionResponses];

export type GetEditSessionDiffData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session to diff
         */
        es_id: string;
    };
    query?: {
        /**
         * Absolute-style path from project root (must start with '/') to limit the diff to. The path must be cleaned (no trailing slash, no `./..` segments); otherwise the request is rejected with `invalid path`. May be provided multiple times to include multiple paths. Mutually exclusive with file_id.
         */
        path?: Array<string>;
        /**
         * File node ID to limit the diff to a single file. Mutually exclusive with path.
         */
        file_id?: string;
        /**
         * JSONPointer path for structured value filtering (for example /project/characters/0/name). Requires exactly one filter target via path or file_id.
         */
        property_path?: string;
        /**
         * Number of context lines to include in the unified diff output, with default value of 3.
         */
        context?: number;
        /**
         * Controls which diff to return.
         * - `current`: live two-dot diff of the edit session against the main project branch.
         * - `applied`: cumulative historical diff of what this edit session has contributed to main across all applies (BaseCommit to last MergeCommit). Returns empty if never applied.
         * - `own_changes` (default): directional since-fork diff of changes made on the edit session branch since it forked from main (`main...edit-session`).
         * - `parent_changes`: directional since-fork diff of changes made on main since the edit session forked (`edit-session...main`).
         *
         */
        view?: 'own_changes' | 'current' | 'applied' | 'parent_changes';
    };
    url: '/edit-sessions/{es_id}/content/diff';
};

export type GetEditSessionDiffErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionDiffError = GetEditSessionDiffErrors[keyof GetEditSessionDiffErrors];

export type GetEditSessionDiffResponses = {
    /**
     * Diff view returned successfully
     */
    200: DiffViewResponse;
};

export type GetEditSessionDiffResponse = GetEditSessionDiffResponses[keyof GetEditSessionDiffResponses];

export type ListEditSessionThreadsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session whose threads are requested
         */
        es_id: string;
    };
    query?: {
        /**
         * Filter by archived status (true/false). Defaults to false (non-archived threads only)
         */
        archived?: boolean;
    };
    url: '/edit-sessions/{es_id}/threads';
};

export type ListEditSessionThreadsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListEditSessionThreadsError = ListEditSessionThreadsErrors[keyof ListEditSessionThreadsErrors];

export type ListEditSessionThreadsResponses = {
    /**
     * Threads retrieved successfully
     */
    200: Array<EditSessionThread>;
};

export type ListEditSessionThreadsResponse = ListEditSessionThreadsResponses[keyof ListEditSessionThreadsResponses];

export type CreateEditSessionThreadData = {
    body: CreateThreadRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session to create a chat in
         */
        es_id: string;
    };
    query?: {
        /**
         * Optional message ID to branch from. If provided, the ChatBranch starts from that message (inheriting all prior context)
         */
        branching_message_id?: string;
    };
    url: '/edit-sessions/{es_id}/threads';
};

export type CreateEditSessionThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateEditSessionThreadError = CreateEditSessionThreadErrors[keyof CreateEditSessionThreadErrors];

export type CreateEditSessionThreadResponses = {
    /**
     * Thread created successfully
     */
    201: EditSessionThread;
};

export type CreateEditSessionThreadResponse = CreateEditSessionThreadResponses[keyof CreateEditSessionThreadResponses];

export type ListEditSessionChatsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/chats';
};

export type ListEditSessionChatsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListEditSessionChatsError = ListEditSessionChatsErrors[keyof ListEditSessionChatsErrors];

export type ListEditSessionChatsResponses = {
    /**
     * Chats retrieved successfully
     */
    200: Array<ChatInfo>;
};

export type ListEditSessionChatsResponse = ListEditSessionChatsResponses[keyof ListEditSessionChatsResponses];

export type CreateEditSessionChatData = {
    body?: CreateChatRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/chats';
};

export type CreateEditSessionChatErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateEditSessionChatError = CreateEditSessionChatErrors[keyof CreateEditSessionChatErrors];

export type CreateEditSessionChatResponses = {
    /**
     * Chat created successfully
     */
    201: Chat;
};

export type CreateEditSessionChatResponse = CreateEditSessionChatResponses[keyof CreateEditSessionChatResponses];

export type ListThreadFsEntriesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
        /**
         * Scope to subfolder path
         */
        path?: string;
        /**
         * Filter by StructuredType name
         */
        type?: string;
        /**
         * Filter by file extension
         */
        extension?: string;
        /**
         * Filter by import status
         */
        import_status?: ImportStatus;
    };
    url: '/edit-session-threads/{thread_id}/content/fs';
};

export type ListThreadFsEntriesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListThreadFsEntriesError = ListThreadFsEntriesErrors[keyof ListThreadFsEntriesErrors];

export type ListThreadFsEntriesResponses = {
    /**
     * File system entry and its contents
     */
    200: FsListResponse;
};

export type ListThreadFsEntriesResponse = ListThreadFsEntriesResponses[keyof ListThreadFsEntriesResponses];

export type CreateThreadFsEntryData = {
    body: CreateFsEntryRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/fs';
};

export type CreateThreadFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateThreadFsEntryError = CreateThreadFsEntryErrors[keyof CreateThreadFsEntryErrors];

export type CreateThreadFsEntryResponses = {
    /**
     * Created file system entry
     */
    201: FsEntry;
};

export type CreateThreadFsEntryResponse = CreateThreadFsEntryResponses[keyof CreateThreadFsEntryResponses];

export type DeleteThreadFsEntryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/fs/{id}';
};

export type DeleteThreadFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteThreadFsEntryError = DeleteThreadFsEntryErrors[keyof DeleteThreadFsEntryErrors];

export type DeleteThreadFsEntryResponses = {
    /**
     * File system entry deleted
     */
    204: void;
};

export type DeleteThreadFsEntryResponse = DeleteThreadFsEntryResponses[keyof DeleteThreadFsEntryResponses];

export type GetThreadFsEntryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-session-threads/{thread_id}/content/fs/{id}';
};

export type GetThreadFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadFsEntryError = GetThreadFsEntryErrors[keyof GetThreadFsEntryErrors];

export type GetThreadFsEntryResponses = {
    /**
     * File system entry metadata
     */
    200: FsEntry;
};

export type GetThreadFsEntryResponse = GetThreadFsEntryResponses[keyof GetThreadFsEntryResponses];

export type UpdateThreadFsEntryData = {
    body: UpdateFsEntryRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/fs/{id}';
};

export type UpdateThreadFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateThreadFsEntryError = UpdateThreadFsEntryErrors[keyof UpdateThreadFsEntryErrors];

export type UpdateThreadFsEntryResponses = {
    /**
     * Updated file system entry
     */
    200: FsEntry;
};

export type UpdateThreadFsEntryResponse = UpdateThreadFsEntryResponses[keyof UpdateThreadFsEntryResponses];

export type GetThreadFsEntryContentData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-session-threads/{thread_id}/content/fs/{id}/content';
};

export type GetThreadFsEntryContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadFsEntryContentError = GetThreadFsEntryContentErrors[keyof GetThreadFsEntryContentErrors];

export type PatchThreadFsEntryContentData = {
    body: PatchFsEntryContentRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: {
        /**
         * Apply the JSON Patch in strict mode without replace transformation or implicit path creation.
         */
        strict?: boolean;
    };
    url: '/edit-session-threads/{thread_id}/content/fs/{id}/content';
};

export type PatchThreadFsEntryContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type PatchThreadFsEntryContentError = PatchThreadFsEntryContentErrors[keyof PatchThreadFsEntryContentErrors];

export type PatchThreadFsEntryContentResponses = {
    /**
     * Updated file metadata
     */
    200: FsEntry;
};

export type PatchThreadFsEntryContentResponse = PatchThreadFsEntryContentResponses[keyof PatchThreadFsEntryContentResponses];

export type RequestThreadUploadUrlData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/fs/{id}/content';
};

export type RequestThreadUploadUrlErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RequestThreadUploadUrlError = RequestThreadUploadUrlErrors[keyof RequestThreadUploadUrlErrors];

export type RequestThreadUploadUrlResponses = {
    /**
     * Upload URL info
     */
    200: RequestUploadUrlResponse;
};

export type RequestThreadUploadUrlResponse = RequestThreadUploadUrlResponses[keyof RequestThreadUploadUrlResponses];

export type ReplaceThreadFsEntryContentData = {
    body: ReplaceFsEntryContentRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/fs/{id}/content';
};

export type ReplaceThreadFsEntryContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * File content changed or the edit unit is unavailable
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ReplaceThreadFsEntryContentError = ReplaceThreadFsEntryContentErrors[keyof ReplaceThreadFsEntryContentErrors];

export type ReplaceThreadFsEntryContentResponses = {
    /**
     * Updated file metadata
     */
    200: FsEntry;
};

export type ReplaceThreadFsEntryContentResponse = ReplaceThreadFsEntryContentResponses[keyof ReplaceThreadFsEntryContentResponses];

export type GetThreadFsEntryByPathData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        /**
         * File path encoded as a single (percent-encoded) URL path segment.
         */
        path: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-session-threads/{thread_id}/content/fs-by-path/{path}';
};

export type GetThreadFsEntryByPathErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadFsEntryByPathError = GetThreadFsEntryByPathErrors[keyof GetThreadFsEntryByPathErrors];

export type GetThreadFsEntryByPathResponses = {
    /**
     * File system entry metadata
     */
    200: FsEntry;
};

export type GetThreadFsEntryByPathResponse = GetThreadFsEntryByPathResponses[keyof GetThreadFsEntryByPathResponses];

export type GetThreadFsEntryContentByPathData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        /**
         * File path encoded as a single (percent-encoded) URL path segment.
         */
        path: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-session-threads/{thread_id}/content/fs-by-path/{path}/content';
};

export type GetThreadFsEntryContentByPathErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadFsEntryContentByPathError = GetThreadFsEntryContentByPathErrors[keyof GetThreadFsEntryContentByPathErrors];

export type CopyThreadFsEntryData = {
    body: CopyRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/fs/{id}/actions/copy';
};

export type CopyThreadFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CopyThreadFsEntryError = CopyThreadFsEntryErrors[keyof CopyThreadFsEntryErrors];

export type CopyThreadFsEntryResponses = {
    /**
     * File copied
     */
    200: CopyFsEntryResponse;
};

export type CopyThreadFsEntryResponse = CopyThreadFsEntryResponses[keyof CopyThreadFsEntryResponses];

export type ReimportThreadFsEntryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/fs/{id}/actions/reimport';
};

export type ReimportThreadFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ReimportThreadFsEntryError = ReimportThreadFsEntryErrors[keyof ReimportThreadFsEntryErrors];

export type ReimportThreadFsEntryResponses = {
    /**
     * Reimport triggered
     */
    202: unknown;
};

export type ValidateThreadFsEntryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/fs/{id}/actions/validate';
};

export type ValidateThreadFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Target is a folder, not a file
     */
    422: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ValidateThreadFsEntryError = ValidateThreadFsEntryErrors[keyof ValidateThreadFsEntryErrors];

export type ValidateThreadFsEntryResponses = {
    /**
     * Validation result for the file
     */
    200: ProblemsResponse;
};

export type ValidateThreadFsEntryResponse = ValidateThreadFsEntryResponses[keyof ValidateThreadFsEntryResponses];

export type CreateThreadFsEntryFromDataData = {
    body: CreateFromDataRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        folder_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/fs/{folder_id}/actions/create-from-data';
};

export type CreateThreadFsEntryFromDataErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateThreadFsEntryFromDataError = CreateThreadFsEntryFromDataErrors[keyof CreateThreadFsEntryFromDataErrors];

export type CreateThreadFsEntryFromDataResponses = {
    /**
     * File created
     */
    201: FsEntry;
};

export type CreateThreadFsEntryFromDataResponse = CreateThreadFsEntryFromDataResponses[keyof CreateThreadFsEntryFromDataResponses];

export type ListThreadProblemsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: {
        severity?: ProblemSeverity;
        /**
         * Filter to problems anchored to this file (matches `Problem.source.id`).
         */
        file_id?: string;
    };
    url: '/edit-session-threads/{thread_id}/problems';
};

export type ListThreadProblemsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListThreadProblemsError = ListThreadProblemsErrors[keyof ListThreadProblemsErrors];

export type ListThreadProblemsResponses = {
    /**
     * List of problems for the thread
     */
    200: ProblemsResponse;
};

export type ListThreadProblemsResponse = ListThreadProblemsResponses[keyof ListThreadProblemsResponses];

export type ReimportThreadContentPathData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/actions/reimport';
};

export type ReimportThreadContentPathErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ReimportThreadContentPathError = ReimportThreadContentPathErrors[keyof ReimportThreadContentPathErrors];

export type ReimportThreadContentPathResponses = {
    /**
     * Reimport triggered
     */
    202: unknown;
};

export type TriggerThreadValidationData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/actions/validate';
};

export type TriggerThreadValidationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type TriggerThreadValidationError = TriggerThreadValidationErrors[keyof TriggerThreadValidationErrors];

export type TriggerThreadValidationResponses = {
    /**
     * Validation triggered
     */
    202: unknown;
};

export type RefreshThreadContentTreeData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: {
        /**
         * Scope to a subtree. Defaults to "/".
         *
         */
        path?: string;
    };
    url: '/edit-session-threads/{thread_id}/content/tree/actions/refresh';
};

export type RefreshThreadContentTreeErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RefreshThreadContentTreeError = RefreshThreadContentTreeErrors[keyof RefreshThreadContentTreeErrors];

export type RefreshThreadContentTreeResponses = {
    /**
     * Tree refresh triggered
     */
    202: unknown;
};

export type GetThreadContentTreeData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
        /**
         * Historical version to compare with when `version_id` is present. The returned tree
         * remains the selected `version_id` snapshot, while `modified` markers reflect the
         * direct comparison with this target. Omit it to compare with the selected version's
         * first parent or the empty tree.
         *
         */
        compare_to?: string;
        /**
         * Scope to a subtree. Returns the specified node and all its descendants.
         * Example: "/Rooms" returns the Rooms folder and all files within it.
         *
         */
        path?: string;
        /**
         * Deprecated: use `relative_depth` instead. Identical semantics; this parameter will be removed in a future version.
         * Limit tree depth. Depth is relative to the root (or path parameter).
         * - depth=0: Only root nodes
         * - depth=1: Root + immediate children
         * - null: Unlimited (default)
         *
         *
         * @deprecated
         */
        depth?: number;
        /**
         * Limit tree depth, relative to the root (or path parameter). Supersedes the deprecated `depth` parameter; if both are given, relative_depth takes precedence.
         * - relative_depth=0: Only root nodes
         * - relative_depth=1: Root + immediate children
         * - null: Unlimited (default)
         *
         */
        relative_depth?: number;
        /**
         * Filter by MIME type (e.g., "application/vnd.dreamstudio.value.room+yaml").
         * Returns matching files and their ancestor folders.
         *
         */
        type?: string;
    };
    url: '/edit-session-threads/{thread_id}/content/tree';
};

export type GetThreadContentTreeErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadContentTreeError = GetThreadContentTreeErrors[keyof GetThreadContentTreeErrors];

export type GetThreadContentTreeResponses = {
    /**
     * Flat array of tree nodes
     */
    200: ContentTreeResponse;
};

export type GetThreadContentTreeResponse = GetThreadContentTreeResponses[keyof GetThreadContentTreeResponses];

export type DeleteThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread being updated
         */
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}';
};

export type DeleteThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteThreadError = DeleteThreadErrors[keyof DeleteThreadErrors];

export type DeleteThreadResponses = {
    /**
     * Thread deleted successfully
     */
    204: void;
};

export type DeleteThreadResponse = DeleteThreadResponses[keyof DeleteThreadResponses];

export type GetThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread the operation targets
         */
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}';
};

export type GetThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadError = GetThreadErrors[keyof GetThreadErrors];

export type GetThreadResponses = {
    /**
     * Thread retrieved successfully
     */
    200: EditSessionThread;
};

export type GetThreadResponse = GetThreadResponses[keyof GetThreadResponses];

export type UpdateThreadData = {
    body: UpdateThreadRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread the operation targets
         */
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}';
};

export type UpdateThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateThreadError = UpdateThreadErrors[keyof UpdateThreadErrors];

export type UpdateThreadResponses = {
    /**
     * Thread updated successfully
     */
    200: EditSessionThread;
};

export type UpdateThreadResponse = UpdateThreadResponses[keyof UpdateThreadResponses];

export type ArchiveThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/actions/archive';
};

export type ArchiveThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ArchiveThreadError = ArchiveThreadErrors[keyof ArchiveThreadErrors];

export type ArchiveThreadResponses = {
    /**
     * Thread archived successfully
     */
    200: EditSessionThread;
};

export type ArchiveThreadResponse = ArchiveThreadResponses[keyof ArchiveThreadResponses];

export type UnarchiveThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/actions/unarchive';
};

export type UnarchiveThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UnarchiveThreadError = UnarchiveThreadErrors[keyof UnarchiveThreadErrors];

export type UnarchiveThreadResponses = {
    /**
     * Thread unarchived successfully
     */
    200: EditSessionThread;
};

export type UnarchiveThreadResponse = UnarchiveThreadResponses[keyof UnarchiveThreadResponses];

export type CanMergeThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread to check
         */
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/actions/can-merge';
};

export type CanMergeThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Merge conflicts detected (same as merge endpoint)
     */
    409: MergeResult;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CanMergeThreadError = CanMergeThreadErrors[keyof CanMergeThreadErrors];

export type CanMergeThreadResponses = {
    /**
     * It is possible to merge the thread, no conflicts detected
     */
    200: MergeResult;
};

export type CanMergeThreadResponse = CanMergeThreadResponses[keyof CanMergeThreadResponses];

export type MergeThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread to merge
         */
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/actions/merge';
};

export type MergeThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type MergeThreadError = MergeThreadErrors[keyof MergeThreadErrors];

export type MergeThreadResponses = {
    /**
     * Thread merged successfully; or there was nothing to merge
     */
    200: ThreadMergeOutcome;
    /**
     * Real content conflict detected; an AI-assisted merge resolution has started
     */
    202: ThreadMergeOutcome;
};

export type MergeThreadResponse = MergeThreadResponses[keyof MergeThreadResponses];

export type CanSyncThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread to check
         */
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/actions/can-sync';
};

export type CanSyncThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Sync conflicts detected (same as sync endpoint)
     */
    409: MergeResult;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CanSyncThreadError = CanSyncThreadErrors[keyof CanSyncThreadErrors];

export type CanSyncThreadResponses = {
    /**
     * It is possible to sync the thread, no conflicts detected
     */
    200: MergeResult;
};

export type CanSyncThreadResponse = CanSyncThreadResponses[keyof CanSyncThreadResponses];

export type SyncThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread to synchronize
         */
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/actions/sync';
};

export type SyncThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type SyncThreadError = SyncThreadErrors[keyof SyncThreadErrors];

export type SyncThreadResponses = {
    /**
     * Thread synchronized successfully
     */
    200: ThreadMergeOutcome;
    /**
     * Real content conflict detected; an AI-assisted merge resolution has started
     */
    202: ThreadMergeOutcome;
};

export type SyncThreadResponse = SyncThreadResponses[keyof SyncThreadResponses];

export type CancelMergeResolutionThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread whose merge resolution should be cancelled
         */
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/actions/cancel-merge-resolution';
};

export type CancelMergeResolutionThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CancelMergeResolutionThreadError = CancelMergeResolutionThreadErrors[keyof CancelMergeResolutionThreadErrors];

export type CancelMergeResolutionThreadResponses = {
    /**
     * Merge resolution cancelled successfully
     */
    204: void;
};

export type CancelMergeResolutionThreadResponse = CancelMergeResolutionThreadResponses[keyof CancelMergeResolutionThreadResponses];

export type GetThreadDiffData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread to diff
         */
        thread_id: string;
    };
    query?: {
        /**
         * Absolute-style path from project root (must start with '/') to limit the diff to. The path must be cleaned (no trailing slash, no `./..` segments); otherwise the request is rejected with `invalid path`. May be provided multiple times to include multiple paths. Mutually exclusive with file_id.
         */
        path?: Array<string>;
        /**
         * File node ID to limit the diff to a single file. Mutually exclusive with path.
         */
        file_id?: string;
        /**
         * JSONPointer path for structured value filtering (for example /project/characters/0/name). Requires exactly one filter target via path or file_id.
         */
        property_path?: string;
        /**
         * Number of context lines to include in the unified diff output, with default value of 3.
         */
        context?: number;
        /**
         * Controls which diff to return.
         * - `current`: live two-dot diff of the thread against its parent edit session branch.
         * - `applied`: cumulative historical diff of what this thread has contributed to the edit session across all applies (BaseCommit to last MergeCommit). Returns empty if never applied.
         * - `own_changes` (default): directional since-fork diff of changes made on the thread branch since it forked from the edit session (`edit-session...thread`).
         * - `parent_changes`: directional since-fork diff of changes made on the edit session branch since the thread forked (`thread...edit-session`).
         *
         */
        view?: 'current' | 'applied' | 'own_changes' | 'parent_changes';
    };
    url: '/edit-session-threads/{thread_id}/content/diff';
};

export type GetThreadDiffErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadDiffError = GetThreadDiffErrors[keyof GetThreadDiffErrors];

export type GetThreadDiffResponses = {
    /**
     * Diff view returned successfully
     */
    200: DiffViewResponse;
};

export type GetThreadDiffResponse = GetThreadDiffResponses[keyof GetThreadDiffResponses];

export type ListThreadHistoryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread
         */
        thread_id: string;
    };
    query?: {
        /**
         * Maximum number of items to return per page.
         *
         * This parameter is only valid on the initial request. When using `cursor`,
         * the page size is encoded in the cursor and this parameter must be omitted.
         *
         */
        page_size?: number;
        /**
         * Opaque pagination cursor from a previous response (`previous_cursor` or `next_cursor`).
         *
         * **Usage Pattern:**
         * - First request: Omit `cursor`, provide `page_size` and any filters
         * - Subsequent requests: Provide only `cursor`, omit all other parameters
         *
         * The cursor encodes all request state (filters, page_size, position), so when
         * using a cursor, do not include any other parameters. Providing `cursor` with
         * `page_size`, `around`, or any filter returns `422 Unprocessable Entity`.
         *
         * Cursors are opaque strings - do not parse or construct them. They may expire
         * after extended periods; start fresh pagination for new sessions.
         *
         */
        cursor?: string;
        /**
         * File selector to limit history to a single file, with optional structured-value filtering using `(<file-path>|@<file-id>)#<json-pointer>[*][=]`.
         * Use an absolute-style file path from project root (must start with '/') or `@<file-id>` to resolve a file node ID.
         *
         * Examples: `/content.yaml#/project/items/0/name`, `@file_123#/project/items/0/name`.
         *
         * Two orthogonal trailing sigils refine structured-property matching:
         * - `*` (subtree axis): match any descendant of the pointer in addition to the pointer itself.
         * - `=` (anchored): disable upward widening. Without `=`, the match also includes ancestor container wildcards and whole-file changes.
         *
         * The sigils combine as `/foo/bar`, `/foo/bar=`, `/foo*`, and `/foo*=`. Order is fixed: `*` must precede `=`.
         *
         */
        path?: string;
    };
    url: '/edit-session-threads/{thread_id}/content/history';
};

export type ListThreadHistoryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListThreadHistoryError = ListThreadHistoryErrors[keyof ListThreadHistoryErrors];

export type ListThreadHistoryResponses = {
    /**
     * Change history retrieved successfully
     */
    200: ListResponseBase & {
        items: Array<HistoryItem>;
    };
};

export type ListThreadHistoryResponse = ListThreadHistoryResponses[keyof ListThreadHistoryResponses];

export type GetThreadHistoryItemData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread
         */
        thread_id: string;
        /**
         * The history item ID
         */
        item_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/history/{item_id}';
};

export type GetThreadHistoryItemErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadHistoryItemError = GetThreadHistoryItemErrors[keyof GetThreadHistoryItemErrors];

export type GetThreadHistoryItemResponses = {
    /**
     * History item retrieved successfully
     */
    200: HistoryItem;
};

export type GetThreadHistoryItemResponse = GetThreadHistoryItemResponses[keyof GetThreadHistoryItemResponses];

export type GetThreadHistoryItemDiffData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread
         */
        thread_id: string;
        /**
         * The public history version ID to diff. Legacy full or unambiguous short Git hashes are also accepted.
         */
        item_id: string;
    };
    query?: {
        /**
         * The public history version ID to compare with. Legacy full or unambiguous short Git hashes are also accepted. When provided, compares the selected item directly to this target (selected to target).
         */
        compare_to?: string;
        /**
         * Absolute-style path from project root (must start with '/') to limit the diff to. The path must be cleaned (no trailing slash, no `./..` segments); otherwise the request is rejected with `invalid path`. May be provided multiple times to include multiple paths. Mutually exclusive with file_id.
         */
        path?: Array<string>;
        /**
         * Stable file node ID to follow independently at both historical endpoints. Mutually exclusive with path.
         */
        file_id?: string;
        /**
         * JSONPointer path for structured value filtering (for example /project/characters/0/name). Requires exactly one filter target via path or file_id. Explicit comparisons remain strictly scoped to this property and return HISTORY_PROPERTY_DIFF_UNAVAILABLE when that scope cannot be preserved.
         */
        property_path?: string;
        /**
         * Number of context lines to include in the unified diff output, with default value of 3.
         */
        context?: number;
    };
    url: '/edit-session-threads/{thread_id}/content/history/{item_id}/diff';
};

export type GetThreadHistoryItemDiffErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Error body `{ message, kind }`; kind is `VALIDATION_FAILED`, `BAD_ARGUMENT`, `HISTORY_DIFF_TOO_LARGE`, or `HISTORY_PROPERTY_DIFF_UNAVAILABLE`.
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
    /**
     * Error body `{ message, kind }` with kind `HISTORY_DIFF_TIMEOUT`.
     */
    504: Error;
};

export type GetThreadHistoryItemDiffError = GetThreadHistoryItemDiffErrors[keyof GetThreadHistoryItemDiffErrors];

export type GetThreadHistoryItemDiffResponses = {
    /**
     * Unified diff returned successfully
     */
    200: string;
};

export type GetThreadHistoryItemDiffResponse = GetThreadHistoryItemDiffResponses[keyof GetThreadHistoryItemDiffResponses];

export type GetThreadHistoryItemSummaryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread
         */
        thread_id: string;
        /**
         * The selected public history version ID. Legacy full or unambiguous short Git hashes are also accepted.
         */
        item_id: string;
    };
    query?: {
        /**
         * The public history version ID used as the direct comparison target. Legacy full or unambiguous short Git hashes are also accepted.
         */
        compare_to?: string;
        /**
         * The displayed public history version ID (or legacy Git selector). Must resolve to a comparison endpoint. When supplied, summaries may include labeled references into that snapshot.
         */
        navigation_version_id?: string;
    };
    url: '/edit-session-threads/{thread_id}/content/history/{item_id}/summary';
};

export type GetThreadHistoryItemSummaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Edit unit is archived; its content is unavailable until it is unarchived
     */
    409: unknown;
    /**
     * Error body `{ message, kind }`; kind is `VALIDATION_FAILED`, `BAD_ARGUMENT`, or `HISTORY_DIFF_TOO_LARGE`.
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
    /**
     * Error body `{ message, kind }` with kind `HISTORY_DIFF_TIMEOUT`.
     */
    504: Error;
};

export type GetThreadHistoryItemSummaryError = GetThreadHistoryItemSummaryErrors[keyof GetThreadHistoryItemSummaryErrors];

export type GetThreadHistoryItemSummaryResponses = {
    /**
     * Human-readable history comparison summary returned successfully
     */
    200: HistoryComparisonSummaryResponse;
};

export type GetThreadHistoryItemSummaryResponse = GetThreadHistoryItemSummaryResponses[keyof GetThreadHistoryItemSummaryResponses];

export type RevertThreadData = {
    body?: RevertEditUnitRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the thread
         */
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/content/actions/revert';
};

export type RevertThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Thread is archived and cannot be restored
     */
    409: unknown;
    /**
     * Invalid history item ID or selected version not found
     */
    422: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RevertThreadError = RevertThreadErrors[keyof RevertThreadErrors];

export type RevertThreadResponses = {
    /**
     * Content restored successfully
     */
    204: void;
};

export type RevertThreadResponse = RevertThreadResponses[keyof RevertThreadResponses];

export type CreateEventChannelData = {
    body: CreateEventChannelRequest;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/events/channels';
};

export type CreateEventChannelErrors = {
    /**
     * Invalid channel request
     */
    400: unknown;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The user cannot view the requested scope
     */
    403: unknown;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateEventChannelError = CreateEventChannelErrors[keyof CreateEventChannelErrors];

export type CreateEventChannelResponses = {
    /**
     * Channel connection URL created
     */
    201: CreateEventChannelResponse;
};

export type CreateEventChannelResponse2 = CreateEventChannelResponses[keyof CreateEventChannelResponses];

export type ConnectEventChannelData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query: {
        /**
         * Short-lived channel token from the URL returned by POST /events/channels; binds the user, scope, and client identity.
         */
        token: string;
        /**
         * Initial channel name within the token's scope, 1 to 256 bytes. Events are shared only within the same scope and channel.
         */
        channel: string;
        /**
         * Comma-separated receive filters in resource:action form, with wildcards supported in either part. Omit to receive all event types in the channel. These filters do not change the publishable event types.
         */
        types?: Array<string>;
    };
    url: '/events/channels/connect';
};

export type ConnectEventChannelErrors = {
    /**
     * Invalid channel token or parameters
     */
    400: unknown;
    /**
     * Not Found
     */
    404: Error;
    /**
     * WebSocket upgrade required
     */
    426: unknown;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ConnectEventChannelError = ConnectEventChannelErrors[keyof ConnectEventChannelErrors];

export type StreamEventsData = {
    body?: never;
    headers?: {
        /**
         * Last event ID from previous connection (automatically sent by browser on reconnection). Takes precedence over `after_id` when both are provided.
         */
        'Last-Event-ID'?: number;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: {
        /**
         * Unix timestamp (inclusive) to get events from this time onward
         */
        since?: number;
        /**
         * Unix timestamp (exclusive) to get events strictly after this time
         */
        after?: number;
        /**
         * Event ID (exclusive) to get events strictly after this ID. Ignored when `Last-Event-ID` is provided.
         */
        after_id?: number;
        /**
         * Comma-separated list of event types to filter (format <resource>:<action>). You can use * to match any resource or action, the full wildcard is '*:*' which is equivalent to not sending any types.
         */
        types?: Array<string>;
        /**
         * Comma-separated list of source IDs to filter (format <resource>:<id>)
         */
        source_ids?: Array<string>;
    };
    url: '/events';
};

export type StreamEventsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type StreamEventsError = StreamEventsErrors[keyof StreamEventsErrors];

export type StreamEventsResponses = {
    /**
     * Server-Sent Events stream
     */
    200: Event;
};

export type StreamEventsResponse = StreamEventsResponses[keyof StreamEventsResponses];

export type ListProjectExternalRunsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
    };
    query?: {
        /**
         * Also list the project's edit-session and thread runs, each with its own scope.
         */
        include_all_scopes?: boolean;
        parent_run_id?: string;
        run_kind?: string;
        status?: 'queued' | 'active' | 'succeeded' | 'failed' | 'cancelled';
        requester_id?: string;
        limit?: number;
        offset?: number;
        /**
         * JSON-encoded object used for JSONB containment; at most 256 KiB.
         */
        input_snapshot_contains?: string;
    };
    url: '/projects/{project_id}/external-runs';
};

export type ListProjectExternalRunsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProjectExternalRunsError = ListProjectExternalRunsErrors[keyof ListProjectExternalRunsErrors];

export type ListProjectExternalRunsResponses = {
    /**
     * Project external runs
     */
    200: Array<ExternalRun>;
};

export type ListProjectExternalRunsResponse = ListProjectExternalRunsResponses[keyof ListProjectExternalRunsResponses];

export type CreateProjectExternalRunData = {
    body: ExternalRunCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/external-runs';
};

export type CreateProjectExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateProjectExternalRunError = CreateProjectExternalRunErrors[keyof CreateProjectExternalRunErrors];

export type CreateProjectExternalRunResponses = {
    /**
     * External run created
     */
    201: ExternalRun;
};

export type CreateProjectExternalRunResponse = CreateProjectExternalRunResponses[keyof CreateProjectExternalRunResponses];

export type DeleteProjectExternalRunData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
        run_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/external-runs/{run_id}';
};

export type DeleteProjectExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteProjectExternalRunError = DeleteProjectExternalRunErrors[keyof DeleteProjectExternalRunErrors];

export type DeleteProjectExternalRunResponses = {
    /**
     * External run deleted
     */
    204: void;
};

export type DeleteProjectExternalRunResponse = DeleteProjectExternalRunResponses[keyof DeleteProjectExternalRunResponses];

export type GetProjectExternalRunData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
        run_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/external-runs/{run_id}';
};

export type GetProjectExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetProjectExternalRunError = GetProjectExternalRunErrors[keyof GetProjectExternalRunErrors];

export type GetProjectExternalRunResponses = {
    /**
     * External run
     */
    200: ExternalRun;
};

export type GetProjectExternalRunResponse = GetProjectExternalRunResponses[keyof GetProjectExternalRunResponses];

export type UpdateProjectExternalRunSettingsData = {
    body: ExternalRunSettingsUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
        run_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/external-runs/{run_id}/settings';
};

export type UpdateProjectExternalRunSettingsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateProjectExternalRunSettingsError = UpdateProjectExternalRunSettingsErrors[keyof UpdateProjectExternalRunSettingsErrors];

export type UpdateProjectExternalRunSettingsResponses = {
    /**
     * Updated external run settings
     */
    200: ExternalRunSettings;
};

export type UpdateProjectExternalRunSettingsResponse = UpdateProjectExternalRunSettingsResponses[keyof UpdateProjectExternalRunSettingsResponses];

export type CreateProjectExternalRunWorkspaceTransactionData = {
    body: ExternalRunWorkspaceTransactionCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
        run_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/external-runs/{run_id}/workspace-transactions';
};

export type CreateProjectExternalRunWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateProjectExternalRunWorkspaceTransactionError = CreateProjectExternalRunWorkspaceTransactionErrors[keyof CreateProjectExternalRunWorkspaceTransactionErrors];

export type CreateProjectExternalRunWorkspaceTransactionResponses = {
    /**
     * Workspace transaction associated with the run
     */
    201: ExternalRunWorkspaceTransaction;
};

export type CreateProjectExternalRunWorkspaceTransactionResponse = CreateProjectExternalRunWorkspaceTransactionResponses[keyof CreateProjectExternalRunWorkspaceTransactionResponses];

export type StartProjectExternalRunData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
        run_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/external-runs/{run_id}/start';
};

export type StartProjectExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type StartProjectExternalRunError = StartProjectExternalRunErrors[keyof StartProjectExternalRunErrors];

export type StartProjectExternalRunResponses = {
    /**
     * External run started
     */
    200: ExternalRun;
};

export type StartProjectExternalRunResponse = StartProjectExternalRunResponses[keyof StartProjectExternalRunResponses];

export type CompleteProjectExternalRunData = {
    body: ExternalRunCompletion;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
        run_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/external-runs/{run_id}/complete';
};

export type CompleteProjectExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CompleteProjectExternalRunError = CompleteProjectExternalRunErrors[keyof CompleteProjectExternalRunErrors];

export type CompleteProjectExternalRunResponses = {
    /**
     * External run completed
     */
    200: ExternalRun;
};

export type CompleteProjectExternalRunResponse = CompleteProjectExternalRunResponses[keyof CompleteProjectExternalRunResponses];

export type CancelProjectExternalRunData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
        run_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/external-runs/{run_id}/cancel';
};

export type CancelProjectExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CancelProjectExternalRunError = CancelProjectExternalRunErrors[keyof CancelProjectExternalRunErrors];

export type CancelProjectExternalRunResponses = {
    /**
     * External run cancelled
     */
    200: ExternalRun;
};

export type CancelProjectExternalRunResponse = CancelProjectExternalRunResponses[keyof CancelProjectExternalRunResponses];

export type AppendProjectExternalRunRecordData = {
    body?: Blob | File;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
        run_id: string;
        record_kind: string;
    };
    query?: never;
    url: '/projects/{project_id}/external-runs/{run_id}/records/{record_kind}';
};

export type AppendProjectExternalRunRecordErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type AppendProjectExternalRunRecordError = AppendProjectExternalRunRecordErrors[keyof AppendProjectExternalRunRecordErrors];

export type AppendProjectExternalRunRecordResponses = {
    /**
     * External run record appended
     */
    201: ExternalRunRecord;
};

export type AppendProjectExternalRunRecordResponse = AppendProjectExternalRunRecordResponses[keyof AppendProjectExternalRunRecordResponses];

export type ListProjectExternalRunRecordsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
        run_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/external-runs/{run_id}/records';
};

export type ListProjectExternalRunRecordsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProjectExternalRunRecordsError = ListProjectExternalRunRecordsErrors[keyof ListProjectExternalRunRecordsErrors];

export type ListProjectExternalRunRecordsResponses = {
    /**
     * External run records in creation order
     */
    200: Array<ExternalRunRecord>;
};

export type ListProjectExternalRunRecordsResponse = ListProjectExternalRunRecordsResponses[keyof ListProjectExternalRunRecordsResponses];

export type GetProjectExternalRunRecordContentData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
        run_id: string;
        record_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/external-runs/{run_id}/records/{record_id}/content';
};

export type GetProjectExternalRunRecordContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetProjectExternalRunRecordContentError = GetProjectExternalRunRecordContentErrors[keyof GetProjectExternalRunRecordContentErrors];

export type GetProjectExternalRunRecordContentResponses = {
    /**
     * Exact external run record payload
     */
    200: Blob | File;
};

export type GetProjectExternalRunRecordContentResponse = GetProjectExternalRunRecordContentResponses[keyof GetProjectExternalRunRecordContentResponses];

export type ListEditSessionExternalRunsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: {
        parent_run_id?: string;
        run_kind?: string;
        status?: 'queued' | 'active' | 'succeeded' | 'failed' | 'cancelled';
        requester_id?: string;
        limit?: number;
        offset?: number;
        /**
         * JSON-encoded object used for JSONB containment; at most 256 KiB.
         */
        input_snapshot_contains?: string;
    };
    url: '/edit-sessions/{es_id}/external-runs';
};

export type ListEditSessionExternalRunsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListEditSessionExternalRunsError = ListEditSessionExternalRunsErrors[keyof ListEditSessionExternalRunsErrors];

export type ListEditSessionExternalRunsResponses = {
    /**
     * Edit-session external runs
     */
    200: Array<ExternalRun>;
};

export type ListEditSessionExternalRunsResponse = ListEditSessionExternalRunsResponses[keyof ListEditSessionExternalRunsResponses];

export type CreateEditSessionExternalRunData = {
    body: ExternalRunCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/external-runs';
};

export type CreateEditSessionExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateEditSessionExternalRunError = CreateEditSessionExternalRunErrors[keyof CreateEditSessionExternalRunErrors];

export type CreateEditSessionExternalRunResponses = {
    /**
     * External run created
     */
    201: ExternalRun;
};

export type CreateEditSessionExternalRunResponse = CreateEditSessionExternalRunResponses[keyof CreateEditSessionExternalRunResponses];

export type DeleteEditSessionExternalRunData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/external-runs/{run_id}';
};

export type DeleteEditSessionExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteEditSessionExternalRunError = DeleteEditSessionExternalRunErrors[keyof DeleteEditSessionExternalRunErrors];

export type DeleteEditSessionExternalRunResponses = {
    /**
     * External run deleted
     */
    204: void;
};

export type DeleteEditSessionExternalRunResponse = DeleteEditSessionExternalRunResponses[keyof DeleteEditSessionExternalRunResponses];

export type GetEditSessionExternalRunData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/external-runs/{run_id}';
};

export type GetEditSessionExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionExternalRunError = GetEditSessionExternalRunErrors[keyof GetEditSessionExternalRunErrors];

export type GetEditSessionExternalRunResponses = {
    /**
     * External run
     */
    200: ExternalRun;
};

export type GetEditSessionExternalRunResponse = GetEditSessionExternalRunResponses[keyof GetEditSessionExternalRunResponses];

export type UpdateEditSessionExternalRunSettingsData = {
    body: ExternalRunSettingsUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/external-runs/{run_id}/settings';
};

export type UpdateEditSessionExternalRunSettingsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateEditSessionExternalRunSettingsError = UpdateEditSessionExternalRunSettingsErrors[keyof UpdateEditSessionExternalRunSettingsErrors];

export type UpdateEditSessionExternalRunSettingsResponses = {
    /**
     * Updated external run settings
     */
    200: ExternalRunSettings;
};

export type UpdateEditSessionExternalRunSettingsResponse = UpdateEditSessionExternalRunSettingsResponses[keyof UpdateEditSessionExternalRunSettingsResponses];

export type CreateEditSessionExternalRunWorkspaceTransactionData = {
    body: ExternalRunWorkspaceTransactionCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/external-runs/{run_id}/workspace-transactions';
};

export type CreateEditSessionExternalRunWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateEditSessionExternalRunWorkspaceTransactionError = CreateEditSessionExternalRunWorkspaceTransactionErrors[keyof CreateEditSessionExternalRunWorkspaceTransactionErrors];

export type CreateEditSessionExternalRunWorkspaceTransactionResponses = {
    /**
     * Workspace transaction associated with the run
     */
    201: ExternalRunWorkspaceTransaction;
};

export type CreateEditSessionExternalRunWorkspaceTransactionResponse = CreateEditSessionExternalRunWorkspaceTransactionResponses[keyof CreateEditSessionExternalRunWorkspaceTransactionResponses];

export type StartEditSessionExternalRunData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/external-runs/{run_id}/start';
};

export type StartEditSessionExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type StartEditSessionExternalRunError = StartEditSessionExternalRunErrors[keyof StartEditSessionExternalRunErrors];

export type StartEditSessionExternalRunResponses = {
    /**
     * External run started
     */
    200: ExternalRun;
};

export type StartEditSessionExternalRunResponse = StartEditSessionExternalRunResponses[keyof StartEditSessionExternalRunResponses];

export type CompleteEditSessionExternalRunData = {
    body: ExternalRunCompletion;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/external-runs/{run_id}/complete';
};

export type CompleteEditSessionExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CompleteEditSessionExternalRunError = CompleteEditSessionExternalRunErrors[keyof CompleteEditSessionExternalRunErrors];

export type CompleteEditSessionExternalRunResponses = {
    /**
     * External run completed
     */
    200: ExternalRun;
};

export type CompleteEditSessionExternalRunResponse = CompleteEditSessionExternalRunResponses[keyof CompleteEditSessionExternalRunResponses];

export type CancelEditSessionExternalRunData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/external-runs/{run_id}/cancel';
};

export type CancelEditSessionExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CancelEditSessionExternalRunError = CancelEditSessionExternalRunErrors[keyof CancelEditSessionExternalRunErrors];

export type CancelEditSessionExternalRunResponses = {
    /**
     * External run cancelled
     */
    200: ExternalRun;
};

export type CancelEditSessionExternalRunResponse = CancelEditSessionExternalRunResponses[keyof CancelEditSessionExternalRunResponses];

export type AppendEditSessionExternalRunRecordData = {
    body?: Blob | File;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        run_id: string;
        record_kind: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/external-runs/{run_id}/records/{record_kind}';
};

export type AppendEditSessionExternalRunRecordErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type AppendEditSessionExternalRunRecordError = AppendEditSessionExternalRunRecordErrors[keyof AppendEditSessionExternalRunRecordErrors];

export type AppendEditSessionExternalRunRecordResponses = {
    /**
     * External run record appended
     */
    201: ExternalRunRecord;
};

export type AppendEditSessionExternalRunRecordResponse = AppendEditSessionExternalRunRecordResponses[keyof AppendEditSessionExternalRunRecordResponses];

export type ListEditSessionExternalRunRecordsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/external-runs/{run_id}/records';
};

export type ListEditSessionExternalRunRecordsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListEditSessionExternalRunRecordsError = ListEditSessionExternalRunRecordsErrors[keyof ListEditSessionExternalRunRecordsErrors];

export type ListEditSessionExternalRunRecordsResponses = {
    /**
     * External run records in creation order
     */
    200: Array<ExternalRunRecord>;
};

export type ListEditSessionExternalRunRecordsResponse = ListEditSessionExternalRunRecordsResponses[keyof ListEditSessionExternalRunRecordsResponses];

export type GetEditSessionExternalRunRecordContentData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        run_id: string;
        record_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/external-runs/{run_id}/records/{record_id}/content';
};

export type GetEditSessionExternalRunRecordContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetEditSessionExternalRunRecordContentError = GetEditSessionExternalRunRecordContentErrors[keyof GetEditSessionExternalRunRecordContentErrors];

export type GetEditSessionExternalRunRecordContentResponses = {
    /**
     * Exact external run record payload
     */
    200: Blob | File;
};

export type GetEditSessionExternalRunRecordContentResponse = GetEditSessionExternalRunRecordContentResponses[keyof GetEditSessionExternalRunRecordContentResponses];

export type ListThreadExternalRunsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: {
        parent_run_id?: string;
        run_kind?: string;
        status?: 'queued' | 'active' | 'succeeded' | 'failed' | 'cancelled';
        requester_id?: string;
        limit?: number;
        offset?: number;
        /**
         * JSON-encoded object used for JSONB containment; at most 256 KiB.
         */
        input_snapshot_contains?: string;
    };
    url: '/edit-session-threads/{thread_id}/external-runs';
};

export type ListThreadExternalRunsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListThreadExternalRunsError = ListThreadExternalRunsErrors[keyof ListThreadExternalRunsErrors];

export type ListThreadExternalRunsResponses = {
    /**
     * Thread external runs
     */
    200: Array<ExternalRun>;
};

export type ListThreadExternalRunsResponse = ListThreadExternalRunsResponses[keyof ListThreadExternalRunsResponses];

export type CreateThreadExternalRunData = {
    body: ExternalRunCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/external-runs';
};

export type CreateThreadExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateThreadExternalRunError = CreateThreadExternalRunErrors[keyof CreateThreadExternalRunErrors];

export type CreateThreadExternalRunResponses = {
    /**
     * External run created
     */
    201: ExternalRun;
};

export type CreateThreadExternalRunResponse = CreateThreadExternalRunResponses[keyof CreateThreadExternalRunResponses];

export type DeleteThreadExternalRunData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/external-runs/{run_id}';
};

export type DeleteThreadExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteThreadExternalRunError = DeleteThreadExternalRunErrors[keyof DeleteThreadExternalRunErrors];

export type DeleteThreadExternalRunResponses = {
    /**
     * External run deleted
     */
    204: void;
};

export type DeleteThreadExternalRunResponse = DeleteThreadExternalRunResponses[keyof DeleteThreadExternalRunResponses];

export type GetThreadExternalRunData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/external-runs/{run_id}';
};

export type GetThreadExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadExternalRunError = GetThreadExternalRunErrors[keyof GetThreadExternalRunErrors];

export type GetThreadExternalRunResponses = {
    /**
     * External run
     */
    200: ExternalRun;
};

export type GetThreadExternalRunResponse = GetThreadExternalRunResponses[keyof GetThreadExternalRunResponses];

export type UpdateThreadExternalRunSettingsData = {
    body: ExternalRunSettingsUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/external-runs/{run_id}/settings';
};

export type UpdateThreadExternalRunSettingsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateThreadExternalRunSettingsError = UpdateThreadExternalRunSettingsErrors[keyof UpdateThreadExternalRunSettingsErrors];

export type UpdateThreadExternalRunSettingsResponses = {
    /**
     * Updated external run settings
     */
    200: ExternalRunSettings;
};

export type UpdateThreadExternalRunSettingsResponse = UpdateThreadExternalRunSettingsResponses[keyof UpdateThreadExternalRunSettingsResponses];

export type CreateThreadExternalRunWorkspaceTransactionData = {
    body: ExternalRunWorkspaceTransactionCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/external-runs/{run_id}/workspace-transactions';
};

export type CreateThreadExternalRunWorkspaceTransactionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateThreadExternalRunWorkspaceTransactionError = CreateThreadExternalRunWorkspaceTransactionErrors[keyof CreateThreadExternalRunWorkspaceTransactionErrors];

export type CreateThreadExternalRunWorkspaceTransactionResponses = {
    /**
     * Workspace transaction associated with the run
     */
    201: ExternalRunWorkspaceTransaction;
};

export type CreateThreadExternalRunWorkspaceTransactionResponse = CreateThreadExternalRunWorkspaceTransactionResponses[keyof CreateThreadExternalRunWorkspaceTransactionResponses];

export type StartThreadExternalRunData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/external-runs/{run_id}/start';
};

export type StartThreadExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type StartThreadExternalRunError = StartThreadExternalRunErrors[keyof StartThreadExternalRunErrors];

export type StartThreadExternalRunResponses = {
    /**
     * External run started
     */
    200: ExternalRun;
};

export type StartThreadExternalRunResponse = StartThreadExternalRunResponses[keyof StartThreadExternalRunResponses];

export type CompleteThreadExternalRunData = {
    body: ExternalRunCompletion;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/external-runs/{run_id}/complete';
};

export type CompleteThreadExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CompleteThreadExternalRunError = CompleteThreadExternalRunErrors[keyof CompleteThreadExternalRunErrors];

export type CompleteThreadExternalRunResponses = {
    /**
     * External run completed
     */
    200: ExternalRun;
};

export type CompleteThreadExternalRunResponse = CompleteThreadExternalRunResponses[keyof CompleteThreadExternalRunResponses];

export type CancelThreadExternalRunData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/external-runs/{run_id}/cancel';
};

export type CancelThreadExternalRunErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CancelThreadExternalRunError = CancelThreadExternalRunErrors[keyof CancelThreadExternalRunErrors];

export type CancelThreadExternalRunResponses = {
    /**
     * External run cancelled
     */
    200: ExternalRun;
};

export type CancelThreadExternalRunResponse = CancelThreadExternalRunResponses[keyof CancelThreadExternalRunResponses];

export type AppendThreadExternalRunRecordData = {
    body?: Blob | File;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        run_id: string;
        record_kind: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/external-runs/{run_id}/records/{record_kind}';
};

export type AppendThreadExternalRunRecordErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type AppendThreadExternalRunRecordError = AppendThreadExternalRunRecordErrors[keyof AppendThreadExternalRunRecordErrors];

export type AppendThreadExternalRunRecordResponses = {
    /**
     * External run record appended
     */
    201: ExternalRunRecord;
};

export type AppendThreadExternalRunRecordResponse = AppendThreadExternalRunRecordResponses[keyof AppendThreadExternalRunRecordResponses];

export type ListThreadExternalRunRecordsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        run_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/external-runs/{run_id}/records';
};

export type ListThreadExternalRunRecordsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListThreadExternalRunRecordsError = ListThreadExternalRunRecordsErrors[keyof ListThreadExternalRunRecordsErrors];

export type ListThreadExternalRunRecordsResponses = {
    /**
     * External run records in creation order
     */
    200: Array<ExternalRunRecord>;
};

export type ListThreadExternalRunRecordsResponse = ListThreadExternalRunRecordsResponses[keyof ListThreadExternalRunRecordsResponses];

export type GetThreadExternalRunRecordContentData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        run_id: string;
        record_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/external-runs/{run_id}/records/{record_id}/content';
};

export type GetThreadExternalRunRecordContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetThreadExternalRunRecordContentError = GetThreadExternalRunRecordContentErrors[keyof GetThreadExternalRunRecordContentErrors];

export type GetThreadExternalRunRecordContentResponses = {
    /**
     * Exact external run record payload
     */
    200: Blob | File;
};

export type GetThreadExternalRunRecordContentResponse = GetThreadExternalRunRecordContentResponses[keyof GetThreadExternalRunRecordContentResponses];

export type DeleteInvitationData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        invitation_id: string;
    };
    query?: never;
    url: '/invitations/{invitation_id}';
};

export type DeleteInvitationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteInvitationError = DeleteInvitationErrors[keyof DeleteInvitationErrors];

export type DeleteInvitationResponses = {
    /**
     * Invitation deleted
     */
    204: void;
};

export type DeleteInvitationResponse = DeleteInvitationResponses[keyof DeleteInvitationResponses];

export type GetInvitationByTokenData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        token: string;
    };
    query?: never;
    url: '/invitations/token/{token}';
};

export type GetInvitationByTokenErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetInvitationByTokenError = GetInvitationByTokenErrors[keyof GetInvitationByTokenErrors];

export type GetInvitationByTokenResponses = {
    /**
     * Invitation retrieved
     */
    200: Invitation;
};

export type GetInvitationByTokenResponse = GetInvitationByTokenResponses[keyof GetInvitationByTokenResponses];

export type GetInvitationResourceByTokenData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        token: string;
    };
    query?: never;
    url: '/invitations/token/{token}/resource';
};

export type GetInvitationResourceByTokenErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetInvitationResourceByTokenError = GetInvitationResourceByTokenErrors[keyof GetInvitationResourceByTokenErrors];

export type GetInvitationResourceByTokenResponses = {
    /**
     * Invitation resource retrieved
     */
    200: InvitationResource;
};

export type GetInvitationResourceByTokenResponse = GetInvitationResourceByTokenResponses[keyof GetInvitationResourceByTokenResponses];

export type AcceptInvitationData = {
    body: InvitationAccept;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/invitations/actions/accept';
};

export type AcceptInvitationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type AcceptInvitationError = AcceptInvitationErrors[keyof AcceptInvitationErrors];

export type AcceptInvitationResponses = {
    /**
     * Invitation accepted
     */
    200: Membership;
};

export type AcceptInvitationResponse = AcceptInvitationResponses[keyof AcceptInvitationResponses];

export type DeclineInvitationData = {
    body: InvitationAccept;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/invitations/actions/decline';
};

export type DeclineInvitationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeclineInvitationError = DeclineInvitationErrors[keyof DeclineInvitationErrors];

export type DeclineInvitationResponses = {
    /**
     * Invitation declined
     */
    204: void;
};

export type DeclineInvitationResponse = DeclineInvitationResponses[keyof DeclineInvitationResponses];

export type GetProjectInviteLinkPreviewData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        token: string;
    };
    query?: never;
    url: '/project-invite-links/token/{token}/preview';
};

export type GetProjectInviteLinkPreviewErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetProjectInviteLinkPreviewError = GetProjectInviteLinkPreviewErrors[keyof GetProjectInviteLinkPreviewErrors];

export type GetProjectInviteLinkPreviewResponses = {
    /**
     * Project invite link preview
     */
    200: ProjectInviteLinkPreview;
};

export type GetProjectInviteLinkPreviewResponse = GetProjectInviteLinkPreviewResponses[keyof GetProjectInviteLinkPreviewResponses];

export type AcceptProjectInviteLinkData = {
    body: InvitationAccept;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/project-invite-links/actions/accept';
};

export type AcceptProjectInviteLinkErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type AcceptProjectInviteLinkError = AcceptProjectInviteLinkErrors[keyof AcceptProjectInviteLinkErrors];

export type AcceptProjectInviteLinkResponses = {
    /**
     * Project invite link accepted
     */
    200: Membership;
};

export type AcceptProjectInviteLinkResponse = AcceptProjectInviteLinkResponses[keyof AcceptProjectInviteLinkResponses];

export type ListUserInvitationsRedirectData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/invitations';
};

export type ListUserInvitationsRedirectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListUserInvitationsRedirectError = ListUserInvitationsRedirectErrors[keyof ListUserInvitationsRedirectErrors];

export type ListUserInvitationsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Unique user ID
         */
        user_id: string;
    };
    query?: {
        /**
         * Filter by resource type
         */
        resource_type?: MembershipResourceType;
        /**
         * Filter by resource ID
         */
        resource_id?: string;
    };
    url: '/users/{user_id}/invitations';
};

export type ListUserInvitationsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListUserInvitationsError = ListUserInvitationsErrors[keyof ListUserInvitationsErrors];

export type ListUserInvitationsResponses = {
    /**
     * List of user's invitations
     */
    200: Array<Invitation>;
};

export type ListUserInvitationsResponse = ListUserInvitationsResponses[keyof ListUserInvitationsResponses];

export type ListProjectInvitationsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/invitations';
};

export type ListProjectInvitationsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProjectInvitationsError = ListProjectInvitationsErrors[keyof ListProjectInvitationsErrors];

export type ListProjectInvitationsResponses = {
    /**
     * List of pending invitations
     */
    200: Array<Invitation>;
};

export type ListProjectInvitationsResponse = ListProjectInvitationsResponses[keyof ListProjectInvitationsResponses];

export type SendProjectInvitationData = {
    body: InvitationCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/invitations';
};

export type SendProjectInvitationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type SendProjectInvitationError = SendProjectInvitationErrors[keyof SendProjectInvitationErrors];

export type SendProjectInvitationResponses = {
    /**
     * Invitation sent
     */
    201: Invitation;
};

export type SendProjectInvitationResponse = SendProjectInvitationResponses[keyof SendProjectInvitationResponses];

export type ListProjectInviteLinksData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/invite-links';
};

export type ListProjectInviteLinksErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProjectInviteLinksError = ListProjectInviteLinksErrors[keyof ListProjectInviteLinksErrors];

export type ListProjectInviteLinksResponses = {
    /**
     * List of project invite links
     */
    200: Array<ProjectInviteLink>;
};

export type ListProjectInviteLinksResponse = ListProjectInviteLinksResponses[keyof ListProjectInviteLinksResponses];

export type CreateProjectInviteLinkData = {
    body: ProjectInviteLinkCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/invite-links';
};

export type CreateProjectInviteLinkErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateProjectInviteLinkError = CreateProjectInviteLinkErrors[keyof CreateProjectInviteLinkErrors];

export type CreateProjectInviteLinkResponses = {
    /**
     * Project invite link created
     */
    201: ProjectInviteLink;
};

export type CreateProjectInviteLinkResponse = CreateProjectInviteLinkResponses[keyof CreateProjectInviteLinkResponses];

export type RevokeProjectInviteLinkData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
        invitation_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/invite-links/{invitation_id}';
};

export type RevokeProjectInviteLinkErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RevokeProjectInviteLinkError = RevokeProjectInviteLinkErrors[keyof RevokeProjectInviteLinkErrors];

export type RevokeProjectInviteLinkResponses = {
    /**
     * Project invite link revoked
     */
    204: void;
};

export type RevokeProjectInviteLinkResponse = RevokeProjectInviteLinkResponses[keyof RevokeProjectInviteLinkResponses];

export type ListOrganizationInvitationsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/invitations';
};

export type ListOrganizationInvitationsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListOrganizationInvitationsError = ListOrganizationInvitationsErrors[keyof ListOrganizationInvitationsErrors];

export type ListOrganizationInvitationsResponses = {
    /**
     * List of pending invitations
     */
    200: Array<Invitation>;
};

export type ListOrganizationInvitationsResponse = ListOrganizationInvitationsResponses[keyof ListOrganizationInvitationsResponses];

export type SendOrganizationInvitationData = {
    body: InvitationCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/invitations';
};

export type SendOrganizationInvitationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type SendOrganizationInvitationError = SendOrganizationInvitationErrors[keyof SendOrganizationInvitationErrors];

export type SendOrganizationInvitationResponses = {
    /**
     * Invitation sent
     */
    201: Invitation;
};

export type SendOrganizationInvitationResponse = SendOrganizationInvitationResponses[keyof SendOrganizationInvitationResponses];

export type SeedLocalDevEnterpriseData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/local-dev/enterprise/actions/seed';
};

export type SeedLocalDevEnterpriseErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type SeedLocalDevEnterpriseError = SeedLocalDevEnterpriseErrors[keyof SeedLocalDevEnterpriseErrors];

export type SeedLocalDevEnterpriseResponses = {
    /**
     * Enterprise seed process executed successfully
     */
    200: {
        /**
         * Whether any changes were detected and applied
         */
        changed: boolean;
        /**
         * Whether AI personas were created or updated
         */
        ai_personas_changed: boolean;
        /**
         * Whether shared assets were imported or updated
         */
        assets_changed: boolean;
        /**
         * Whether static files served under /assets/ were published or updated
         */
        public_assets_changed: boolean;
        /**
         * Whether trusted enterprise plugin packages were installed or updated
         */
        plugins_changed: boolean;
        /**
         * Package-level trusted plugin synchronization failures; other packages and seed sources may still succeed
         */
        plugin_errors: Array<string>;
        /**
         * The configured source used to seed enterprise project content
         */
        seed_source: {
            /**
             * Whether seeding reads the configured path directly or synchronizes a Git checkout first
             */
            type: string;
            /**
             * Absolute configured seed path on the server
             */
            path: string;
        };
    };
};

export type SeedLocalDevEnterpriseResponse = SeedLocalDevEnterpriseResponses[keyof SeedLocalDevEnterpriseResponses];

export type ListProjectMarketingData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/marketing';
};

export type ListProjectMarketingErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProjectMarketingError = ListProjectMarketingErrors[keyof ListProjectMarketingErrors];

export type ListProjectMarketingResponses = {
    /**
     * Saved versions, newest first
     */
    200: Array<MarketingRecord>;
};

export type ListProjectMarketingResponse = ListProjectMarketingResponses[keyof ListProjectMarketingResponses];

export type CreateProjectMarketingData = {
    body: MarketingDirection;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/marketing';
};

export type CreateProjectMarketingErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateProjectMarketingError = CreateProjectMarketingErrors[keyof CreateProjectMarketingErrors];

export type CreateProjectMarketingResponses = {
    /**
     * New immutable marketing version
     */
    201: MarketingRecord;
};

export type CreateProjectMarketingResponse = CreateProjectMarketingResponses[keyof CreateProjectMarketingResponses];

export type DeleteProjectMarketingData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
        marketing_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/marketing/{marketing_id}';
};

export type DeleteProjectMarketingErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteProjectMarketingError = DeleteProjectMarketingErrors[keyof DeleteProjectMarketingErrors];

export type DeleteProjectMarketingResponses = {
    /**
     * Version hidden; artifact retained for recovery
     */
    204: void;
};

export type DeleteProjectMarketingResponse = DeleteProjectMarketingResponses[keyof DeleteProjectMarketingResponses];

export type RenameProjectMarketingData = {
    body: {
        name: string;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        project_id: string;
        marketing_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/marketing/{marketing_id}';
};

export type RenameProjectMarketingErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RenameProjectMarketingError = RenameProjectMarketingErrors[keyof RenameProjectMarketingErrors];

export type RenameProjectMarketingResponses = {
    /**
     * Renamed version; artwork and generation inputs unchanged
     */
    200: MarketingRecord;
};

export type RenameProjectMarketingResponse = RenameProjectMarketingResponses[keyof RenameProjectMarketingResponses];

export type ListUserMembershipsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Unique user ID
         */
        user_id: string;
    };
    query?: {
        /**
         * Filter by resource type
         */
        resource_type?: MembershipResourceType;
        /**
         * Filter by resource ID
         */
        resource_id?: string;
        /**
         * Sort option for endpoint-local user membership views. `view` orders by recent viewing presence.
         */
        order_by?: MembershipOrderBy;
        /**
         * Filter memberships by archived (`true`) / non-archived (`false`) resources (default: non-archived / `false`)
         */
        archived?: boolean;
    };
    url: '/users/{user_id}/memberships';
};

export type ListUserMembershipsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListUserMembershipsError = ListUserMembershipsErrors[keyof ListUserMembershipsErrors];

export type ListUserMembershipsResponses = {
    /**
     * List of user's memberships
     */
    200: Array<Membership>;
};

export type ListUserMembershipsResponse = ListUserMembershipsResponses[keyof ListUserMembershipsResponses];

export type ListOrganizationMembersData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/members';
};

export type ListOrganizationMembersErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListOrganizationMembersError = ListOrganizationMembersErrors[keyof ListOrganizationMembersErrors];

export type ListOrganizationMembersResponses = {
    /**
     * List of members
     */
    200: Array<Membership>;
};

export type ListOrganizationMembersResponse = ListOrganizationMembersResponses[keyof ListOrganizationMembersResponses];

export type RemoveOrganizationMemberData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        org_id: string;
        user_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/members/{user_id}';
};

export type RemoveOrganizationMemberErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RemoveOrganizationMemberError = RemoveOrganizationMemberErrors[keyof RemoveOrganizationMemberErrors];

export type RemoveOrganizationMemberResponses = {
    /**
     * Member removed
     */
    204: void;
};

export type RemoveOrganizationMemberResponse = RemoveOrganizationMemberResponses[keyof RemoveOrganizationMemberResponses];

export type UpdateOrganizationMemberData = {
    body: MembershipUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        org_id: string;
        user_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/members/{user_id}';
};

export type UpdateOrganizationMemberErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateOrganizationMemberError = UpdateOrganizationMemberErrors[keyof UpdateOrganizationMemberErrors];

export type UpdateOrganizationMemberResponses = {
    /**
     * Member updated
     */
    200: Membership;
};

export type UpdateOrganizationMemberResponse = UpdateOrganizationMemberResponses[keyof UpdateOrganizationMemberResponses];

export type ListProjectMembersData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/members';
};

export type ListProjectMembersErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProjectMembersError = ListProjectMembersErrors[keyof ListProjectMembersErrors];

export type ListProjectMembersResponses = {
    /**
     * List of members
     */
    200: Array<Membership>;
};

export type ListProjectMembersResponse = ListProjectMembersResponses[keyof ListProjectMembersResponses];

export type RemoveProjectMemberData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
        user_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/members/{user_id}';
};

export type RemoveProjectMemberErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RemoveProjectMemberError = RemoveProjectMemberErrors[keyof RemoveProjectMemberErrors];

export type RemoveProjectMemberResponses = {
    /**
     * Member removed
     */
    204: void;
};

export type RemoveProjectMemberResponse = RemoveProjectMemberResponses[keyof RemoveProjectMemberResponses];

export type UpdateProjectMemberData = {
    body: MembershipUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
        user_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/members/{user_id}';
};

export type UpdateProjectMemberErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateProjectMemberError = UpdateProjectMemberErrors[keyof UpdateProjectMemberErrors];

export type UpdateProjectMemberResponses = {
    /**
     * Member updated
     */
    200: Membership;
};

export type UpdateProjectMemberResponse = UpdateProjectMemberResponses[keyof UpdateProjectMemberResponses];

export type ListOrganizationsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/organizations';
};

export type ListOrganizationsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListOrganizationsError = ListOrganizationsErrors[keyof ListOrganizationsErrors];

export type ListOrganizationsResponses = {
    /**
     * List of all organizations in the system
     */
    200: Array<Organization>;
};

export type ListOrganizationsResponse = ListOrganizationsResponses[keyof ListOrganizationsResponses];

export type CreateOrganizationData = {
    body: OrganizationCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/organizations';
};

export type CreateOrganizationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateOrganizationError = CreateOrganizationErrors[keyof CreateOrganizationErrors];

export type CreateOrganizationResponses = {
    /**
     * Organization created
     */
    201: Organization;
};

export type CreateOrganizationResponse = CreateOrganizationResponses[keyof CreateOrganizationResponses];

export type GetOrganizationData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}';
};

export type GetOrganizationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetOrganizationError = GetOrganizationErrors[keyof GetOrganizationErrors];

export type GetOrganizationResponses = {
    /**
     * Organization details
     */
    200: Organization;
};

export type GetOrganizationResponse = GetOrganizationResponses[keyof GetOrganizationResponses];

export type UpdateOrganizationData = {
    body: OrganizationUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}';
};

export type UpdateOrganizationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateOrganizationError = UpdateOrganizationErrors[keyof UpdateOrganizationErrors];

export type UpdateOrganizationResponses = {
    /**
     * Organization updated
     */
    200: Organization;
};

export type UpdateOrganizationResponse = UpdateOrganizationResponses[keyof UpdateOrganizationResponses];

export type ArchiveOrganizationData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/actions/archive';
};

export type ArchiveOrganizationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ArchiveOrganizationError = ArchiveOrganizationErrors[keyof ArchiveOrganizationErrors];

export type ArchiveOrganizationResponses = {
    /**
     * Organization archived
     */
    200: Organization;
};

export type ArchiveOrganizationResponse = ArchiveOrganizationResponses[keyof ArchiveOrganizationResponses];

export type TransferOwnershipData = {
    body: TransferOwnershipRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/actions/transfer-ownership';
};

export type TransferOwnershipErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type TransferOwnershipError = TransferOwnershipErrors[keyof TransferOwnershipErrors];

export type TransferOwnershipResponses = {
    /**
     * Ownership transferred
     */
    204: void;
};

export type TransferOwnershipResponse = TransferOwnershipResponses[keyof TransferOwnershipResponses];

export type RedirectToUserOrganizationsData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: {
        /**
         * Filter memberships by archived (`true`) / non-archived (`false`) resources (default: non-archived / `false`)
         */
        archived?: boolean;
    };
    url: '/user/organizations';
};

export type RedirectToUserOrganizationsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserOrganizationsError = RedirectToUserOrganizationsErrors[keyof RedirectToUserOrganizationsErrors];

export type RedirectToUserOrganizationMembershipsData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Unique user ID
         */
        user_id: string;
    };
    query?: {
        /**
         * Filter memberships by archived (`true`) / non-archived (`false`) resources (default: non-archived / `false`)
         */
        archived?: boolean;
    };
    url: '/users/{user_id}/organizations';
};

export type RedirectToUserOrganizationMembershipsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserOrganizationMembershipsError = RedirectToUserOrganizationMembershipsErrors[keyof RedirectToUserOrganizationMembershipsErrors];

export type ListProjectSkillsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the project.
         */
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/skills';
};

export type ListProjectSkillsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProjectSkillsError = ListProjectSkillsErrors[keyof ListProjectSkillsErrors];

export type ListProjectSkillsResponses = {
    /**
     * Skills retrieved successfully
     */
    200: Array<SkillInfo>;
};

export type ListProjectSkillsResponse = ListProjectSkillsResponses[keyof ListProjectSkillsResponses];

export type RunProjectSkillScriptData = {
    body: RunSkillScriptRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the project.
         */
        proj_id: string;
        /**
         * Exact skill name.
         */
        skill_name: string;
    };
    query?: never;
    url: '/projects/{proj_id}/skills/{skill_name}/actions/run-script';
};

export type RunProjectSkillScriptErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The billing gate refused a paid skill binary, run directly or through a script's
     * `skill_run_binary` call: `kind` is `BALANCE_EXHAUSTED` or `BILLING_NOT_PROVISIONED`.
     * `payer` names who would pay; with `BILLING_NOT_PROVISIONED`, `setup_available` says
     * whether self-serve setup can provision them.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Execution output exceeds the capture limit
     */
    413: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RunProjectSkillScriptError = RunProjectSkillScriptErrors[keyof RunProjectSkillScriptErrors];

export type RunProjectSkillScriptResponses = {
    /**
     * Skill script completed successfully
     */
    200: SkillRunResult;
};

export type RunProjectSkillScriptResponse = RunProjectSkillScriptResponses[keyof RunProjectSkillScriptResponses];

export type RunProjectSkillBinaryData = {
    body: RunSkillBinaryRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the project.
         */
        proj_id: string;
        /**
         * Exact skill name.
         */
        skill_name: string;
    };
    query?: never;
    url: '/projects/{proj_id}/skills/{skill_name}/actions/run-binary';
};

export type RunProjectSkillBinaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The billing gate refused a paid skill binary, run directly or through a script's
     * `skill_run_binary` call: `kind` is `BALANCE_EXHAUSTED` or `BILLING_NOT_PROVISIONED`.
     * `payer` names who would pay; with `BILLING_NOT_PROVISIONED`, `setup_available` says
     * whether self-serve setup can provision them.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Execution output exceeds the capture limit
     */
    413: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RunProjectSkillBinaryError = RunProjectSkillBinaryErrors[keyof RunProjectSkillBinaryErrors];

export type RunProjectSkillBinaryResponses = {
    /**
     * Skill binary completed successfully
     */
    200: SkillRunResult;
};

export type RunProjectSkillBinaryResponse = RunProjectSkillBinaryResponses[keyof RunProjectSkillBinaryResponses];

export type RunProjectPluginScriptData = {
    body: RunSkillScriptRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the project.
         */
        proj_id: string;
        /**
         * Current trusted plugin identifier.
         */
        plugin_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/plugins/{plugin_id}/actions/run-script';
};

export type RunProjectPluginScriptErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The billing gate refused a paid skill binary, run directly or through a script's
     * `skill_run_binary` call: `kind` is `BALANCE_EXHAUSTED` or `BILLING_NOT_PROVISIONED`.
     * `payer` names who would pay; with `BILLING_NOT_PROVISIONED`, `setup_available` says
     * whether self-serve setup can provision them.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Execution output exceeds the capture limit
     */
    413: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RunProjectPluginScriptError = RunProjectPluginScriptErrors[keyof RunProjectPluginScriptErrors];

export type RunProjectPluginScriptResponses = {
    /**
     * Plugin script completed successfully
     */
    200: SkillRunResult;
};

export type RunProjectPluginScriptResponse = RunProjectPluginScriptResponses[keyof RunProjectPluginScriptResponses];

export type RunProjectPluginBinaryData = {
    body: RunSkillBinaryRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the project.
         */
        proj_id: string;
        /**
         * Current trusted plugin identifier.
         */
        plugin_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/plugins/{plugin_id}/actions/run-binary';
};

export type RunProjectPluginBinaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The billing gate refused a paid skill binary, run directly or through a script's
     * `skill_run_binary` call: `kind` is `BALANCE_EXHAUSTED` or `BILLING_NOT_PROVISIONED`.
     * `payer` names who would pay; with `BILLING_NOT_PROVISIONED`, `setup_available` says
     * whether self-serve setup can provision them.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Execution output exceeds the capture limit
     */
    413: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RunProjectPluginBinaryError = RunProjectPluginBinaryErrors[keyof RunProjectPluginBinaryErrors];

export type RunProjectPluginBinaryResponses = {
    /**
     * Plugin binary completed successfully
     */
    200: SkillRunResult;
};

export type RunProjectPluginBinaryResponse = RunProjectPluginBinaryResponses[keyof RunProjectPluginBinaryResponses];

export type ListEditSessionSkillsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session.
         */
        es_id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/skills';
};

export type ListEditSessionSkillsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListEditSessionSkillsError = ListEditSessionSkillsErrors[keyof ListEditSessionSkillsErrors];

export type ListEditSessionSkillsResponses = {
    /**
     * Skills retrieved successfully
     */
    200: Array<SkillInfo>;
};

export type ListEditSessionSkillsResponse = ListEditSessionSkillsResponses[keyof ListEditSessionSkillsResponses];

export type RunEditSessionSkillScriptData = {
    body: RunSkillScriptRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session.
         */
        es_id: string;
        /**
         * Exact skill name.
         */
        skill_name: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/skills/{skill_name}/actions/run-script';
};

export type RunEditSessionSkillScriptErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The billing gate refused a paid skill binary, run directly or through a script's
     * `skill_run_binary` call: `kind` is `BALANCE_EXHAUSTED` or `BILLING_NOT_PROVISIONED`.
     * `payer` names who would pay; with `BILLING_NOT_PROVISIONED`, `setup_available` says
     * whether self-serve setup can provision them.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Execution output exceeds the capture limit
     */
    413: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RunEditSessionSkillScriptError = RunEditSessionSkillScriptErrors[keyof RunEditSessionSkillScriptErrors];

export type RunEditSessionSkillScriptResponses = {
    /**
     * Skill script completed successfully
     */
    200: SkillRunResult;
};

export type RunEditSessionSkillScriptResponse = RunEditSessionSkillScriptResponses[keyof RunEditSessionSkillScriptResponses];

export type RunEditSessionSkillBinaryData = {
    body: RunSkillBinaryRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session.
         */
        es_id: string;
        /**
         * Exact skill name.
         */
        skill_name: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/skills/{skill_name}/actions/run-binary';
};

export type RunEditSessionSkillBinaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The billing gate refused a paid skill binary, run directly or through a script's
     * `skill_run_binary` call: `kind` is `BALANCE_EXHAUSTED` or `BILLING_NOT_PROVISIONED`.
     * `payer` names who would pay; with `BILLING_NOT_PROVISIONED`, `setup_available` says
     * whether self-serve setup can provision them.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Execution output exceeds the capture limit
     */
    413: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RunEditSessionSkillBinaryError = RunEditSessionSkillBinaryErrors[keyof RunEditSessionSkillBinaryErrors];

export type RunEditSessionSkillBinaryResponses = {
    /**
     * Skill binary completed successfully
     */
    200: SkillRunResult;
};

export type RunEditSessionSkillBinaryResponse = RunEditSessionSkillBinaryResponses[keyof RunEditSessionSkillBinaryResponses];

export type RunEditSessionPluginScriptData = {
    body: RunSkillScriptRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session.
         */
        es_id: string;
        /**
         * Current trusted plugin identifier.
         */
        plugin_id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/plugins/{plugin_id}/actions/run-script';
};

export type RunEditSessionPluginScriptErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The billing gate refused a paid skill binary, run directly or through a script's
     * `skill_run_binary` call: `kind` is `BALANCE_EXHAUSTED` or `BILLING_NOT_PROVISIONED`.
     * `payer` names who would pay; with `BILLING_NOT_PROVISIONED`, `setup_available` says
     * whether self-serve setup can provision them.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Execution output exceeds the capture limit
     */
    413: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RunEditSessionPluginScriptError = RunEditSessionPluginScriptErrors[keyof RunEditSessionPluginScriptErrors];

export type RunEditSessionPluginScriptResponses = {
    /**
     * Plugin script completed successfully
     */
    200: SkillRunResult;
};

export type RunEditSessionPluginScriptResponse = RunEditSessionPluginScriptResponses[keyof RunEditSessionPluginScriptResponses];

export type RunEditSessionPluginBinaryData = {
    body: RunSkillBinaryRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session.
         */
        es_id: string;
        /**
         * Current trusted plugin identifier.
         */
        plugin_id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/plugins/{plugin_id}/actions/run-binary';
};

export type RunEditSessionPluginBinaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The billing gate refused a paid skill binary, run directly or through a script's
     * `skill_run_binary` call: `kind` is `BALANCE_EXHAUSTED` or `BILLING_NOT_PROVISIONED`.
     * `payer` names who would pay; with `BILLING_NOT_PROVISIONED`, `setup_available` says
     * whether self-serve setup can provision them.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Execution output exceeds the capture limit
     */
    413: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RunEditSessionPluginBinaryError = RunEditSessionPluginBinaryErrors[keyof RunEditSessionPluginBinaryErrors];

export type RunEditSessionPluginBinaryResponses = {
    /**
     * Plugin binary completed successfully
     */
    200: SkillRunResult;
};

export type RunEditSessionPluginBinaryResponse = RunEditSessionPluginBinaryResponses[keyof RunEditSessionPluginBinaryResponses];

export type ListEditSessionThreadSkillsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session thread.
         */
        thread_id: string;
    };
    query?: never;
    url: '/edit-session-threads/{thread_id}/skills';
};

export type ListEditSessionThreadSkillsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListEditSessionThreadSkillsError = ListEditSessionThreadSkillsErrors[keyof ListEditSessionThreadSkillsErrors];

export type ListEditSessionThreadSkillsResponses = {
    /**
     * Skills retrieved successfully
     */
    200: Array<SkillInfo>;
};

export type ListEditSessionThreadSkillsResponse = ListEditSessionThreadSkillsResponses[keyof ListEditSessionThreadSkillsResponses];

export type RunEditSessionThreadSkillScriptData = {
    body: RunSkillScriptRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session thread.
         */
        thread_id: string;
        /**
         * Exact skill name.
         */
        skill_name: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-session-threads/{thread_id}/skills/{skill_name}/actions/run-script';
};

export type RunEditSessionThreadSkillScriptErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The billing gate refused a paid skill binary, run directly or through a script's
     * `skill_run_binary` call: `kind` is `BALANCE_EXHAUSTED` or `BILLING_NOT_PROVISIONED`.
     * `payer` names who would pay; with `BILLING_NOT_PROVISIONED`, `setup_available` says
     * whether self-serve setup can provision them.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Execution output exceeds the capture limit
     */
    413: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RunEditSessionThreadSkillScriptError = RunEditSessionThreadSkillScriptErrors[keyof RunEditSessionThreadSkillScriptErrors];

export type RunEditSessionThreadSkillScriptResponses = {
    /**
     * Skill script completed successfully
     */
    200: SkillRunResult;
};

export type RunEditSessionThreadSkillScriptResponse = RunEditSessionThreadSkillScriptResponses[keyof RunEditSessionThreadSkillScriptResponses];

export type RunEditSessionThreadSkillBinaryData = {
    body: RunSkillBinaryRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session thread.
         */
        thread_id: string;
        /**
         * Exact skill name.
         */
        skill_name: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-session-threads/{thread_id}/skills/{skill_name}/actions/run-binary';
};

export type RunEditSessionThreadSkillBinaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The billing gate refused a paid skill binary, run directly or through a script's
     * `skill_run_binary` call: `kind` is `BALANCE_EXHAUSTED` or `BILLING_NOT_PROVISIONED`.
     * `payer` names who would pay; with `BILLING_NOT_PROVISIONED`, `setup_available` says
     * whether self-serve setup can provision them.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Execution output exceeds the capture limit
     */
    413: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RunEditSessionThreadSkillBinaryError = RunEditSessionThreadSkillBinaryErrors[keyof RunEditSessionThreadSkillBinaryErrors];

export type RunEditSessionThreadSkillBinaryResponses = {
    /**
     * Skill binary completed successfully
     */
    200: SkillRunResult;
};

export type RunEditSessionThreadSkillBinaryResponse = RunEditSessionThreadSkillBinaryResponses[keyof RunEditSessionThreadSkillBinaryResponses];

export type RunEditSessionThreadPluginScriptData = {
    body: RunSkillScriptRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session thread.
         */
        thread_id: string;
        /**
         * Current trusted plugin identifier.
         */
        plugin_id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-session-threads/{thread_id}/plugins/{plugin_id}/actions/run-script';
};

export type RunEditSessionThreadPluginScriptErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The billing gate refused a paid skill binary, run directly or through a script's
     * `skill_run_binary` call: `kind` is `BALANCE_EXHAUSTED` or `BILLING_NOT_PROVISIONED`.
     * `payer` names who would pay; with `BILLING_NOT_PROVISIONED`, `setup_available` says
     * whether self-serve setup can provision them.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Execution output exceeds the capture limit
     */
    413: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RunEditSessionThreadPluginScriptError = RunEditSessionThreadPluginScriptErrors[keyof RunEditSessionThreadPluginScriptErrors];

export type RunEditSessionThreadPluginScriptResponses = {
    /**
     * Plugin script completed successfully
     */
    200: SkillRunResult;
};

export type RunEditSessionThreadPluginScriptResponse = RunEditSessionThreadPluginScriptResponses[keyof RunEditSessionThreadPluginScriptResponses];

export type RunEditSessionThreadPluginBinaryData = {
    body: RunSkillBinaryRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the edit session thread.
         */
        thread_id: string;
        /**
         * Current trusted plugin identifier.
         */
        plugin_id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-session-threads/{thread_id}/plugins/{plugin_id}/actions/run-binary';
};

export type RunEditSessionThreadPluginBinaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The billing gate refused a paid skill binary, run directly or through a script's
     * `skill_run_binary` call: `kind` is `BALANCE_EXHAUSTED` or `BILLING_NOT_PROVISIONED`.
     * `payer` names who would pay; with `BILLING_NOT_PROVISIONED`, `setup_available` says
     * whether self-serve setup can provision them.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Execution output exceeds the capture limit
     */
    413: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RunEditSessionThreadPluginBinaryError = RunEditSessionThreadPluginBinaryErrors[keyof RunEditSessionThreadPluginBinaryErrors];

export type RunEditSessionThreadPluginBinaryResponses = {
    /**
     * Plugin binary completed successfully
     */
    200: SkillRunResult;
};

export type RunEditSessionThreadPluginBinaryResponse = RunEditSessionThreadPluginBinaryResponses[keyof RunEditSessionThreadPluginBinaryResponses];

export type RedirectToUserPresenceRecordData = {
    body: PresenceCreate;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/presence';
};

export type RedirectToUserPresenceRecordErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserPresenceRecordError = RedirectToUserPresenceRecordErrors[keyof RedirectToUserPresenceRecordErrors];

export type RecordUserPresenceData = {
    body: PresenceCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * User ID whose presence is being recorded
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/presence';
};

export type RecordUserPresenceErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RecordUserPresenceError = RecordUserPresenceErrors[keyof RecordUserPresenceErrors];

export type RecordUserPresenceResponses = {
    /**
     * Presence recorded
     */
    204: void;
};

export type RecordUserPresenceResponse = RecordUserPresenceResponses[keyof RecordUserPresenceResponses];

export type RedirectToUserProjectsData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: {
        /**
         * Filter memberships by archived (`true`) / non-archived (`false`) resources (default: non-archived / `false`)
         */
        archived?: boolean;
    };
    url: '/user/projects';
};

export type RedirectToUserProjectsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserProjectsError = RedirectToUserProjectsErrors[keyof RedirectToUserProjectsErrors];

export type RedirectToUserProjectMembershipsData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * The ID of the user whose projects to list
         */
        user_id: string;
    };
    query?: {
        /**
         * Filter memberships by archived (`true`) / non-archived (`false`) resources (default: non-archived / `false`)
         */
        archived?: boolean;
    };
    url: '/users/{user_id}/projects';
};

export type RedirectToUserProjectMembershipsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserProjectMembershipsError = RedirectToUserProjectMembershipsErrors[keyof RedirectToUserProjectMembershipsErrors];

export type GetProjectData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}';
};

export type GetProjectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetProjectError = GetProjectErrors[keyof GetProjectErrors];

export type GetProjectResponses = {
    /**
     * Project details
     */
    200: Project;
};

export type GetProjectResponse = GetProjectResponses[keyof GetProjectResponses];

export type UpdateProjectData = {
    body: ProjectUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}';
};

export type UpdateProjectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateProjectError = UpdateProjectErrors[keyof UpdateProjectErrors];

export type UpdateProjectResponses = {
    /**
     * Project updated
     */
    200: Project;
};

export type UpdateProjectResponse = UpdateProjectResponses[keyof UpdateProjectResponses];

export type UploadProjectThumbnailData = {
    /**
     * Upload the thumbnail image providing the 'file' field.
     */
    body: {
        [key: string]: unknown;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/thumbnail';
};

export type UploadProjectThumbnailErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UploadProjectThumbnailError = UploadProjectThumbnailErrors[keyof UploadProjectThumbnailErrors];

export type UploadProjectThumbnailResponses = {
    /**
     * Thumbnail uploaded and project updated
     */
    200: Project;
};

export type UploadProjectThumbnailResponse = UploadProjectThumbnailResponses[keyof UploadProjectThumbnailResponses];

export type ArchiveProjectData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/actions/archive';
};

export type ArchiveProjectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ArchiveProjectError = ArchiveProjectErrors[keyof ArchiveProjectErrors];

export type ArchiveProjectResponses = {
    /**
     * Project archived
     */
    200: Project;
};

export type ArchiveProjectResponse = ArchiveProjectResponses[keyof ArchiveProjectResponses];

export type DuplicateProjectData = {
    body: ProjectDuplicate;
    headers: {
        /**
         * Reusing the key with the same request returns the original operation.
         */
        'Idempotency-Key': string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/actions/duplicate';
};

export type DuplicateProjectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DuplicateProjectError = DuplicateProjectErrors[keyof DuplicateProjectErrors];

export type DuplicateProjectResponses = {
    /**
     * Project copy accepted for asynchronous processing
     */
    202: ProjectCopyOperation;
};

export type DuplicateProjectResponse = DuplicateProjectResponses[keyof DuplicateProjectResponses];

export type GetProjectCopyOperationData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        operation_id: string;
    };
    query?: never;
    url: '/project-copy-operations/{operation_id}';
};

export type GetProjectCopyOperationErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetProjectCopyOperationError = GetProjectCopyOperationErrors[keyof GetProjectCopyOperationErrors];

export type GetProjectCopyOperationResponses = {
    /**
     * Current project copy operation state
     */
    200: ProjectCopyOperation;
};

export type GetProjectCopyOperationResponse = GetProjectCopyOperationResponses[keyof GetProjectCopyOperationResponses];

export type ListOrganizationProjectsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        org_id: string;
    };
    query?: {
        /**
         * Filter memberships by archived (`true`) / non-archived (`false`) resources (default: non-archived / `false`)
         */
        archived?: boolean;
    };
    url: '/organizations/{org_id}/projects';
};

export type ListOrganizationProjectsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListOrganizationProjectsError = ListOrganizationProjectsErrors[keyof ListOrganizationProjectsErrors];

export type ListOrganizationProjectsResponses = {
    /**
     * List of organization projects
     */
    200: Array<Project>;
};

export type ListOrganizationProjectsResponse = ListOrganizationProjectsResponses[keyof ListOrganizationProjectsResponses];

export type CreateOrganizationProjectData = {
    body: ProjectCreate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/projects';
};

export type CreateOrganizationProjectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type CreateOrganizationProjectError = CreateOrganizationProjectErrors[keyof CreateOrganizationProjectErrors];

export type CreateOrganizationProjectResponses = {
    /**
     * Project created
     */
    201: Project;
};

export type CreateOrganizationProjectResponse = CreateOrganizationProjectResponses[keyof CreateOrganizationProjectResponses];

export type ListFsEntriesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: {
        /**
         * Scope to subfolder path
         */
        path?: string;
        /**
         * Filter by StructuredType name
         */
        type?: string;
        /**
         * Filter by file extension
         */
        extension?: string;
        /**
         * Filter by import status
         */
        import_status?: ImportStatus;
    };
    url: '/projects/{proj_id}/content/fs';
};

export type ListFsEntriesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListFsEntriesError = ListFsEntriesErrors[keyof ListFsEntriesErrors];

export type ListFsEntriesResponses = {
    /**
     * File system entry and its contents
     */
    200: FsListResponse;
};

export type ListFsEntriesResponse = ListFsEntriesResponses[keyof ListFsEntriesResponses];

export type GetFsEntryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/fs/{id}';
};

export type GetFsEntryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetFsEntryError = GetFsEntryErrors[keyof GetFsEntryErrors];

export type GetFsEntryResponses = {
    /**
     * File system entry metadata
     */
    200: FsEntry;
};

export type GetFsEntryResponse = GetFsEntryResponses[keyof GetFsEntryResponses];

export type GetFsEntryContentData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/fs/{id}/content';
};

export type GetFsEntryContentErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetFsEntryContentError = GetFsEntryContentErrors[keyof GetFsEntryContentErrors];

export type GetFsEntryByPathData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
        /**
         * File path encoded as a single (percent-encoded) URL path segment.
         */
        path: string;
    };
    query?: never;
    url: '/projects/{proj_id}/content/fs-by-path/{path}';
};

export type GetFsEntryByPathErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetFsEntryByPathError = GetFsEntryByPathErrors[keyof GetFsEntryByPathErrors];

export type GetFsEntryByPathResponses = {
    /**
     * File system entry metadata
     */
    200: FsEntry;
};

export type GetFsEntryByPathResponse = GetFsEntryByPathResponses[keyof GetFsEntryByPathResponses];

export type GetFsEntryContentByPathData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
        /**
         * File path encoded as a single (percent-encoded) URL path segment.
         */
        path: string;
    };
    query?: never;
    url: '/projects/{proj_id}/content/fs-by-path/{path}/content';
};

export type GetFsEntryContentByPathErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetFsEntryContentByPathError = GetFsEntryContentByPathErrors[keyof GetFsEntryContentByPathErrors];

export type ListProblemsData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: {
        severity?: ProblemSeverity;
        /**
         * Filter to problems anchored to this file (matches `Problem.source.id`).
         */
        file_id?: string;
    };
    url: '/projects/{proj_id}/problems';
};

export type ListProblemsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProblemsError = ListProblemsErrors[keyof ListProblemsErrors];

export type ListProblemsResponses = {
    /**
     * List of problems
     */
    200: ProblemsResponse;
};

export type ListProblemsResponse = ListProblemsResponses[keyof ListProblemsResponses];

export type RefreshContentTreeData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: {
        /**
         * Scope to a subtree. Defaults to "/".
         *
         */
        path?: string;
    };
    url: '/projects/{proj_id}/content/tree/actions/refresh';
};

export type RefreshContentTreeErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RefreshContentTreeError = RefreshContentTreeErrors[keyof RefreshContentTreeErrors];

export type RefreshContentTreeResponses = {
    /**
     * Tree refresh triggered
     */
    202: unknown;
};

export type ReimportContentPathData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: {
        /**
         * Scope to a subtree. Defaults to "/".
         *
         */
        path?: string;
    };
    url: '/projects/{proj_id}/content/actions/reimport';
};

export type ReimportContentPathErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ReimportContentPathError = ReimportContentPathErrors[keyof ReimportContentPathErrors];

export type ReimportContentPathResponses = {
    /**
     * Reimport triggered
     */
    202: unknown;
};

export type GetContentTreeData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
    };
    query?: {
        /**
         * Scope to a subtree. Returns the specified node and all its descendants.
         * Example: "/Rooms" returns the Rooms folder and all files within it.
         *
         */
        path?: string;
        /**
         * Deprecated: use `relative_depth` instead. Identical semantics; this parameter will be removed in a future version.
         * Limit tree depth. Depth is relative to the root (or path parameter).
         * - depth=0: Only root nodes
         * - depth=1: Root + immediate children
         * - null: Unlimited (default)
         *
         *
         * @deprecated
         */
        depth?: number;
        /**
         * Limit tree depth, relative to the root (or path parameter). Supersedes the deprecated `depth` parameter; if both are given, relative_depth takes precedence.
         * - relative_depth=0: Only root nodes
         * - relative_depth=1: Root + immediate children
         * - null: Unlimited (default)
         *
         */
        relative_depth?: number;
        /**
         * Filter by MIME type (e.g., "application/vnd.dreamstudio.value.room+yaml").
         * Returns matching files and their ancestor folders.
         *
         */
        type?: string;
    };
    url: '/projects/{proj_id}/content/tree';
};

export type GetContentTreeErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetContentTreeError = GetContentTreeErrors[keyof GetContentTreeErrors];

export type GetContentTreeResponses = {
    /**
     * Flat array of tree nodes
     */
    200: ContentTreeResponse;
};

export type GetContentTreeResponse = GetContentTreeResponses[keyof GetContentTreeResponses];

export type GetStructuredTypeInfoInProjectData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
        type_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/structured-types/{type_id}';
};

export type GetStructuredTypeInfoInProjectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetStructuredTypeInfoInProjectError = GetStructuredTypeInfoInProjectErrors[keyof GetStructuredTypeInfoInProjectErrors];

export type GetStructuredTypeInfoInProjectResponses = {
    /**
     * Structured type metadata
     */
    200: StructuredTypeInfo;
};

export type GetStructuredTypeInfoInProjectResponse = GetStructuredTypeInfoInProjectResponses[keyof GetStructuredTypeInfoInProjectResponses];

export type GetStructuredTypeSchemaInProjectData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
        type_id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/structured-types/{type_id}/schema';
};

export type GetStructuredTypeSchemaInProjectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetStructuredTypeSchemaInProjectError = GetStructuredTypeSchemaInProjectErrors[keyof GetStructuredTypeSchemaInProjectErrors];

export type GetStructuredTypeSchemaInProjectResponses = {
    /**
     * Raw schema definition
     */
    200: {
        [key: string]: unknown;
    };
};

export type GetStructuredTypeSchemaInProjectResponse = GetStructuredTypeSchemaInProjectResponses[keyof GetStructuredTypeSchemaInProjectResponses];

export type GetStructuredValueInfoInProjectData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
        id: string;
    };
    query?: {
        /**
         * Include resolved references (default false)
         */
        resolve_refs?: boolean;
        /**
         * Include validation results (default false)
         */
        validate?: boolean;
        /**
         * Include file metadata (default true)
         */
        metadata?: boolean;
    };
    url: '/projects/{proj_id}/structured-values/{id}';
};

export type GetStructuredValueInfoInProjectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetStructuredValueInfoInProjectError = GetStructuredValueInfoInProjectErrors[keyof GetStructuredValueInfoInProjectErrors];

export type GetStructuredValueInfoInProjectResponses = {
    /**
     * Structured value with enhancements
     */
    200: StructuredValueInfo;
};

export type GetStructuredValueInfoInProjectResponse = GetStructuredValueInfoInProjectResponses[keyof GetStructuredValueInfoInProjectResponses];

export type RedirectStructuredValueTypeInProjectData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
        id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/structured-values/{id}/type';
};

export type RedirectStructuredValueTypeInProjectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectStructuredValueTypeInProjectError = RedirectStructuredValueTypeInProjectErrors[keyof RedirectStructuredValueTypeInProjectErrors];

export type RedirectStructuredValueTypeSchemaInProjectData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
        id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/structured-values/{id}/type/schema';
};

export type RedirectStructuredValueTypeSchemaInProjectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectStructuredValueTypeSchemaInProjectError = RedirectStructuredValueTypeSchemaInProjectErrors[keyof RedirectStructuredValueTypeSchemaInProjectErrors];

export type BuildStructuredValueInProjectData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        proj_id: string;
        id: string;
    };
    query?: never;
    url: '/projects/{proj_id}/structured-values/{id}/actions/build';
};

export type BuildStructuredValueInProjectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BuildStructuredValueInProjectError = BuildStructuredValueInProjectErrors[keyof BuildStructuredValueInProjectErrors];

export type BuildStructuredValueInProjectResponses = {
    /**
     * Bundle created
     */
    201: BuildResult;
};

export type BuildStructuredValueInProjectResponse = BuildStructuredValueInProjectResponses[keyof BuildStructuredValueInProjectResponses];

export type GetStructuredTypeInfoInEditSessionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        type_id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/structured-types/{type_id}';
};

export type GetStructuredTypeInfoInEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetStructuredTypeInfoInEditSessionError = GetStructuredTypeInfoInEditSessionErrors[keyof GetStructuredTypeInfoInEditSessionErrors];

export type GetStructuredTypeInfoInEditSessionResponses = {
    /**
     * Structured type metadata
     */
    200: StructuredTypeInfo;
};

export type GetStructuredTypeInfoInEditSessionResponse = GetStructuredTypeInfoInEditSessionResponses[keyof GetStructuredTypeInfoInEditSessionResponses];

export type GetStructuredTypeSchemaInEditSessionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        type_id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/structured-types/{type_id}/schema';
};

export type GetStructuredTypeSchemaInEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetStructuredTypeSchemaInEditSessionError = GetStructuredTypeSchemaInEditSessionErrors[keyof GetStructuredTypeSchemaInEditSessionErrors];

export type GetStructuredTypeSchemaInEditSessionResponses = {
    /**
     * Raw schema definition
     */
    200: {
        [key: string]: unknown;
    };
};

export type GetStructuredTypeSchemaInEditSessionResponse = GetStructuredTypeSchemaInEditSessionResponses[keyof GetStructuredTypeSchemaInEditSessionResponses];

export type GetStructuredValueInfoInEditSessionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
        /**
         * Include resolved references (default false)
         */
        resolve_refs?: boolean;
        /**
         * Include validation results (default false)
         */
        validate?: boolean;
        /**
         * Include file metadata (default true)
         */
        metadata?: boolean;
    };
    url: '/edit-sessions/{es_id}/structured-values/{id}';
};

export type GetStructuredValueInfoInEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetStructuredValueInfoInEditSessionError = GetStructuredValueInfoInEditSessionErrors[keyof GetStructuredValueInfoInEditSessionErrors];

export type GetStructuredValueInfoInEditSessionResponses = {
    /**
     * Structured value with enhancements
     */
    200: StructuredValueInfo;
};

export type GetStructuredValueInfoInEditSessionResponse = GetStructuredValueInfoInEditSessionResponses[keyof GetStructuredValueInfoInEditSessionResponses];

export type RedirectStructuredValueTypeInEditSessionData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/structured-values/{id}/type';
};

export type RedirectStructuredValueTypeInEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectStructuredValueTypeInEditSessionError = RedirectStructuredValueTypeInEditSessionErrors[keyof RedirectStructuredValueTypeInEditSessionErrors];

export type RedirectStructuredValueTypeSchemaInEditSessionData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/structured-values/{id}/type/schema';
};

export type RedirectStructuredValueTypeSchemaInEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectStructuredValueTypeSchemaInEditSessionError = RedirectStructuredValueTypeSchemaInEditSessionErrors[keyof RedirectStructuredValueTypeSchemaInEditSessionErrors];

export type BuildStructuredValueInEditSessionData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-sessions/{es_id}/structured-values/{id}/actions/build';
};

export type BuildStructuredValueInEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BuildStructuredValueInEditSessionError = BuildStructuredValueInEditSessionErrors[keyof BuildStructuredValueInEditSessionErrors];

export type BuildStructuredValueInEditSessionResponses = {
    /**
     * Bundle created
     */
    201: BuildResult;
};

export type BuildStructuredValueInEditSessionResponse = BuildStructuredValueInEditSessionResponses[keyof BuildStructuredValueInEditSessionResponses];

export type GetStructuredTypeInfoInEditThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        type_id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-threads/{thread_id}/structured-types/{type_id}';
};

export type GetStructuredTypeInfoInEditThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetStructuredTypeInfoInEditThreadError = GetStructuredTypeInfoInEditThreadErrors[keyof GetStructuredTypeInfoInEditThreadErrors];

export type GetStructuredTypeInfoInEditThreadResponses = {
    /**
     * Structured type metadata
     */
    200: StructuredTypeInfo;
};

export type GetStructuredTypeInfoInEditThreadResponse = GetStructuredTypeInfoInEditThreadResponses[keyof GetStructuredTypeInfoInEditThreadResponses];

export type GetStructuredTypeSchemaInEditThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        type_id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-threads/{thread_id}/structured-types/{type_id}/schema';
};

export type GetStructuredTypeSchemaInEditThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetStructuredTypeSchemaInEditThreadError = GetStructuredTypeSchemaInEditThreadErrors[keyof GetStructuredTypeSchemaInEditThreadErrors];

export type GetStructuredTypeSchemaInEditThreadResponses = {
    /**
     * Raw schema definition
     */
    200: {
        [key: string]: unknown;
    };
};

export type GetStructuredTypeSchemaInEditThreadResponse = GetStructuredTypeSchemaInEditThreadResponses[keyof GetStructuredTypeSchemaInEditThreadResponses];

export type GetStructuredValueInfoInEditThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
        /**
         * Include resolved references (default false)
         */
        resolve_refs?: boolean;
        /**
         * Include validation results (default false)
         */
        validate?: boolean;
        /**
         * Include file metadata (default true)
         */
        metadata?: boolean;
    };
    url: '/edit-threads/{thread_id}/structured-values/{id}';
};

export type GetStructuredValueInfoInEditThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetStructuredValueInfoInEditThreadError = GetStructuredValueInfoInEditThreadErrors[keyof GetStructuredValueInfoInEditThreadErrors];

export type GetStructuredValueInfoInEditThreadResponses = {
    /**
     * Structured value with enhancements
     */
    200: StructuredValueInfo;
};

export type GetStructuredValueInfoInEditThreadResponse = GetStructuredValueInfoInEditThreadResponses[keyof GetStructuredValueInfoInEditThreadResponses];

export type RedirectStructuredValueTypeInEditThreadData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-threads/{thread_id}/structured-values/{id}/type';
};

export type RedirectStructuredValueTypeInEditThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectStructuredValueTypeInEditThreadError = RedirectStructuredValueTypeInEditThreadErrors[keyof RedirectStructuredValueTypeInEditThreadErrors];

export type RedirectStructuredValueTypeSchemaInEditThreadData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-threads/{thread_id}/structured-values/{id}/type/schema';
};

export type RedirectStructuredValueTypeSchemaInEditThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectStructuredValueTypeSchemaInEditThreadError = RedirectStructuredValueTypeSchemaInEditThreadErrors[keyof RedirectStructuredValueTypeSchemaInEditThreadErrors];

export type BuildStructuredValueInEditThreadData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: never;
    url: '/edit-threads/{thread_id}/structured-values/{id}/actions/build';
};

export type BuildStructuredValueInEditThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type BuildStructuredValueInEditThreadError = BuildStructuredValueInEditThreadErrors[keyof BuildStructuredValueInEditThreadErrors];

export type BuildStructuredValueInEditThreadResponses = {
    /**
     * Bundle created
     */
    201: BuildResult;
};

export type BuildStructuredValueInEditThreadResponse = BuildStructuredValueInEditThreadResponses[keyof BuildStructuredValueInEditThreadResponses];

export type GetStructuredValueEditorSchemaInEditSessionData = {
    body?: {
        /**
         * The structured value content to use for enum population. If omitted, the current file content will be fetched automatically.
         */
        value?: {
            [key: string]: unknown;
        };
        path?: SubvaluePath;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        es_id: string;
        id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-sessions/{es_id}/structured-values/{id}/actions/schema-for-editor';
};

export type GetStructuredValueEditorSchemaInEditSessionErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetStructuredValueEditorSchemaInEditSessionError = GetStructuredValueEditorSchemaInEditSessionErrors[keyof GetStructuredValueEditorSchemaInEditSessionErrors];

export type GetStructuredValueEditorSchemaInEditSessionResponses = {
    /**
     * JSON Schema optimized for form editors
     */
    200: SchemaForEditorResponse;
};

export type GetStructuredValueEditorSchemaInEditSessionResponse = GetStructuredValueEditorSchemaInEditSessionResponses[keyof GetStructuredValueEditorSchemaInEditSessionResponses];

export type GetStructuredValueEditorSchemaInEditThreadData = {
    body?: {
        /**
         * The structured value content to use for enum population. If omitted, the current file content will be fetched automatically.
         */
        value?: {
            [key: string]: unknown;
        };
        path?: SubvaluePath;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        thread_id: string;
        id: string;
    };
    query?: {
        /**
         * Historical version selector. Full canonical IDs and unambiguous short IDs are accepted.
         * Empty, malformed, ambiguous, invisible, or unreachable versions are rejected by the domain resolver.
         *
         */
        version_id?: string;
    };
    url: '/edit-threads/{thread_id}/structured-values/{id}/actions/schema-for-editor';
};

export type GetStructuredValueEditorSchemaInEditThreadErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetStructuredValueEditorSchemaInEditThreadError = GetStructuredValueEditorSchemaInEditThreadErrors[keyof GetStructuredValueEditorSchemaInEditThreadErrors];

export type GetStructuredValueEditorSchemaInEditThreadResponses = {
    /**
     * JSON Schema optimized for form editors
     */
    200: SchemaForEditorResponse;
};

export type GetStructuredValueEditorSchemaInEditThreadResponse = GetStructuredValueEditorSchemaInEditThreadResponses[keyof GetStructuredValueEditorSchemaInEditThreadResponses];

export type ListProjectTemplatesData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/project-templates';
};

export type ListProjectTemplatesErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListProjectTemplatesError = ListProjectTemplatesErrors[keyof ListProjectTemplatesErrors];

export type ListProjectTemplatesResponses = {
    /**
     * Templates grouped by owning organization
     */
    200: Array<ProjectTemplateGroup>;
};

export type ListProjectTemplatesResponse = ListProjectTemplatesResponses[keyof ListProjectTemplatesResponses];

export type SeedOrgProjectsData = {
    body?: ProjectTemplateSeedRequest;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        org_id: string;
    };
    query?: never;
    url: '/organizations/{org_id}/actions/seed-projects';
};

export type SeedOrgProjectsErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type SeedOrgProjectsError = SeedOrgProjectsErrors[keyof SeedOrgProjectsErrors];

export type SeedOrgProjectsResponses = {
    /**
     * Seeding triggered successfully
     */
    204: void;
};

export type SeedOrgProjectsResponse = SeedOrgProjectsResponses[keyof SeedOrgProjectsResponses];

export type GetProjectTemplateData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        template_id: string;
    };
    query?: never;
    url: '/project-templates/{template_id}';
};

export type GetProjectTemplateErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetProjectTemplateError = GetProjectTemplateErrors[keyof GetProjectTemplateErrors];

export type GetProjectTemplateResponses = {
    /**
     * Project template details
     */
    200: ProjectTemplate;
};

export type GetProjectTemplateResponse = GetProjectTemplateResponses[keyof GetProjectTemplateResponses];

export type GetServiceAccountRedirectData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/service-account';
};

export type GetServiceAccountRedirectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetServiceAccountRedirectError = GetServiceAccountRedirectErrors[keyof GetServiceAccountRedirectErrors];

export type GetServiceAccountByIdData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        service_account_id: string;
    };
    query?: never;
    url: '/service-accounts/{service_account_id}';
};

export type GetServiceAccountByIdErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Missing or invalid service credential
     */
    401: unknown;
    /**
     * Service account cannot access another service account
     */
    403: unknown;
    /**
     * Service account not found
     */
    404: unknown;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetServiceAccountByIdError = GetServiceAccountByIdErrors[keyof GetServiceAccountByIdErrors];

export type GetServiceAccountByIdResponses = {
    /**
     * Service account details
     */
    200: ServiceAccount;
};

export type GetServiceAccountByIdResponse = GetServiceAccountByIdResponses[keyof GetServiceAccountByIdResponses];

export type ReportUsageRecordsData = {
    body: Array<UsageReportRecord>;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/usage/records';
};

export type ReportUsageRecordsErrors = {
    /**
     * Invalid request
     */
    400: Error;
    /**
     * Missing or invalid service credentials
     */
    401: Error;
    /**
     * Caller is not authorized for service authentication
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Batch request failed validation
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ReportUsageRecordsError = ReportUsageRecordsErrors[keyof ReportUsageRecordsErrors];

export type ReportUsageRecordsResponses = {
    /**
     * Per-record capture outcomes
     */
    200: Array<UsageReportResult>;
};

export type ReportUsageRecordsResponse = ReportUsageRecordsResponses[keyof ReportUsageRecordsResponses];

export type GetUserUsageCreditsAvailableData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Incurring user whose captured usage is requested.
         */
        user_id: string;
    };
    query?: {
        /**
         * The project the usage is for. Its organization pays when the user is an active member
         * and the organization has billing; otherwise, and without a project, the user pays.
         *
         */
        project_id?: string;
    };
    url: '/users/{user_id}/usage/credits-available';
};

export type GetUserUsageCreditsAvailableErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The payer has no billing set up yet (`kind` `BILLING_NOT_PROVISIONED`); `payer`,
     * `setup_available` and `auto_setup_on_first_use` say who and how.
     *
     */
    402: BillingRefusalError;
    /**
     * The caller may not check this user
     */
    403: Error;
    /**
     * The project does not exist
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * The balance could not be read (`kind` `BILLING_PROVIDER_UNAVAILABLE`). Transient: retry
     * with backoff.
     *
     */
    503: Error;
};

export type GetUserUsageCreditsAvailableError = GetUserUsageCreditsAvailableErrors[keyof GetUserUsageCreditsAvailableErrors];

export type GetUserUsageCreditsAvailableResponses = {
    /**
     * Whether the payer has Dream Bucks left
     */
    200: UsageCreditsAvailable;
};

export type GetUserUsageCreditsAvailableResponse = GetUserUsageCreditsAvailableResponses[keyof GetUserUsageCreditsAvailableResponses];

export type AuthorizeUserUsageData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Incurring user whose captured usage is requested.
         */
        user_id: string;
    };
    query?: {
        /**
         * The project the usage is for. Its organization pays when the user is an active member
         * and the organization has billing; otherwise, and without a project, the user pays.
         *
         */
        project_id?: string;
    };
    url: '/users/{user_id}/usage/credits-available';
};

export type AuthorizeUserUsageErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * The payer has no billing set up and none was set up now (`kind`
     * `BILLING_NOT_PROVISIONED`); `payer` and `setup_available` say who and how.
     *
     */
    402: BillingRefusalError;
    /**
     * The caller may not authorize this user
     */
    403: Error;
    /**
     * The project does not exist
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * The balance could not be read, or setup could not finish (`kind`
     * `BILLING_PROVIDER_UNAVAILABLE`). Transient: retry with backoff; a setup cut short
     * resumes.
     *
     */
    503: Error;
};

export type AuthorizeUserUsageError = AuthorizeUserUsageErrors[keyof AuthorizeUserUsageErrors];

export type AuthorizeUserUsageResponses = {
    /**
     * Whether the payer has Dream Bucks left
     */
    200: UsageCreditsAvailable;
};

export type AuthorizeUserUsageResponse = AuthorizeUserUsageResponses[keyof AuthorizeUserUsageResponses];

export type GetOrgUsageSummaryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose captured usage is requested.
         */
        org_id: string;
    };
    query?: {
        /**
         * Inclusive lower bound of the usage range as Unix seconds, with optional subsecond
         * precision. Supply with `to_ts`; omit both for the current UTC calendar
         * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
         * request; omit when using `cursor`.
         *
         */
        from_ts?: number;
        /**
         * Exclusive upper bound of the usage range as Unix seconds, with optional subsecond
         * precision. Supply with `from_ts`; omit both for the current UTC calendar
         * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
         * request; omit when using `cursor`.
         *
         */
        to_ts?: number;
    };
    url: '/organizations/{org_id}/usage/summary';
};

export type GetOrgUsageSummaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Dream Bucks cannot be computed for this range. `kind` is `BILLING_DISABLED` when the
     * server runs with billing (Metronome) off, or `BILLING_NOT_PROVISIONED` when usage in
     * the range belongs to a payer without a Metronome contract. Show a "usage isn't available"
     * state, not zero and not an error page.
     * With `BILLING_NOT_PROVISIONED`, `payer` names the payer without a contract (not
     * necessarily the requested subject) and `setup_available` says whether self-serve setup
     * can provision it.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Invalid usage range
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Metronome is unreachable and its rates are not cached, so Dream Bucks cannot be computed
     * (`kind` `BILLING_PROVIDER_UNAVAILABLE`). Transient: retry with backoff.
     *
     */
    503: Error;
};

export type GetOrgUsageSummaryError = GetOrgUsageSummaryErrors[keyof GetOrgUsageSummaryErrors];

export type GetOrgUsageSummaryResponses = {
    /**
     * Organization usage summary
     */
    200: OrgUsageSummary;
};

export type GetOrgUsageSummaryResponse = GetOrgUsageSummaryResponses[keyof GetOrgUsageSummaryResponses];

export type ListOrgUsageHistoryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Organization whose captured usage is requested.
         */
        org_id: string;
    };
    query?: {
        /**
         * Maximum number of items to return per page.
         *
         * This parameter is only valid on the initial request. When using `cursor`,
         * the page size is encoded in the cursor and this parameter must be omitted.
         *
         */
        page_size?: number;
        /**
         * Opaque pagination cursor from a previous response (`previous_cursor` or `next_cursor`).
         *
         * **Usage Pattern:**
         * - First request: Omit `cursor`, provide `page_size` and any filters
         * - Subsequent requests: Provide only `cursor`, omit all other parameters
         *
         * The cursor encodes all request state (filters, page_size, position), so when
         * using a cursor, do not include any other parameters. Providing `cursor` with
         * `page_size`, `around`, or any filter returns `422 Unprocessable Entity`.
         *
         * Cursors are opaque strings - do not parse or construct them. They may expire
         * after extended periods; start fresh pagination for new sessions.
         *
         */
        cursor?: string;
        /**
         * Inclusive lower bound of the usage range as Unix seconds, with optional subsecond
         * precision. Supply with `to_ts`; omit both for the current UTC calendar
         * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
         * request; omit when using `cursor`.
         *
         */
        from_ts?: number;
        /**
         * Exclusive upper bound of the usage range as Unix seconds, with optional subsecond
         * precision. Supply with `from_ts`; omit both for the current UTC calendar
         * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
         * request; omit when using `cursor`.
         *
         */
        to_ts?: number;
        /**
         * UTC-aligned history bucket width. Valid only on an initial request; omit when
         * using `cursor`, which carries the original granularity.
         *
         */
        granularity?: 'hour' | 'day';
    };
    url: '/organizations/{org_id}/usage/history';
};

export type ListOrgUsageHistoryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Dream Bucks cannot be computed for this range. `kind` is `BILLING_DISABLED` when the
     * server runs with billing (Metronome) off, or `BILLING_NOT_PROVISIONED` when usage in
     * the range belongs to a payer without a Metronome contract. Show a "usage isn't available"
     * state, not zero and not an error page.
     * With `BILLING_NOT_PROVISIONED`, `payer` names the payer without a contract (not
     * necessarily the requested subject) and `setup_available` says whether self-serve setup
     * can provision it.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Invalid range or cursor parameter combination
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Metronome is unreachable and its rates are not cached, so Dream Bucks cannot be computed
     * (`kind` `BILLING_PROVIDER_UNAVAILABLE`). Transient: retry with backoff.
     *
     */
    503: Error;
};

export type ListOrgUsageHistoryError = ListOrgUsageHistoryErrors[keyof ListOrgUsageHistoryErrors];

export type ListOrgUsageHistoryResponses = {
    /**
     * Paginated organization usage history
     */
    200: UsageHistoryResponse;
};

export type ListOrgUsageHistoryResponse = ListOrgUsageHistoryResponses[keyof ListOrgUsageHistoryResponses];

export type GetProjectUsageSummaryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Project whose captured usage is requested.
         */
        proj_id: string;
    };
    query?: {
        /**
         * Inclusive lower bound of the usage range as Unix seconds, with optional subsecond
         * precision. Supply with `to_ts`; omit both for the current UTC calendar
         * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
         * request; omit when using `cursor`.
         *
         */
        from_ts?: number;
        /**
         * Exclusive upper bound of the usage range as Unix seconds, with optional subsecond
         * precision. Supply with `from_ts`; omit both for the current UTC calendar
         * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
         * request; omit when using `cursor`.
         *
         */
        to_ts?: number;
    };
    url: '/projects/{proj_id}/usage/summary';
};

export type GetProjectUsageSummaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Dream Bucks cannot be computed for this range. `kind` is `BILLING_DISABLED` when the
     * server runs with billing (Metronome) off, or `BILLING_NOT_PROVISIONED` when usage in
     * the range belongs to a payer without a Metronome contract. Show a "usage isn't available"
     * state, not zero and not an error page.
     * With `BILLING_NOT_PROVISIONED`, `payer` names the payer without a contract (not
     * necessarily the requested subject) and `setup_available` says whether self-serve setup
     * can provision it.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Invalid usage range
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Metronome is unreachable and its rates are not cached, so Dream Bucks cannot be computed
     * (`kind` `BILLING_PROVIDER_UNAVAILABLE`). Transient: retry with backoff.
     *
     */
    503: Error;
};

export type GetProjectUsageSummaryError = GetProjectUsageSummaryErrors[keyof GetProjectUsageSummaryErrors];

export type GetProjectUsageSummaryResponses = {
    /**
     * Project usage summary
     */
    200: ProjectUsageSummary;
};

export type GetProjectUsageSummaryResponse = GetProjectUsageSummaryResponses[keyof GetProjectUsageSummaryResponses];

export type ListProjectUsageHistoryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Project whose captured usage is requested.
         */
        proj_id: string;
    };
    query?: {
        /**
         * Maximum number of items to return per page.
         *
         * This parameter is only valid on the initial request. When using `cursor`,
         * the page size is encoded in the cursor and this parameter must be omitted.
         *
         */
        page_size?: number;
        /**
         * Opaque pagination cursor from a previous response (`previous_cursor` or `next_cursor`).
         *
         * **Usage Pattern:**
         * - First request: Omit `cursor`, provide `page_size` and any filters
         * - Subsequent requests: Provide only `cursor`, omit all other parameters
         *
         * The cursor encodes all request state (filters, page_size, position), so when
         * using a cursor, do not include any other parameters. Providing `cursor` with
         * `page_size`, `around`, or any filter returns `422 Unprocessable Entity`.
         *
         * Cursors are opaque strings - do not parse or construct them. They may expire
         * after extended periods; start fresh pagination for new sessions.
         *
         */
        cursor?: string;
        /**
         * Inclusive lower bound of the usage range as Unix seconds, with optional subsecond
         * precision. Supply with `to_ts`; omit both for the current UTC calendar
         * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
         * request; omit when using `cursor`.
         *
         */
        from_ts?: number;
        /**
         * Exclusive upper bound of the usage range as Unix seconds, with optional subsecond
         * precision. Supply with `from_ts`; omit both for the current UTC calendar
         * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
         * request; omit when using `cursor`.
         *
         */
        to_ts?: number;
        /**
         * UTC-aligned history bucket width. Valid only on an initial request; omit when
         * using `cursor`, which carries the original granularity.
         *
         */
        granularity?: 'hour' | 'day';
    };
    url: '/projects/{proj_id}/usage/history';
};

export type ListProjectUsageHistoryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Dream Bucks cannot be computed for this range. `kind` is `BILLING_DISABLED` when the
     * server runs with billing (Metronome) off, or `BILLING_NOT_PROVISIONED` when usage in
     * the range belongs to a payer without a Metronome contract. Show a "usage isn't available"
     * state, not zero and not an error page.
     * With `BILLING_NOT_PROVISIONED`, `payer` names the payer without a contract (not
     * necessarily the requested subject) and `setup_available` says whether self-serve setup
     * can provision it.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Invalid range or cursor parameter combination
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Metronome is unreachable and its rates are not cached, so Dream Bucks cannot be computed
     * (`kind` `BILLING_PROVIDER_UNAVAILABLE`). Transient: retry with backoff.
     *
     */
    503: Error;
};

export type ListProjectUsageHistoryError = ListProjectUsageHistoryErrors[keyof ListProjectUsageHistoryErrors];

export type ListProjectUsageHistoryResponses = {
    /**
     * Paginated project usage history
     */
    200: UsageHistoryResponse;
};

export type ListProjectUsageHistoryResponse = ListProjectUsageHistoryResponses[keyof ListProjectUsageHistoryResponses];

export type GetChatBranchUsageSummaryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Chat branch whose visible messages' usage is requested.
         */
        branch_id: string;
    };
    query?: never;
    url: '/chat-branches/{branch_id}/usage/summary';
};

export type GetChatBranchUsageSummaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Dream Bucks cannot be computed for this branch: `kind` is `BILLING_NOT_PROVISIONED`
     * because usage in the branch belongs to a payer without a Metronome contract. Show a
     * "usage isn't available" state, not zero and not an error page.
     * `payer` names the payer without a contract (not necessarily the requested subject) and
     * `setup_available` says whether self-serve setup can provision it.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Metronome is unreachable and its rates are not cached, so Dream Bucks cannot be computed
     * (`kind` `BILLING_PROVIDER_UNAVAILABLE`). Transient: retry with backoff.
     *
     */
    503: Error;
};

export type GetChatBranchUsageSummaryError = GetChatBranchUsageSummaryErrors[keyof GetChatBranchUsageSummaryErrors];

export type GetChatBranchUsageSummaryResponses = {
    /**
     * Chat branch usage summary
     */
    200: ChatBranchUsageSummary;
};

export type GetChatBranchUsageSummaryResponse = GetChatBranchUsageSummaryResponses[keyof GetChatBranchUsageSummaryResponses];

export type GetUserUsageSummaryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Incurring user whose captured usage is requested.
         */
        user_id: string;
    };
    query?: {
        /**
         * Inclusive lower bound of the usage range as Unix seconds, with optional subsecond
         * precision. Supply with `to_ts`; omit both for the current UTC calendar
         * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
         * request; omit when using `cursor`.
         *
         */
        from_ts?: number;
        /**
         * Exclusive upper bound of the usage range as Unix seconds, with optional subsecond
         * precision. Supply with `from_ts`; omit both for the current UTC calendar
         * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
         * request; omit when using `cursor`.
         *
         */
        to_ts?: number;
    };
    url: '/users/{user_id}/usage/summary';
};

export type GetUserUsageSummaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Dream Bucks cannot be computed for this range. `kind` is `BILLING_DISABLED` when the
     * server runs with billing (Metronome) off, or `BILLING_NOT_PROVISIONED` when usage in
     * the range belongs to a payer without a Metronome contract. Show a "usage isn't available"
     * state, not zero and not an error page.
     * With `BILLING_NOT_PROVISIONED`, `payer` names the payer without a contract (not
     * necessarily the requested subject) and `setup_available` says whether self-serve setup
     * can provision it.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Invalid usage range
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Metronome is unreachable and its rates are not cached, so Dream Bucks cannot be computed
     * (`kind` `BILLING_PROVIDER_UNAVAILABLE`). Transient: retry with backoff.
     *
     */
    503: Error;
};

export type GetUserUsageSummaryError = GetUserUsageSummaryErrors[keyof GetUserUsageSummaryErrors];

export type GetUserUsageSummaryResponses = {
    /**
     * User usage summary
     */
    200: UsageSummaryBase;
};

export type GetUserUsageSummaryResponse = GetUserUsageSummaryResponses[keyof GetUserUsageSummaryResponses];

export type ListUserUsageHistoryData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Incurring user whose captured usage is requested.
         */
        user_id: string;
    };
    query?: {
        /**
         * Maximum number of items to return per page.
         *
         * This parameter is only valid on the initial request. When using `cursor`,
         * the page size is encoded in the cursor and this parameter must be omitted.
         *
         */
        page_size?: number;
        /**
         * Opaque pagination cursor from a previous response (`previous_cursor` or `next_cursor`).
         *
         * **Usage Pattern:**
         * - First request: Omit `cursor`, provide `page_size` and any filters
         * - Subsequent requests: Provide only `cursor`, omit all other parameters
         *
         * The cursor encodes all request state (filters, page_size, position), so when
         * using a cursor, do not include any other parameters. Providing `cursor` with
         * `page_size`, `around`, or any filter returns `422 Unprocessable Entity`.
         *
         * Cursors are opaque strings - do not parse or construct them. They may expire
         * after extended periods; start fresh pagination for new sessions.
         *
         */
        cursor?: string;
        /**
         * Inclusive lower bound of the usage range as Unix seconds, with optional subsecond
         * precision. Supply with `to_ts`; omit both for the current UTC calendar
         * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
         * request; omit when using `cursor`.
         *
         */
        from_ts?: number;
        /**
         * Exclusive upper bound of the usage range as Unix seconds, with optional subsecond
         * precision. Supply with `from_ts`; omit both for the current UTC calendar
         * month-to-date. Ranges longer than 366 days are rejected. Valid only on an initial
         * request; omit when using `cursor`.
         *
         */
        to_ts?: number;
        /**
         * UTC-aligned history bucket width. Valid only on an initial request; omit when
         * using `cursor`, which carries the original granularity.
         *
         */
        granularity?: 'hour' | 'day';
    };
    url: '/users/{user_id}/usage/history';
};

export type ListUserUsageHistoryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Dream Bucks cannot be computed for this range. `kind` is `BILLING_DISABLED` when the
     * server runs with billing (Metronome) off, or `BILLING_NOT_PROVISIONED` when usage in
     * the range belongs to a payer without a Metronome contract. Show a "usage isn't available"
     * state, not zero and not an error page.
     * With `BILLING_NOT_PROVISIONED`, `payer` names the payer without a contract (not
     * necessarily the requested subject) and `setup_available` says whether self-serve setup
     * can provision it.
     *
     */
    402: BillingRefusalError;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Invalid range or cursor parameter combination
     */
    422: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Metronome is unreachable and its rates are not cached, so Dream Bucks cannot be computed
     * (`kind` `BILLING_PROVIDER_UNAVAILABLE`). Transient: retry with backoff.
     *
     */
    503: Error;
};

export type ListUserUsageHistoryError = ListUserUsageHistoryErrors[keyof ListUserUsageHistoryErrors];

export type ListUserUsageHistoryResponses = {
    /**
     * Paginated user usage history
     */
    200: UsageHistoryResponse;
};

export type ListUserUsageHistoryResponse = ListUserUsageHistoryResponses[keyof ListUserUsageHistoryResponses];

export type RedirectToUserUsageSummaryData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/usage/summary';
};

export type RedirectToUserUsageSummaryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserUsageSummaryError = RedirectToUserUsageSummaryErrors[keyof RedirectToUserUsageSummaryErrors];

export type RedirectToUserUsageHistoryData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/usage/history';
};

export type RedirectToUserUsageHistoryErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserUsageHistoryError = RedirectToUserUsageHistoryErrors[keyof RedirectToUserUsageHistoryErrors];

export type RedirectToUserUsageCreditsAvailableData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: {
        /**
         * The project the usage is for. Its organization pays when the user is an active member
         * and the organization has billing; otherwise, and without a project, the user pays.
         *
         */
        project_id?: string;
    };
    url: '/user/usage/credits-available';
};

export type RedirectToUserUsageCreditsAvailableErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToUserUsageCreditsAvailableError = RedirectToUserUsageCreditsAvailableErrors[keyof RedirectToUserUsageCreditsAvailableErrors];

export type RedirectToAuthorizeUserUsageData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: {
        /**
         * The project the usage is for. Its organization pays when the user is an active member
         * and the organization has billing; otherwise, and without a project, the user pays.
         *
         */
        project_id?: string;
    };
    url: '/user/usage/credits-available';
};

export type RedirectToAuthorizeUserUsageErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type RedirectToAuthorizeUserUsageError = RedirectToAuthorizeUserUsageErrors[keyof RedirectToAuthorizeUserUsageErrors];

export type DeleteUserData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user';
};

export type DeleteUserErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteUserError = DeleteUserErrors[keyof DeleteUserErrors];

export type GetUserRedirectData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user';
};

export type GetUserRedirectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetUserRedirectError = GetUserRedirectErrors[keyof GetUserRedirectErrors];

export type UpdateUserData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user';
};

export type UpdateUserErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateUserError = UpdateUserErrors[keyof UpdateUserErrors];

export type DeleteUserAvatarRedirectData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/avatar';
};

export type DeleteUserAvatarRedirectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteUserAvatarRedirectError = DeleteUserAvatarRedirectErrors[keyof DeleteUserAvatarRedirectErrors];

export type GetUserAvatarRedirectData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/avatar';
};

export type GetUserAvatarRedirectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetUserAvatarRedirectError = GetUserAvatarRedirectErrors[keyof GetUserAvatarRedirectErrors];

export type UploadUserAvatarRedirectData = {
    /**
     * Upload the avatar image providing the 'file' field.
     */
    body: {
        [key: string]: unknown;
    };
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/avatar';
};

export type UploadUserAvatarRedirectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UploadUserAvatarRedirectError = UploadUserAvatarRedirectErrors[keyof UploadUserAvatarRedirectErrors];

export type DeleteUserByIdData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Unique user ID
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}';
};

export type DeleteUserByIdErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteUserByIdError = DeleteUserByIdErrors[keyof DeleteUserByIdErrors];

export type DeleteUserByIdResponses = {
    /**
     * User deleted
     */
    204: void;
};

export type DeleteUserByIdResponse = DeleteUserByIdResponses[keyof DeleteUserByIdResponses];

export type GetUserData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Unique user ID
         */
        user_id: string;
    };
    query?: {
        /**
         * Presence-only flag. When the `private` query parameter is present
         * (with or without a value), returns the caller's own full profile
         * (email, status, timestamps); the caller must be the requested user
         * or the endpoint returns 403. When absent, returns the minimal public
         * profile (id, name, nickname). The value (if any) is ignored.
         *
         */
        private?: string;
    };
    url: '/users/{user_id}';
};

export type GetUserErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetUserError = GetUserErrors[keyof GetUserErrors];

export type GetUserResponses = {
    /**
     * User details
     */
    200: User | PublicUser;
};

export type GetUserResponse = GetUserResponses[keyof GetUserResponses];

export type UpdateUserByIdData = {
    body: UserUpdate;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Unique user ID
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}';
};

export type UpdateUserByIdErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UpdateUserByIdError = UpdateUserByIdErrors[keyof UpdateUserByIdErrors];

export type UpdateUserByIdResponses = {
    /**
     * User updated
     */
    200: User;
};

export type UpdateUserByIdResponse = UpdateUserByIdResponses[keyof UpdateUserByIdResponses];

export type DeleteUserAvatarData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Unique user ID
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/avatar';
};

export type DeleteUserAvatarErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type DeleteUserAvatarError = DeleteUserAvatarErrors[keyof DeleteUserAvatarErrors];

export type DeleteUserAvatarResponses = {
    /**
     * User avatar deleted
     */
    204: void;
};

export type DeleteUserAvatarResponse = DeleteUserAvatarResponses[keyof DeleteUserAvatarResponses];

export type GetUserAvatarData = {
    body?: never;
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Unique user ID
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/avatar';
};

export type GetUserAvatarErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type GetUserAvatarError = GetUserAvatarErrors[keyof GetUserAvatarErrors];

export type UploadUserAvatarData = {
    /**
     * Upload the avatar image providing the 'file' field.
     */
    body: {
        [key: string]: unknown;
    };
    headers?: {
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path: {
        /**
         * Unique user ID
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/avatar';
};

export type UploadUserAvatarErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type UploadUserAvatarError = UploadUserAvatarErrors[keyof UploadUserAvatarErrors];

export type UploadUserAvatarResponses = {
    /**
     * Avatar uploaded and user updated
     */
    200: User;
};

export type UploadUserAvatarResponse = UploadUserAvatarResponses[keyof UploadUserAvatarResponses];

export type ListUserMembershipsRedirectData = {
    body?: never;
    headers?: {
        /**
         * RFC 7239 forwarded metadata from a trusted reverse proxy.
         * Example: for=203.0.113.10;proto=https;host=example.com
         *
         */
        Forwarded?: string;
        /**
         * Original client-facing scheme set by a trusted proxy (for example, `https`).
         */
        'X-Forwarded-Proto'?: string;
        /**
         * Original client-facing host set by a trusted proxy.
         */
        'X-Forwarded-Host'?: string;
        /**
         * Original client-facing port set by a trusted proxy.
         */
        'X-Forwarded-Port'?: string;
        /**
         * Original path prefix preserved by a trusted proxy (for example, `/api` or `/api/v1`).
         */
        'X-Forwarded-Prefix'?: string;
        /**
         * Version of the DreamStudio client, set by the client application.
         * Meant to be used to check current version and prompt users to update if they are on an older version. It accepts:
         * - A compliant semantic version string: `1.2.3`, `1.2.3+metadata`, `1.2.3-prerelease+metadata`. As an exception, it allows the semver to be prefixed with `v` like `v1.2.3`.
         * - A fully formated header: `ver=<semver>`, for example: `ver=1.2.3+a1b2c3d.20260512T184500Z`.
         *
         */
        'X-DS-Version'?: string;
    };
    path?: never;
    query?: {
        /**
         * Filter memberships by archived (`true`) / non-archived (`false`) resources (default: non-archived / `false`)
         */
        archived?: boolean;
    };
    url: '/user/memberships';
};

export type ListUserMembershipsRedirectErrors = {
    /**
     * Bad Request, the input can't be processed
     */
    400: Error;
    /**
     * Unauthorized, authentication is required
     */
    401: Error;
    /**
     * Forbidden, the principal does not have permission to access the resource
     */
    403: Error;
    /**
     * Not Found
     */
    404: Error;
    /**
     * Upgrade Required, the client must upgrade before retrying. Special use case: returned as FRONTEND_UPDATE_REQUIRED when frontend version policy requires an update.
     */
    426: Error;
    /**
     * Service Unavailable, the service is temporarily unable to handle the request. Special use case: returned as VERSION_POLICY_UNAVAILABLE when frontend version policy cannot be loaded.
     */
    503: Error;
};

export type ListUserMembershipsRedirectError = ListUserMembershipsRedirectErrors[keyof ListUserMembershipsRedirectErrors];
